export interface Product {
    id: string;
    title: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        Turkish: string;
        [key: string]: string;
    };
    category: string;
    desc: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        Turkish: string;
        [key: string]: string;
    };
    img: string;
    gallery: string[];
    features: {
        zh: string[];
        en: string[];
        ja: string[];
        Russian: string[];
        Malay: string[];
        Turkish: string[];
        [key: string]: string[];
    };
    certifications: {
        icon: string;
        name: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            Turkish: string;
            [key: string]: string;
        };
    }[];
    specifications: {
        name: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            Turkish: string;
            [key: string]: string;
        };
        value: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            Turkish: string;
            [key: string]: string;
        };
    }[];
    usageExamples: {
        title: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            Turkish: string;
            [key: string]: string;
        };
        desc: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            Turkish: string;
            [key: string]: string;
        };
        img: string;
    }[];
    relatedProducts: string[];
}

export interface Advantage {
    icon: string;
    title: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        Turkish: string;
        [key: string]: string;
    };
    desc: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        Turkish: string;
        [key: string]: string;
    };
}

export interface Application {
    img: string;
    title: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        Turkish: string;
        [key: string]: string;
    };
    desc: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        Turkish: string;
        [key: string]: string;
    };
}

export const tabs : {
    key: string;
    label: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        Turkish: string;
        [key: string]: string;
    };
}[] = [
    { key: 'all', label: { zh: '全部产品', en: 'All Products', ja: '全製品', Russian: 'продукция', Malay: 'Semua Produk', Turkish: 'Tüm Ürünler' } },
    { key: 'pulp', label: { zh: '原生竹浆', en: 'Virgin Bamboo Pulp', ja: 'バージン竹パルプ', Russian: 'Натуральная бамбуковая целлюлозная пульпа', Malay: 'Pulpa Buluh Asli', Turkish: 'Ham Bambu Hamuru' } },
    { key: 'packaging', label: { zh: '原生竹浆包装用纸', en: 'Virgin Bamboo Pulp Packaging Paper', ja: 'バージン竹パルプ包装用紙' , Russian: 'Первичная бамбуковая целлюлозная бумага для упаковки', Malay: 'Kertas Pembungkusan daripada Pulpa Buluh Asli', Turkish: 'Ham Bambu Hamurundan Ambalaj Kağıdı'} },
    { key: 'cultural', label: { zh: '原生竹浆文化用纸', en: 'Virgin Bamboo Pulp Cultural  Paper', ja: 'バージン竹パルプ印刷筆記用紙' , Russian: 'Первичная бамбуковая целлюлозная офисная бумага', Malay: 'Kertas Budaya berasaskan Pulpa Buluh Asli', Turkish: 'Ham Bambu Hamurundan Kültürel Kağıt'} },
    { key: 'rawpaper', label: { zh: '原生竹浆生活原纸', en: 'Virgin Bamboo Pulp Tissue Base Paper', ja: 'バージン竹パルプティッシュ原紙' , Russian: 'Первичная бамбуковая целлюлозная бумага для хозяйственных нужд', Malay: 'Kertas Asas Kegunaan Harian Pulpa Buluh Asli', Turkish: 'Ham Bambu Hamurundan Temel Yaşam Kağıdı'} },
    { key: 'finishedpaper', label: { zh: '原生竹浆生活成品纸', en: 'Virgin Bamboo Pulp Finished Tissue Products', ja: 'バージン竹パルプティッシュ製品', Russian: 'Готовая бумага из первичной бамбуковой пульпы для хозяйственных нужд', Malay: 'Kertas Siap Kegunaan Harian Pulpa Buluh Asli', Turkish: 'Ham Bambu Hamurundan Bitmiş Yaşam Kağıdı' } },
    { key: 'fiber', label: { zh: '纤维材料', en: 'Fiber Materials', ja: '繊維材料', Russian: 'Фибровый материал', Malay: 'Bahan Gentian' , Turkish: 'Lif Malzemesi'} },
];

export const products: Product[] = [
    {
        id: 'pulp-001',
        title: {
            zh: '本色竹浆板',
            en: 'Unbleached Pulp Board',
            ja: '未晒竹パルプボード',
            Russian: 'Бамбуковая пульпная плита в исходном цвете',
            Malay: 'Papan Pulpa Buluh Warna Semula Jadi',
            Turkish: 'Doğal Renkli Bambu Hamuru Levhası'
        },
        category: 'pulp',
        desc: {
            zh: '精选优质竹种、提取最好的竹纤维',
            en: 'Selected Premium Bamboo Species, Extracting the Finest Bamboo Fibers',
            ja: '高品質竹種厳選、最良竹繊維抽出',
            Russian: 'Отбор наилучших сортов бамбука, извлечение целлюлозных волокон высшего качества',
            Malay: 'Pemilihan Spesies Buluh Premium & Pengekstrakan Gentian Terbaik',
            Turkish: 'Seçilmiş Kaliteli Bambu Türlerinden En İyi Bambu Liflerinin Çıkarılması'
        },
        img: '/images/mainProduction/YuanSeZhuJiangSuoLve.png',
        gallery: [
            // '/images/mainProduction/YuanSeZhuJiangSuoLve.png',
            // '/images/mainProduction/YuanSeZhuJiangSuoLve.png',
            // '/images/mainProduction/YuanSeZhuJiangSuoLve.png',
            '/images/mainProduction/YuanSeZhuJiangSuoLve.png'
        ],
        features: {
            zh: [
                '优质竹种',
                '纤维长，宽度粗',
                '综合强度好',
                '环保可降解'
            ],
            en: [
                'Premium Bamboo Species',
                'Long, Coarse Fibers',
                'Good Overall Strength',
                'Eco-Friendly & Biodegradable'
            ],
            ja: [
                '高品質竹種',
                '長繊維、太幅',
                '総合強度良好',
                '環境配慮型・生分解性'
            ],
            Russian: [
                'Высококачественные сорта бамбука',
                'Длинные и толстые волокна',
                'Высокая общая прочность',
                'Экологически безопасный и биоразлагаемый'
            ],
            Malay: [
                'Spesies Buluh Berkualiti Tinggi',
                'Gentian Panjang dan Lebar',
                'Kekuatan Komprehensif yang Baik',
                'Mesra Alam & Boleh Terurai'
            ],
            Turkish: [
                'Kaliteli Bambu Türleri',
                'Uzun Lif, Kalın Genişlik',
                'İyi Kapsamlı Dayanıklılık',
                'Çevre Dostu ve Biyobozunur'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-leaf',
            //     name: {
            //         zh: 'FSC认证',
            //         en: 'FSC Certification',
            //         ja: 'FSC認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '标准规格',
                    en: 'Standard Specification',
                    ja: '標準規格',
                    Russian: 'Стандартные параметры',
                    Malay: 'Spesifikasi Standard',
                    Turkish: 'Standart Özellikler'
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '本色',
                    en: 'Natural Color',
                    ja: '自然色',
                    Russian: 'Исходный цвет',
                    Malay: 'Warna Semula Jadi (tanpa peluntur)',
                    Turkish: 'Doğal Renk'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '造纸原料',
                    en: 'Papermaking Raw Material',
                    ja: '製紙原料',
                    Russian: 'Сырьё для бумажной промышленности',
                    Malay: 'Bahan Mentah Pembuatan Kertas',
                    Turkish: 'Kağıt Yapım Hammaddesi'
                },
                desc: {
                    zh: '卫生纸产品加工领域',
                    en: 'Tissue Product Processing Field',
                    ja: 'ティッシュ製品加工分野',
                    Russian: 'Область производства туалетной бумаги',
                    Malay: 'Bidang Pemprosesan Produk Tisu Kertas',
                    Turkish: 'Hijyenik Kağıt Ürünleri İşleme Alanı'
                },
                img: '/images/ApplicationScenarios/ZaoZhiLingYu.png'
            },
            {
                title: {
                    zh: '纸浆模塑',
                    en: 'Pulp Molding',
                    ja: 'パルプモールド',
                    Russian: 'Формование из бумажной пульпы',
                    Malay: 'Acuan Pulpa',
                    Turkish: 'Hamur Kalıplama'
                },
                desc: {
                    zh: '纸浆模塑产品加工领域',
                    en: 'Pulp Molding Product Processing Field',
                    ja: 'パルプモールド製品加工分野',
                    Russian: 'Область производства изделий из бумажной пульпы',
                    Malay: 'Bidang Pemprosesan Produk Acuan Pulpa',
                    Turkish: 'Hamur Kalıplama Ürünleri İşleme Alanı'
                },
                img: '/images/ApplicationScenarios/ZhiJiangMoSu.png'
            },
            {
                title: {
                    zh: '特种纸加工',
                    en: 'Specialty Paper Processing',
                    ja: '特殊紙加工',
                    Russian: 'Производство специализированной бумаги',
                    Malay: 'Pemprosesan Kertas Khas',
                    Turkish: 'Özel Kağıt İşleme'
                },
                desc: {
                    zh: '特种纸等产品加工领域',
                    en: 'Specialty Paper & Related Product Processing Field',
                    ja: '特殊紙等製品加工分野',
                    Russian: 'Область производства специализированной бумаги и другой продукции',
                    Malay: 'Bidang Pemprosesan Produk Kertas Khas dll.',
                    Turkish: 'Özel Kağıt ve Benzeri Ürünler İşleme Alanı'
                },
                img: '/images/ApplicationScenarios/TeZhongZhiJiaGong.png'
            }
        ],
        relatedProducts: ['pulp-002', 'packaging-001', 'packaging-002']
    },
    {
        id: 'pulp-002',
        title: {
            zh: '漂白竹浆板',
            en: 'Bleached Bamboo Pulp Board',
            ja: '晒竹パルプボード',
            Russian: 'Отбеленная целлюлозная плита из бамбука',
            Malay: 'Papan Pulpa Buluh Pelunturan',
            Turkish: 'Ağartılmış Bambu Hamuru Levhası'
        },
        category: 'pulp',
        desc: {
            zh: '精选优质竹种、提取最好的竹纤维',
            en: 'Selected Premium Bamboo Species, Extracting the Finest Bamboo Fibers',
            ja: '高品質竹種厳選、最良竹繊維抽出',
            Russian: 'Отбор наилучших сортов бамбука, извлечение целлюлозных волокон высшего качества',
            Malay: 'Pemilihan Spesies Buluh Premium & Pengekstrakan Gentian Terbaik',
            Turkish: 'Seçilmiş Kaliteli Bambu Türlerinden En İyi Bambu Liflerinin Çıkarılması'
        },
        img: '/images/mainProduction/BaiSeZhuJiangSuoLve.png',
        gallery: [
            // '/images/mainProduction/BaiSeZhuJiangSuoLve.png',
            // '/images/mainProduction/BaiSeZhuJiangSuoLve.png',
            // '/images/mainProduction/BaiSeZhuJiangSuoLve.png',
            '/images/mainProduction/BaiSeZhuJiangSuoLve.png'
        ],
        features: {
            zh: [
                '优质竹种',
                '纤维长，宽度粗',
                '综合强度好',
                '环保可降解'
            ],
            en: [
                'Premium Bamboo Species',
                'Long, Coarse Fibers',
                'Good Overall Strength',
                'Eco-Friendly & Biodegradable'
            ],
            ja: [
                '高品質竹種',
                '長繊維、太幅',
                '総合強度良好',
                '環境配慮型・生分解性'
            ],
            Russian: [
                'Высококачественные сорта бамбука',
                'Длинные и толстые волокна',
                'Высокая общая прочность',
                'Экологически безопасный и биоразлагаемый'
            ],
            Malay: [
                'Spesies Buluh Berkualiti Tinggi',
                'Gentian Panjang dan Lebar',
                'Kekuatan Komprehensif yang Baik',
                'Mesra Alam & Boleh Terurai'
            ],
            Turkish: [
                'Kaliteli Bambu Türleri',
                'Uzun Lif, Kalın Genişlik',
                'İyi Kapsamlı Dayanıklılık',
                'Çevre Dostu ve Biyobozunur'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-leaf',
            //     name: {
            //         zh: 'FSC认证',
            //         en: 'FSC Certification',
            //         ja: 'FSC認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '标准规格',
                    en: 'Standard Specification',
                    ja: '標準規格',
                    Russian: 'Стандартные параметры',
                    Malay: 'Spesifikasi Standard',
                    Turkish: 'Standart Özellikler'
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih',
                    Turkish: 'Beyaz'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '造纸原料',
                    en: 'Papermaking Raw Material',
                    ja: '製紙原料',
                    Russian: 'Сырьё для бумажной промышленности',
                    Malay: 'Bahan Mentah Pembuatan Kertas',
                    Turkish: 'Kağıt Yapım Hammaddesi'
                },
                desc: {
                    zh: '卫生纸产品加工领域',
                    en: 'Tissue Product Processing Field',
                    ja: 'ティッシュ製品加工分野',
                    Russian: 'Область производства туалетной бумаги',
                    Malay: 'Bidang Pemprosesan Produk Tisu Kertas',
                    Turkish: 'Hijyenik Kağıt Ürünleri İşleme Alanı'
                },
                img: '/images/ApplicationScenarios/ZaoZhiLingYu.png'
            },
            {
                title: {
                    zh: '纸浆模塑',
                    en: 'Pulp Molding',
                    ja: 'パルプモールド',
                    Russian: 'Формование из бумажной пульпы',
                    Malay: 'Acuan Pulpa',
                    Turkish: 'Hamur Kalıplama'
                },
                desc: {
                    zh: '纸浆模塑产品加工领域',
                    en: 'Pulp Molding Product Processing Field',
                    ja: 'パルプモールド製品加工分野',
                    Russian: 'Область производства изделий из бумажной пульпы',
                    Malay: 'Bidang Pemprosesan Produk Acuan Pulpa',
                    Turkish: 'Hamur Kalıplama Ürünleri İşleme Alanı'
                },
                img: '/images/ApplicationScenarios/ZhiJiangMoSu.png'
            },
            {
                title: {
                    zh: '特种纸加工',
                    en: 'Specialty Paper Processing',
                    ja: '特殊紙加工',
                    Russian: 'Производство специализированной бумаги',
                    Malay: 'Pemprosesan Kertas Khas',
                    Turkish: 'Özel Kağıt İşleme'
                },
                desc: {
                    zh: '特种纸等产品加工领域',
                    en: 'Specialty Paper & Related Product Processing Field',
                    ja: '特殊紙等製品加工分野',
                    Russian: 'Область производства специализированной бумаги и другой продукции',
                    Malay: 'Bidang Pemprosesan Produk Kertas Khas dll.',
                    Turkish: 'Özel Kağıt ve Benzeri Ürünler İşleme Alanı'
                },
                img: '/images/ApplicationScenarios/TeZhongZhiJiaGong.png'
            }
        ],
        relatedProducts: ['pulp-001', 'packaging-001', 'packaging-002']
    },
    {
        id: 'packaging-001',
        title: {
            zh: '漂白全竹浆纸',
            en: 'Bleached 100% Bamboo Pulp Paper',
            ja: '全漂白竹パルプ紙',
            Russian: 'Бумага из цельной бамбуковой целлюлозы после отбеливания',
            Malay: 'Kertas Pulpa Buluh Pelunturan Penuh',
            Turkish: 'Tamamen Ağartılmış Bambu Hamuru Kağıdı'
        },
        category: 'packaging',
        desc: {
            zh: '加工产品易成型、得率高、报废少',
            en: 'Easy Forming, High Yield Rate, Low Reject Rate in Processing',
            ja: '加工製品成形容易、高歩留まり、低廃棄率',
            Russian: 'Продукция легко формируется, обладает высоким выходом и низким процентом брака',
            Malay: 'Produk Mudah Dibentuk, Kecekapan Pengeluaran Tinggi, Kadar Sisa Rendah',
            Turkish: 'İşlenmiş Ürünler Kolay Şekillenir, Yüksek Verim, Düşük Fire'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '具有良好的边渗透性能',
                '无异味，符合国家食品安全要求'
            ],
            en: [
                'Fluorescent Whitening Agent Free',
                'Uncoated, Unlaminated, Uniform Thickness',
                'Good Edge Penetration Performance',
                'Odorless, Compliant with National Food Safety Standards'
            ],
            ja: [
                '蛍光増白剤不使用',
                '無塗工、無ラミネート、均一厚',
                '良好なエッジ浸透防止性能',
                '無臭、国家食品安全基準適合'
            ],
            Russian: [
                'Не содержит флуоресцентных отбеливателей',
                'Не лакированная и не покрытая пленкой продукция равномерной толщины',
                'Обладает хорошими характеристиками краевого проникновения.',
                'Без постороннего запаха, соответствует санитарно - эпидемиологическим требованиям к пищевым продуктам.'
            ],
            Malay: [
                'Tiada Agen Pendarfluor',
                'Tiada Salutan/Tiada Laminasi, Ketebalan Seragam',
                'Memiliki Prestasi Penyerapan Tepi yang Baik',
                'Bebas Bau, Mematuhi Keperluan Keselamatan Makanan Negara'
            ],
            Turkish: [
                'Floresan Ağartıcı İçermez',
                'Kaplamasız, Laminatsız, Düzgün Kalınlık',
                'İyi Kenar Nüfuz Özelliği',
                'Kokusuz, Ulusal Gıda Güvenliği Standartlarına Uygun'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'QS Certification',
                    ja: 'QS認証',
                    Russian: 'Сертификация QS (китайская система сертификации безопасности пищевой продукции)',
                    Malay: 'Pensijilan QS',
                    Turkish: 'QS Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '190/320/350 g/㎡',
                    en: '190/320/350 g/㎡',
                    ja: '190/320/350 g/㎡',
                    Russian: '190/320/350 g/㎡',
                    Malay: '190/320/350 g/㎡',
                    Turkish: '190/320/350 g/㎡'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customizable Upon Request',
                    ja: 'ご要望に応じカスタマイズ',
                    Russian: 'Индивидуальный заказ по требованиям',
                    Malay: 'Disesuaikan Mengikut Keperluan',
                    Turkish: 'İhtiyaca Göre Özel Üretim'
                }
            },
            {
                name: {
                    zh: '纯度',
                    en: 'Purity',
                    ja: '純度',
                    Russian: 'Степень чистоты сырья',
                    Malay: 'Ketulenan',
                    Turkish: 'Saflık'
                },
                value: {
                    zh: '100%原生竹浆',
                    en: '100% Vrigin Bamboo Pulp',
                    ja: '100%バージン竹パルプ',
                    Russian: '100% цельная бамбуковая целлюлоза',
                    Malay: '100% Pulpa Buluh Asli',
                    Turkish: '%100 Ham Bambu Hamuru'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '5100元/吨',
            //         en: '¥5100/Ton',
            //         ja: '5100人民元/トン',
            //         Russian: '5100 юаней/т',
            //         Malay: '5100 RMB/tan',
            //         Turkish: '5100 Yuan/Ton'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '纸杯加工',
                    en: 'Paper Cup Processing',
                    ja: '紙コップ加工',
                    Russian: 'Производство бумажных стаканчиков',
                    Malay: 'Pemprosesan Cawan Kertas',
                    Turkish: 'Kağıt Bardak İşleme'
                },
                desc: {
                    zh: '用于各类纸杯生产加工。',
                    en: 'For producing various types of paper cups',
                    ja: '各種紙コップ製造加工用',
                    Russian: 'Для производства различных бумажных стаканчиков',
                    Malay: 'Untuk pengeluaran pelbagai jenis cawan kertas.',
                    Turkish: 'Her türlü kağıt bardak üretimi ve işlemesi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            },
            {
                title: {
                    zh: '纸碗加工',
                    en: 'Paper Bowl Processing',
                    ja: '紙製ボウル加工',
                    Russian: 'Производство бумажных контейнеров (мисок)',
                    Malay: 'Pemprosesan Mangkuk Kertas',
                    Turkish: 'Kağıt Kase İşleme'
                },
                desc: {
                    zh: '用于各类纸碗、纸餐具加工生产。',
                    en: 'For producing various types of paper bowls and disposable tableware',
                    ja: '各種紙製ボウル・紙製食器製造加工用',
                    Russian: 'Для производства бумажных мисок и бумажной посуды',
                    Malay: 'Untuk pengeluaran pelbagai jenis mangkuk kertas dan peralatan makan kertas.',
                    Turkish: 'Her türlü kağıt kase ve kağıt mutfak eşyası üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            },
            {
                title: {
                    zh: '快餐桶加工',
                    en: 'Fast Food Container Processing',
                    ja: 'ファストフード容器加工',
                    Russian: 'Производство фастфуд-контейнеров',
                    Malay: 'Pemprosesan Baldi Makanan Segera',
                    Turkish: 'Fast Food Kutusu İşleme'
                },
                desc: {
                    zh: '用于各类纸桶、纸盒加工生产。',
                    en: 'For producing various types of paper buckets and boxes',
                    ja: '各種紙バケツ・紙箱製造加工用',
                    Russian: 'Для производства бумажных бочонков и коробок',
                    Malay: 'Untuk pengeluaran pelbagai jenis baldi kertas dan kotak kertas.',
                    Turkish: 'Her türlü kağıt kutu ve kağıt kutu üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiTongShengChan.png'
            }
        ],
        relatedProducts: ['packaging-002', 'packaging-003', 'packaging-004']
    },
    {
        id: 'packaging-002',
        title: {
            zh: '高松纸',
            en: 'High Bulk Paper',
            ja: '嵩高紙',
            Russian: 'Бумага с высоким коэффициентом объема',
            Malay: 'Kertas Ketumpatan Tinggi',
            Turkish: 'Yüksek Kabarık Kağıt'
        },
        category: 'packaging',
        desc: {
            zh: '加工产品易成型、得率高、报废少',
            en: 'Easy Forming, High Yield Rate, Low Reject Rate in Processing',
            ja: '加工製品成形容易、高歩留まり、低廃棄率',
            Russian: 'Легко формируется • Высокий выход • Минимальный брак',
            Malay: 'Produk Mudah Dibentuk, Kecekapan Pengeluaran Tinggi, Kadar Sisa Rendah',
            Turkish: 'İşlenmiş ürünler kolay şekillenir, yüksek verim sağlar ve düşük fire oranına sahiptir.'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '具有良好的边渗透性能',
                '超高松厚度、高挺度'
            ],
            en: [
                'Fluorescent Whitening Agent Free',
                'Uncoated, Unlaminated, Uniform Thickness',
                'Good Edge Penetration Performance',
                'Ultra-High Bulk, High Stiffness'
            ],
            ja: [
                '蛍光増白剤不使用',
                '無塗工、無ラミネート、均一厚',
                '良好なエッジ浸透防止性能',
                '超嵩高、高剛性'
            ],
            Russian: [
                'Не содержит флуоресцентных отбеливателей',
                'Не лакированная и не покрытая пленкой продукция равномерной толщины',
                'Обладает хорошими характеристиками краевого проникновения.',
                'Продукция обладает чрезвычайно высоким коэффициентом объема и замечательной жесткостью.'
            ],
            Malay: [
                'Tiada Agen Pendarfluor',
                'Tiada Salutan/Tiada Laminasi, Ketebalan Seragam',
                'Memiliki Prestasi Penyerapan Tepi yang Baik',
                'Ketebalan Super Tinggi & Kekakuan Tinggi'
            ],
            Turkish: [
                'Floresan Ağartıcı İçermez',
                'Kaplamasız, Laminatsız, Düzgün Kalınlık',
                'İyi Kenar Nüfuz Özelliği',
                'Süper Yüksek Kabarıklık, Yüksek Diklik'
            ],
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'QS Certification',
                    ja: 'QS認証',
                    Russian: 'Сертификация QS (китайская система сертификации безопасности пищевой продукции)',
                    Malay: 'Pensijilan QS',
                    Turkish: 'QS Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '国家食品安全要求',
                    en: 'Compliant with National Food Safety Standards',
                    ja: '国家食品安全基準',
                    Russian: 'Продукция соответствует федеральным санитарно-эпидемиологическим требованиям к пищевым продуктам.',
                    Malay: 'Keperluan Keselamatan Makanan Negara',
                    Turkish: 'Ulusal Gıda Güvenliği Gereklilikleri'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '150~300 g/㎡',
                    en: '150~300 g/㎡',
                    ja: '150~300 g/㎡',
                    Russian: '150~300 g/㎡',
                    Malay: '150~300 g/㎡',
                    Turkish: '150~300 g/㎡'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customizable Upon Request',
                    ja: 'ご要望に応じカスタマイズ',
                    Russian: 'Индивидуальный заказ по требованиям',
                    Malay: 'Disesuaikan Mengikut Keperluan',
                    Turkish: 'İhtiyaca Göre Özel Üretim'
                }
            },
            {
                name: {
                    zh: '成分',
                    en: 'Composition',
                    ja: '成分',
                    Russian: 'Ингредиенты',
                    Malay: 'Komposisi',
                    Turkish: 'Bileşen'
                },
                value: {
                    zh: '原生竹浆、原生木浆',
                    en: 'Virgin Bamboo Pulp, Virgin Wood Pulp',
                    ja: 'バージン竹パルプ、バージン木材パルプ',
                    Russian: 'Натуральная бамбуковая целлюлоза',
                    Malay: 'Pulpa Buluh Asli, Pulpa Kayu Asli',
                    Turkish: 'Ham Bambu Hamuru, Ham Odun Hamuru'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '5100元/吨',
            //         en: '¥5100/Ton',
            //         ja: '5100人民元/トン',
            //         Russian: '5100 юаней/т',
            //         Malay: '5100 RMB/tan',
            //         Turkish: '5100 Yuan/Ton'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '纸杯加工',
                    en: 'Paper Cup Processing',
                    ja: '紙コップ加工',
                    Russian: 'Производство бумажных стаканчиков',
                    Malay: 'Pemprosesan Cawan Kertas',
                    Turkish: 'Kağıt Bardak İşleme'
                },
                desc: {
                    zh: '用于各类纸杯生产加工。',
                    en: 'For producing various types of paper cups',
                    ja: '各種紙コップ製造加工用',
                    Russian: 'Для производства различных бумажных стаканчиков',
                    Malay: 'Untuk pengeluaran pelbagai jenis cawan kertas.',
                    Turkish: 'Her türlü kağıt bardak üretimi ve işlemesi için kullanılır'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            },
            {
                title: {
                    zh: '纸碗加工',
                    en: 'Paper Bowl Processing',
                    ja: '紙製ボウル加工',
                    Russian: 'Производство бумажных контейнеров (мисок)',
                    Malay: 'Pemprosesan Mangkuk Kertas',
                    Turkish: 'Kağıt Kase İşleme'
                },
                desc: {
                    zh: '用于各类纸碗、纸餐具加工生产。',
                    en: 'For producing various types of paper bowls and disposable tableware',
                    ja: '各種紙製ボウル・紙製食器製造加工用',
                    Russian: 'Для производства бумажных мисок и бумажной посуды',
                    Malay: 'Untuk pengeluaran pelbagai jenis mangkuk kertas dan peralatan makan kertas.',
                    Turkish: 'Her türlü kağıt kase ve kağıt mutfak eşyası üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            },
            {
                title: {
                    zh: '快餐桶加工',
                    en: 'Fast Food Container Processing',
                    ja: 'ファストフード容器加工',
                    Russian: 'Производство фастфуд-контейнеров',
                    Malay: 'Pemprosesan Baldi Makanan Segera',
                    Turkish: 'Fast Food Kutusu İşleme'
                },
                desc: {
                    zh: '用于各类纸桶、纸盒加工生产。',
                    en: 'For producing various types of paper buckets and boxes',
                    ja: '各種紙バケツ・紙箱製造加工用',
                    Russian: 'Для производства бумажных бочонков и коробок',
                    Malay: 'Untuk pengeluaran pelbagai jenis baldi kertas dan kotak kertas.',
                    Turkish: 'Her türlü kağıt kutu ve kağıt kutu üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiTongShengChan.png'
            }
        ],
        relatedProducts: ['packaging-001', 'packaging-003', 'packaging-004']
    },
    {
        id: 'packaging-003',
        title: {
            zh: '高档中松纸',
            en: 'Premium Medium Bulk Paper',
            ja: '高級中嵩紙',
            Russian: 'Премиальная бумага средней плотности для изысканных решений；Натуральная древесная целлюлоза',
            Malay: 'Kertas Ketumpatan Sederhana Tinggi',
            Turkish: 'Yüksek Kalite Orta Kabarık Kağıt'
        },
        category: 'packaging',
        desc: {
            zh: '加工产品易成型、得率高、报废少',
            en: 'Easy Forming, High Yield Rate, Low Reject Rate in Processing',
            ja: '加工製品成形容易、高歩留まり、低廃棄率',
            Russian: 'Легко формируется • Высокий выход • Минимальный брак',
            Malay: 'Produk Mudah Dibentuk, Kecekapan Pengeluaran Tinggi, Kadar Sisa Rendah',
            Turkish: 'İşlenmiş ürünler kolay şekillenir, yüksek verim sağlar ve düşük fire oranına sahiptir.'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '无异味，具有良好的边渗透性能',
                '高松厚度、高挺度'
            ],
            en: [
                'Fluorescent Whitening Agent Free',
                'Uncoated, Unlaminated, Uniform Thickness',
                'Odorless, Good Edge Penetration Performance',
                'High Bulk, High Stiffness'
            ],
            ja: [
                '蛍光増白剤不使用',
                '無塗工、無ラミネート、均一厚',
                '無臭、良好なエッジ浸透防止性能',
                '嵩高、高剛性'
            ],
            Russian: [
                'Не содержит флуоресцентных отбеливателей',
                'Не лакированная и не покрытая пленкой продукция равномерной толщины',
                'Без постороннего запаха, обладает отличными характеристиками краевого проникновения.',
                'Высокий коэффициент объема и высокая жесткость бумаги'
            ],
            Malay: [
                'Tiada Agen Pendarfluor',
                'Tiada Salutan/Tiada Laminasi, Ketebalan Seragam',
                'Bebas Bau, Penyerapan Tepi yang Baik',
                'Ketebalan Tinggi & Kekakuan Unggul'
            ],
            Turkish: [
                'Floresan Ağartıcı İçermez',
                'Kaplamasız, Laminatsız, Düzgün Kalınlık',
                'Kokusuzdur ve mükemmel kenar penetrasyon özelliğine sahiptir.',
                'Yüksek Kabarıklık ve Yüksek Diklik'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'QS Certification',
                    ja: 'QS認証',
                    Russian: 'Сертификация QS (китайская система сертификации безопасности пищевой продукции)',
                    Malay: 'Pensijilan QS',
                    Turkish: 'QS Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '150~350 g/㎡',
                    en: '150~350 g/㎡',
                    ja: '150~350 g/㎡',
                    Russian: '150~350 g/㎡',
                    Malay: '150~350 g/㎡',
                    Turkish: '150~350 g/㎡'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customizable Upon Request',
                    ja: 'ご要望に応じカスタマイズ',
                    Russian: 'Индивидуальный заказ по требованиям',
                    Malay: 'Disesuaikan Mengikut Keperluan',
                    Turkish: 'İhtiyaca Göre Özel Üretim'
                }
            },
            {
                name: {
                    zh: '成分',
                    en: 'Composition',
                    ja: '成分',
                    Russian: 'Ингредиенты',
                    Malay: 'Komposisi',
                    Turkish: 'Bileşen'
                },
                value: {
                    zh: '原生竹浆、原生木浆',
                    en: 'Virgin Bamboo Pulp, Virgin Wood Pulp',
                    ja: 'バージン竹パルプ、バージン木材パルプ',
                    Russian: 'Натуральная бамбуковая целлюлоза',
                    Malay: 'Pulpa Buluh Asli, Pulpa Kayu Asli',
                    Turkish: 'Ham Bambu Hamuru, Ham Odun Hamuru'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '5100元/吨',
            //         en: '¥5100/Ton',
            //         ja: '5100人民元/トン',
            //         Russian: '5100 юаней/т',
            //         Malay: '5100 RMB/tan',
            //         Turkish: '5100 Yuan/Ton'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '纸杯加工',
                    en: 'Paper Cup Processing',
                    ja: '紙コップ加工',
                    Russian: 'Производство бумажных стаканчиков',
                    Malay: 'Pemprosesan Cawan Kertas',
                    Turkish: 'Kağıt Bardak İşleme'
                },
                desc: {
                    zh: '用于各类纸杯生产加工。',
                    en: 'For producing various types of paper cups',
                    ja: '各種紙コップ製造加工用',
                    Russian: 'Для производства различных бумажных стаканчиков',
                    Malay: 'Untuk pengeluaran pelbagai jenis cawan kertas.',
                    Turkish: 'Her türlü kağıt bardak üretimi ve işlemesi için kullanılır'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            },
            {
                title: {
                    zh: '纸碗加工',
                    en: 'Paper Bowl Processing',
                    ja: '紙製ボウル加工',
                    Russian: 'Производство бумажных контейнеров (мисок)',
                    Malay: 'Pemprosesan Mangkuk Kertas',
                    Turkish: 'Kağıt Kase İşleme'
                },
                desc: {
                    zh: '用于各类纸碗、纸餐具加工生产。',
                    en: 'For producing various types of paper bowls and disposable tableware',
                    ja: '各種紙製ボウル・紙製食器製造加工用',
                    Russian: 'Для производства бумажных мисок и бумажной посуды',
                    Malay: 'Untuk pengeluaran pelbagai jenis mangkuk kertas dan peralatan makan kertas.',
                    Turkish: 'Her türlü kağıt kase ve kağıt mutfak eşyası üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            },
            {
                title: {
                    zh: '快餐桶加工',
                    en: 'Fast Food Container Processing',
                    ja: 'ファストフード容器加工',
                    Russian: 'Производство фастфуд-контейнеров',
                    Malay: 'Pemprosesan Baldi Makanan Segera',
                    Turkish: 'Fast Food Kutusu İşleme'
                },
                desc: {
                    zh: '用于各类纸桶、纸盒加工生产。',
                    en: 'For producing various types of paper buckets and boxes',
                    ja: '各種紙バケツ・紙箱製造加工用',
                    Russian: 'Для производства бумажных бочонков и коробок',
                    Malay: 'Untuk pengeluaran pelbagai jenis baldi kertas dan kotak kertas.',
                    Turkish: 'Her türlü kağıt kutu ve kağıt kutu üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiTongShengChan.png'
            }
        ],
        relatedProducts: ['packaging-001', 'packaging-002', 'packaging-004']
    },
    {
        id: 'packaging-004',
        title: {
            zh: '普松纸',
            en: 'Standard Bulk Paper',
            ja: '並嵩紙',
            Russian: 'Бумага со средней объемной плотностью',
            Malay: 'Kertas Ketumpatan Biasa',
            Turkish: 'Standart Kabarık Kağıt'
        },
        category: 'packaging',
        desc: {
            zh: '加工产品易成型、得率高、报废少',
            en: 'Easy Forming, High Yield Rate, Low Reject Rate in Processing',
            ja: '加工製品成形容易、高歩留まり、低廃棄率',
            Russian: 'Легко формируется • Высокий выход • Минимальный брак',
            Malay: 'Produk Mudah Dibentuk, Kecekapan Pengeluaran Tinggi, Kadar Sisa Rendah',
            Turkish: 'İşlenmiş ürünler kolay şekillenir, yüksek verim sağlar ve düşük fire oranına sahiptir.'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '无异味',
                '具有良好的边渗透性能'
            ],
            en: [
                'Fluorescent Whitening Agent Free',
                'Uncoated, Unlaminated, Uniform Thickness',
                'Odorless',
                'Good Edge Penetration Performance'
            ],
            ja: [
                '蛍光増白剤不使用',
                '無塗工、無ラミネート、均一厚',
                '無臭',
                '良好なエッジ浸透防止性能'
            ],
            Russian: [
                'Не содержит флуоресцентных отбеливателей',
                'Не лакированная и не покрытая пленкой продукция равномерной толщины',
                'Без постороннего запаха',
                'обладает отличными характеристиками краевого проникновения.'
            ],
            Malay: [
                'Tiada Agen Pendarfluor',
                'Tiada Salutan/Tiada Laminasi, Ketebalan Seragam',
                'Bebas Bau',
                'Penyerapan Tepi yang Baik'
            ],
            Turkish: [
                'Floresan Ağartıcı İçermez',
                'Kaplamasız, Laminatsız, Düzgün Kalınlık',
                'Kokusuz',
                'İyi Kenar Nüfuz Özelliği'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'QS Certification',
                    ja: 'QS認証',
                    Russian: 'Сертификация QS (китайская система сертификации безопасности пищевой продукции)',
                    Malay: 'Pensijilan QS',
                    Turkish: 'QS Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '135~350 g/㎡',
                    en: '135~350 g/㎡',
                    ja: '135~350 g/㎡',
                    Russian: '135~350 g/㎡',
                    Malay: '135~350 g/㎡',
                    Turkish: '135~350 g/㎡'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customizable Upon Request',
                    ja: 'ご要望に応じカスタマイズ',
                    Russian: 'Индивидуальный заказ по требованиям',
                    Malay: 'Disesuaikan Mengikut Keperluan',
                    Turkish: 'İhtiyaca Göre Özel Üretim'
                }
            },
            {
                name: {
                    zh: '成分',
                    en: 'Composition',
                    ja: '成分',
                    Russian: 'Ингредиенты',
                    Malay: 'Komposisi',
                    Turkish: 'Bileşen'
                },
                value: {
                    zh: '原生竹浆、原生木浆',
                    en: 'Virgin Bamboo Pulp, Virgin Wood Pulp',
                    ja: 'バージン竹パルプ、バージン木材パルプ',
                    Russian: 'Натуральная бамбуковая целлюлоза',
                    Malay: 'Pulpa Buluh Asli, Pulpa Kayu Asli',
                    Turkish: 'Ham Bambu Hamuru, Ham Odun Hamuru'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '5100元/吨',
            //         en: '¥5100/Ton',
            //         ja: '5100人民元/トン',
            //         Russian: '5100 юаней/т',
            //         Malay: '5100 RMB/tan',
            //         Turkish: '5100 Yuan/Ton'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '纸杯加工',
                    en: 'Paper Cup Processing',
                    ja: '紙コップ加工',
                    Russian: 'Производство бумажных стаканчиков',
                    Malay: 'Pemprosesan Cawan Kertas',
                    Turkish: 'Kağıt Bardak İşleme'
                },
                desc: {
                    zh: '用于各类纸杯生产加工。',
                    en: 'For producing various types of paper cups',
                    ja: '各種紙コップ製造加工用',
                    Russian: 'Для производства различных бумажных стаканчиков',
                    Malay: 'Untuk pengeluaran pelbagai jenis cawan kertas.',
                    Turkish: 'Her türlü kağıt bardak üretimi ve işlemesi için kullanılır'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            },
            {
                title: {
                    zh: '纸碗加工',
                    en: 'Paper Bowl Processing',
                    ja: '紙製ボウル加工',
                    Russian: 'Производство бумажных контейнеров (мисок)',
                    Malay: 'Pemprosesan Mangkuk Kertas',
                    Turkish: 'Kağıt Kase İşleme'
                },
                desc: {
                    zh: '用于各类纸碗、纸餐具加工生产。',
                    en: 'For producing various types of paper bowls and disposable tableware',
                    ja: '各種紙製ボウル・紙製食器製造加工用',
                    Russian: 'Для производства бумажных мисок и бумажной посуды',
                    Malay: 'Untuk pengeluaran pelbagai jenis mangkuk kertas dan peralatan makan kertas.',
                    Turkish: 'Her türlü kağıt kase ve kağıt mutfak eşyası üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            },
            {
                title: {
                    zh: '快餐桶加工',
                    en: 'Fast Food Container Processing',
                    ja: 'ファストフード容器加工',
                    Russian: 'Производство фастфуд-контейнеров',
                    Malay: 'Pemprosesan Baldi Makanan Segera',
                    Turkish: 'Fast Food Kutusu İşleme'
                },
                desc: {
                    zh: '用于各类纸桶、纸盒加工生产。',
                    en: 'For producing various types of paper buckets and boxes',
                    ja: '各種紙バケツ・紙箱製造加工用',
                    Russian: 'Для производства бумажных бочонков и коробок',
                    Malay: 'Untuk pengeluaran pelbagai jenis baldi kertas dan kotak kertas.',
                    Turkish: 'Her türlü kağıt kutu ve kağıt kutu üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiTongShengChan.png'
            }
        ],
        relatedProducts: ['packaging-001', 'packaging-002', 'packaging-003']
    },
    {
        id: 'packaging-005',
        title: {
            zh: '竹浆面碗原纸',
            en: 'Bamboo Pulp Noodle Bowl Base Paper',
            ja: '竹パルプ麺用ボウル原紙',
            Russian: 'Экологически чистая бумага из бамбуковой целлюлозы для экологичных мисок',
            Malay: 'Kertas Asas Mangkuk Mi Buluh',
            Turkish: 'Bambu Hamuru Noodle Kasesi Temel Kağıdı'
        },
        category: 'packaging',
        desc: {
            zh: '原竹本色、未漂白、洁净度好',
            en: 'Natural Bamboo Color, Unbleached, Good Cleanliness',
            ja: '竹本来の色、未漂白、高清潔度',
            Russian: 'Бамбуковая бумага натурального цвета, без отбеливания и с хорошей чистотой поверхности',
            Malay: 'Warna Asli Buluh, Tanpa Pelunturan, Kebersihan Baik',
            Turkish: 'Doğal Bambu Rengi, Ağartılmamış, İyi Temizlik'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangZhi.jpg',
        gallery: [
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangZhi.jpg'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '无异味，具有良好的边渗透性能',
                '高松厚度、高挺度'
            ],
            en: [
                'Fluorescent Whitening Agent Free',
                'Uncoated, Unlaminated, Uniform Thickness',
                'Odorless, Good Edge Penetration Performance',
                'High Bulk, High Stiffness'
            ],
            ja: [
                '蛍光増白剤不使用',
                '無塗工、無ラミネート、均一厚',
                '無臭、良好なエッジ浸透防止性能',
                '嵩高、高剛性'
            ],
            Russian: [
                'Не содержит флуоресцентных отбеливателей',
                'Не лакированная и не покрытая пленкой продукция равномерной толщины',
                'Без постороннего запаха, обладает отличными характеристиками краевого проникновения.',
                'Высокий коэффициент объема и высокая жесткость бумаги'
            ],
            Malay: [
                'Tiada Agen Pendarfluor',
                'Tiada Salutan/Tiada Laminasi, Ketebalan Seragam',
                'Bebas Bau, Penyerapan Tepi yang Baik',
                'Ketebalan Tinggi & Kekakuan Unggul'
            ],
            Turkish: [
                'Floresan Ağartıcı İçermez',
                'Kaplamasız, Laminatsız, Düzgün Kalınlık',
                'Kokusuzdur ve mükemmel kenar penetrasyon özelliğine sahiptir.',
                'Yüksek Kabarıklık ve Yüksek Diklik'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'QS Certification',
                    ja: 'QS認証',
                    Russian: 'Сертификация QS (китайская система сертификации безопасности пищевой продукции)',
                    Malay: 'Pensijilan QS',
                    Turkish: 'QS Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '210~260 g/㎡',
                    en: '210~260 g/㎡',
                    ja: '210~260 g/㎡',
                    Russian: '210~260 g/㎡',
                    Malay: '210~260 g/㎡',
                    Turkish: '210~260 g/㎡'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customizable Upon Request',
                    ja: 'ご要望に応じカスタマイズ',
                    Russian: 'Индивидуальный заказ по требованиям',
                    Malay: 'Disesuaikan Mengikut Keperluan',
                    Turkish: 'İhtiyaca Göre Özel Üretim'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '5800元/吨',
            //         en: '¥5800/Ton',
            //         ja: '5800人民元/トン',
            //         Russian: '5800 юаней/т',
            //         Malay: '5800 RMB/tan'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '食品包装',
                    en: 'Food Packaging',
                    ja: '食品包装',
                    Russian: 'Экологичная и безопасная упаковка для пищевой продукции',
                    Malay: 'Pembungkusan Makanan',
                    Turkish: 'Gıda Ambalajı'
                },
                desc: {
                    zh: '用于各类面碗生产',
                    en: 'For producing various types of noodle bowls',
                    ja: '各種麺用ボウル製造用',
                    Russian: 'Для производства едальных мисок',
                    Malay: 'Untuk pengeluaran pelbagai jenis mangkuk mi.',
                    Turkish: 'Her türlü noodle kasesi üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            }
        ],
        relatedProducts: ['packaging-006', 'packaging-007', 'packaging-008']
    },
    {
        id: 'packaging-006',
        title: {
            zh: '奶茶杯专用原纸',
            en: 'Specialty Base Paper for Bubble Tea Cups',
            ja: 'ミルクティーカップ専用原紙',
            Russian: 'молочно-чайная бумага',
            Malay: 'Kertas Khas Cawan Teh Susu',
            Turkish: 'Süt Çayı Bardakları İçin Özel Kağıt'
        },
        category: 'packaging',
        desc: {
            zh: '原竹本色、未漂白、洁净度好',
            en: 'Natural Bamboo Color, Unbleached, Good Cleanliness',
            ja: '竹本来の色、未漂白、高清潔度',
            Russian: 'Бамбуковая бумага натурального цвета, без отбеливания и с хорошей чистотой поверхности',
            Malay: 'Warna Asli Buluh, Tanpa Pelunturan, Kebersihan Baik',
            Turkish: 'Doğal Bambu Rengi, Ağartılmamış, İyi Temizlik'
        },
        img: '/images/mainProduction/ZhiBeiXiGuan.jpg',
        gallery: [
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            '/images/mainProduction/ZhiBeiXiGuan.jpg'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '具有良好的边渗透性能',
                '无异味，符合国家食品安全要求'
            ],
            en: [
                'Fluorescent Whitening Agent Free',
                'Uncoated, Unlaminated, Uniform Thickness',
                'Good Edge Penetration Performance',
                'Odorless, Compliant with National Food Safety Standards'
            ],
            ja: [
                '蛍光増白剤不使用',
                '無塗工、無ラミネート、均一厚',
                '良好なエッジ浸透防止性能',
                '無臭、国家食品安全基準適合'
            ],
            Russian: [
                'Не содержит флуоресцентных отбеливателей',
                'Не лакированная и не покрытая пленкой продукция равномерной толщины',
                'Обладает хорошими характеристиками краевого проникновения.',
                'Без постороннего запаха, соответствует санитарно - эпидемиологическим требованиям к пищевым продуктам.'
            ],
            Malay: [
                'Tiada Agen Pendarfluor',
                'Tiada Salutan/Tiada Laminasi, Ketebalan Seragam',
                'Memiliki Prestasi Penyerapan Tepi yang Baik',
                'Bebas Bau, Mematuhi Keperluan Keselamatan Makanan Negara'
            ],
            Turkish: [
                'Floresan Ağartıcı İçermez',
                'Kaplamasız, Laminatsız, Düzgün Kalınlık',
                'İyi Kenar Nüfuz Özelliği',
                'Kokusuz, Ulusal Gıda Güvenliği Standartlarına Uygun'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'QS Certification',
                    ja: 'QS認証',
                    Russian: 'Сертификация QS (китайская система сертификации безопасности пищевой продукции)',
                    Malay: 'Pensijilan QS',
                    Turkish: 'QS Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '标准规格',
                    en: 'Standard Specification',
                    ja: '標準規格',
                    Russian: 'Стандартные параметры',
                    Malay: 'Spesifikasi Standard',
                    Turkish: 'Standart Özellikler'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '240 g/㎡',
                    en: '240 g/㎡',
                    ja: '240 g/㎡',
                    Russian: '240 g/㎡',
                    Malay: '240 g/㎡',
                    Turkish: '240 g/㎡'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '5800元/吨',
            //         en: '¥5800/Ton',
            //         ja: '5800人民元/トン',
            //         Russian: '5800 юаней/т',
            //         Malay: '5800 RMB/tan'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '食品包装',
                    en: 'Food Packaging',
                    ja: '食品包装',
                    Russian: 'Экологичная и безопасная упаковка для пищевой продукции',
                    Malay: 'Pembungkusan Makanan',
                    Turkish: 'Gıda Ambalajı'
                },
                desc: {
                    zh: '用于各类奶茶杯生产',
                    en: 'For producing various types of bubble tea cups',
                    ja: '各種ミルクティーカップ製造用',
                    Russian: 'Бумага для производства различных молочно-чайных стаканчиков',
                    Malay: 'Untuk pengeluaran pelbagai jenis cawan teh susu.',
                    Turkish: 'Çeşitli bubble tea bardakları üretimi için kullanılır'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            }
        ],
        relatedProducts: ['packaging-005', 'packaging-007', 'packaging-008']
    },
    {
        id: 'packaging-007',
        title: {
            zh: '竹浆吸管原纸',
            en: 'Bamboo Pulp Straw Base Paper',
            ja: '竹パルプストロー原紙',
            Russian: 'Бумага из бамбуковой целлюлозы для соломинок',
            Malay: 'Kertas Asas Penyedut Minuman Buluh',
            Turkish: 'Bambu Hamuru Pipet Temel Kağıdı'
        },
        category: 'packaging',
        desc: {
            zh: '强度好、耐折高、洁净度好',
            en: 'Good Strength, High Fold Endurance, Good Cleanliness',
            ja: '高強度、高耐折性、高清潔度',
            Russian: 'Прочная бумага с высокой устойчивостью к складыванию и отличной чистотой поверхности',
            Malay: 'Kekuatan Baik, Ketahanan Lipatan Tinggi, Kebersihan Baik',
            Turkish: 'İyi Dayanıklılık, Yüksek Katlanma Direnci, İyi Temizlik'
        },
        img: '/images/mainProduction/XiGuanSuoLve.png',
        gallery: [
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            '/images/mainProduction/XiGuanSuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '具有良好的边渗透性能',
                '无异味，符合国家食品安全要求'
            ],
            en: [
                'Fluorescent Whitening Agent Free',
                'Uncoated, Unlaminated, Uniform Thickness',
                'Good Edge Penetration Performance',
                'Odorless, Compliant with National Food Safety Standards'
            ],
            ja: [
                '蛍光増白剤不使用',
                '無塗工、無ラミネート、均一厚',
                '良好なエッジ浸透防止性能',
                '無臭、国家食品安全基準適合'
            ],
            Russian: [
                'Не содержит флуоресцентных отбеливателей',
                'Не лакированная и не покрытая пленкой продукция равномерной толщины',
                'Обладает хорошими характеристиками краевого проникновения.',
                'Без постороннего запаха, соответствует санитарно - эпидемиологическим требованиям к пищевым продуктам.'
            ],
            Malay: [
                'Tiada Agen Pendarfluor',
                'Tiada Salutan/Tiada Laminasi, Ketebalan Seragam',
                'Memiliki Prestasi Penyerapan Tepi yang Baik',
                'Bebas Bau, Mematuhi Keperluan Keselamatan Makanan Negara'
            ],
            Turkish: [
                'Floresan Ağartıcı İçermez',
                'Kaplamasız, Laminatsız, Düzgün Kalınlık',
                'İyi Kenar Nüfuz Özelliği',
                'Kokusuz, Ulusal Gıda Güvenliği Standartlarına Uygun'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'QS Certification',
                    ja: 'QS認証',
                    Russian: 'Сертификация QS (китайская система сертификации безопасности пищевой продукции)',
                    Malay: 'Pensijilan QS',
                    Turkish: 'QS Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '100/120/150 g/㎡',
                    en: '100/120/150 g/㎡',
                    ja: '100/120/150 g/㎡',
                    Russian: '100/120/150 g/㎡',
                    Malay: '100/120/150 g/㎡',
                    Turkish: '100/120/150 g/㎡'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customizable Upon Request',
                    ja: 'ご要望に応じカスタマイズ',
                    Russian: 'Индивидуальный заказ по требованиям',
                    Malay: 'Disesuaikan Mengikut Keperluan',
                    Turkish: 'İhtiyaca Göre Özel Üretim'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '7800元/吨',
            //         en: '¥7800/Ton',
            //         ja: '7800人民元/トン',
            //         Russian: '7800 юаней/т',
            //         Malay: '7800 RMB/tan'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '食品包装',
                    en: 'Food Packaging',
                    ja: '食品包装',
                    Russian: 'Экологичная и безопасная упаковка для пищевой продукции',
                    Malay: 'Pembungkusan Makanan',
                    Turkish: 'Gıda Ambalajı'
                },
                desc: {
                    zh: '用于各类纸吸管生产',
                    en: 'For producing various types of paper straws',
                    ja: '各種紙ストロー製造用',
                    Russian: 'Для производства бумажных соломинок',
                    Malay: 'Untuk pengeluaran pelbagai jenis penyedut minuman kertas.',
                    Turkish: 'Her türlü kağıt pipet üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ZhiXiGuanShengChan.png'
            }
        ],
        relatedProducts: ['packaging-005', 'packaging-006', 'packaging-008']
    },
    {
        id: 'packaging-008',
        title: {
            zh: '纸杯',
            en: 'Paper Cup',
            ja: '紙コップ',
            Russian: 'Экологически чистый бумажный стакан',
            Malay: 'Cawan Kertas',
            Turkish: 'Kağıt Bardak'
        },
        category: 'packaging',
        desc: {
            zh: '双层加厚不烫手，防止变形，无异味',
            en: 'Double-Wall Insulated (Heat-Proof) , Deformation Resistant, Odorless',
            ja: '二重厚手構造・火傷防止、変形防止、無臭',
            Russian: 'Двухслойная бумага с утолщённой структурой, обладающая:·не горячая на ощупь·устойчива к деформации·отсутствием постороннего запаха',
            Malay: 'Dua Lapisan Tebal (Tidak Panas di Tangan), Cegah Ubah Bentuk, Bebas Bau',
            Turkish: 'Çift Katmanlı Kalınlaştırılmış, Yanmaz, Şekil Değiştirmeye Karşı, Kokusuz'
        },
        img: '/images/ZhiBei.png',
        gallery: [
            // '/images/ZhiBei.png',
            // '/images/ZhiBei.png',
            // '/images/ZhiBei.png',
            '/images/ZhiBei.png'
        ],
        features: {
            zh: [
                '双层加厚',
                '不烫手',
                '防止变形',
                '无异味'
            ],
            en: [
                'Double-Wall Insulated',
                'Heat-resistant',
                'Deformation-resistant',
                'Odorless'
            ],
            ja: [
                '二重に厚くて',
                '手に熱くない',
                '変形しない',
                '臭いがありません'
            ],
            Russian: [
                'Двухслойная бумага с утолщённой структурой, обладающая:',
                'не горячая на ощупь',
                'устойчива к деформации',
                'отсутствием постороннего запаха'
            ],
            Malay: [
                'Dua Lapisan Tebal ',
                'Tidak Panas di Tangan',
                'Cegah Ubah Bentuk',
                'Bebas Bau'
            ],
            Turkish: [
                'Çift Katmanlı Kalınlaştırılmış',
                'Yanmaz',
                'Şekil Değiştirmeye Karşı',
                'Kokusuz'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-shield-alt',
            //     name: {
            //         zh: '食品级认证',
            //         en: 'Food Grade Certification',
            //         ja: '食品レベル認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '容量',
                    en: 'Capacity',
                    ja: '容量',
                    Russian: 'Емкость',
                    Malay: 'Kapasiti',
                    Turkish: 'Kapasite'
                },
                value: {
                    zh: '多种规格可选',
                    en: 'Multiple sizes available',
                    ja: '多種規格選択可能',
                    Russian: 'Различные варианты размеров и типов на выбор',
                    Malay: 'Pelbagai Spesifikasi Tersedia',
                    Turkish: 'Çeşitli Boyutlarda Mevcut'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '食品级竹浆纸',
                    en: 'Food-grade bamboo pulp paper',
                    ja: '食品グレード竹パルプ紙',
                    Russian: 'Экологически чистая бумага из бамбуковой целлюлозы, безопасная для пищевых контактов',
                    Malay: 'Kertas Buluh Gred Makanan',
                    Turkish: 'Gıda Sınıfı Bambu Hamuru Kağıdı'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日用',
                    en: 'Household Use',
                    ja: '家庭用',
                    Russian: 'Для домашнего обихода',
                    Malay: 'Kegunaan Harian Keluarga',
                    Turkish: 'Ev Kullanımı'
                },
                desc: {
                    zh: '适用于家庭日常使用',
                    en: 'Suitable for daily household use',
                    ja: '家庭日常使用に適応',
                    Russian: 'Для домашнего обихода',
                    Malay: 'Sesuai untuk kegunaan harian keluarga.',
                    Turkish: 'Günlük ev kullanımı için uygundur.'
                },
                img: '/images/ApplicationScenarios/ZhiBeijiaYong.png'
            },
            {
                title: {
                    zh: '商务接待',
                    en: 'Business Reception',
                    ja: 'ビジネス接客用',
                    Russian: '​Для деловых мероприятий и приемов​',
                    Malay: 'Sambutan Perniagaan',
                    Turkish: 'İş Toplantıları ve Misafir Ağırlama'
                },
                desc: {
                    zh: '适用于会议、办公待客，商务接待',
                    en: 'Suitable for meetings, office hospitality and business reception',
                    ja: '会議、オフィス来客、ビジネス接客に適応',
                    Russian: 'Подходит для конференций, офисного приема и деловых мероприятий',
                    Malay: 'Sesuai untuk mesyuarat, pejabat, dan sambutan perniagaan.',
                    Turkish: 'Toplantılar, ofis ziyaretçileri ve iş ağırlamaları için uygundur.'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShangWuJieDai.png'
            },
            {
                title: {
                    zh: '旅行便携',
                    en: 'Compact for Travel',
                    ja: '旅行携帯用',
                    Russian: '​Компактный и легкий для поездок​',
                    Malay: 'Mudah Alih untuk Perjalanan',
                    Turkish: 'Seyahat için Taşınabilir'
                },
                desc: {
                    zh: '适用于旅行便携',
                    en: 'Suitable for travel and portability',
                    ja: '旅行携帯に適応',
                    Russian: '​Компактный и легкий для поездок​',
                    Malay: 'Sesuai untuk mudah alih semasa perjalanan.',
                    Turkish: 'Seyahatlerde taşınabilir kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ZhiBeiLuXingBianXie.png'
            }
        ],
        relatedProducts: ['packaging-006', 'packaging-007', 'packaging-009']
    },
    {
        id: 'packaging-009',
        title: {
            zh: '杯茶',
            en: 'Cup Tea',
            ja: 'カップティー',
            Russian: '​Бумажный стакан с чайным пакетиком​',
            Malay: 'Teh dalam Cawan',
            Turkish: 'Bardak Çay'
        },
        category: 'packaging',
        desc: {
            zh: '杯茶一体，独立茶仓即冲即饮',
            en: 'Integrated Cup & Tea, Independent Tea Chamber for Instant Brewing',
            ja: 'カップ・茶葉一体型、個別茶葉スペース、即席抽出',
            Russian: 'Бумажный стакан с чайным пакетиком для моментального заваривания',
            Malay: 'Cawan Bersepadu Teh, Petak Teh Bebas (Bancuh & Minum Segera)',
            Turkish: 'Bardak ve çay bir arada, bağımsız çay haznesiyle anında demleme'
        },
        img: '/images/BeiCha.jpg',
        gallery: [
            // '/images/BeiCha.jpg',
            // '/images/BeiCha.jpg',
            // '/images/BeiCha.jpg',
            '/images/BeiCha.jpg'
        ],
        features: {
            zh: [
                '杯茶一体',
                '独立茶仓',
                '即冲即饮',
                '方便携带'
            ],
            en: [
                'Integrated Cup & Tea',
                'Independent Tea Chamber',
                'Instant Brewing',
                'Portable'
            ],
            ja: [
                'カップ・茶葉一体型',
                '個別茶葉スペース',
                '即席抽出',
                '携帯便利'
            ],
            Russian: [
                '​Бумажный стакан с чайным пакетиком​',
                'для моментального заваривания',
                'Удобно носить с собой'
            ],
            Malay: [
                'Cawan Bersepadu Teh',
                'Petak Teh Bebas',
                'Bancuh & Minum Segera',
                'Mudah Dibawa'
            ],
            Turkish: [
                'Bardak ve Çay Bir Arada',
                'Bağımsız Çay Haznesi',
                'Anında Demle ve İç',
                'Taşıması Kolay'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-shield-alt',
            //     name: {
            //         zh: '食品级认证',
            //         en: 'Food Grade Certification',
            //         ja: '食品レベル認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi' ,
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '350ML/杯',
                    en: '350ML/Cup',
                    ja: '350ML/カップ',
                    Russian: '350 мл/стакан',
                    Malay: '350ML/cawan',
                    Turkish: '350ML/Bardak'
                }
            },
            {
                name: {
                    zh: '容量',
                    en: 'Capacity',
                    ja: '容量',
                    Russian: 'Емкость',
                    Malay: 'Kapasiti',
                    Turkish: 'Kapasite'
                },
                value: {
                    zh: '350ML/杯',
                    en: '350ML/Cup',
                    ja: '350ML/カップ',
                    Russian: '350 мл/стакан',
                    Malay: '350ML/cawan',
                    Turkish: '350ML/Bardak'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日用',
                    en: 'Household Use',
                    ja: '家庭用',
                    Russian: 'Для домашнего обихода',
                    Malay: 'Kegunaan Harian Keluarga',
                    Turkish: 'Ev Kullanımı'
                },
                desc: {
                    zh: '适用于家庭日常使用',
                    en: 'Suitable for daily household use',
                    ja: '家庭日常使用に適応',
                    Russian: 'Для домашнего обихода',
                    Malay: 'Sesuai untuk kegunaan harian keluarga.',
                    Turkish: 'Günlük ev kullanımı için uygundur.'
                },
                img: '/images/ApplicationScenarios/ZhiBeijiaYong.png'
            },
            {
                title: {
                    zh: '商务接待',
                    en: 'Business Reception',
                    ja: 'ビジネス接客用',
                    Russian: '​Для деловых мероприятий и приемов​',
                    Malay: 'Sambutan Perniagaan',
                    Turkish: 'İş Toplantıları ve Misafir Ağırlama'
                },
                desc: {
                    zh: '适用于会议、办公待客，商务接待',
                    en: 'Suitable for meetings, office hospitality and business reception',
                    ja: '会議、オフィス来客、ビジネス接客に適応',
                    Russian: 'Подходит для конференций, офисного приема и деловых мероприятий',
                    Malay: 'Sesuai untuk mesyuarat, pejabat, dan sambutan perniagaan.',
                    Turkish: 'Toplantılar, ofis ziyaretçileri ve iş ağırlamaları için uygundur.'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShangWuJieDai.png'
            },
            {
                title: {
                    zh: '旅行便携',
                    en: 'Compact for Travel',
                    ja: '旅行携帯用',
                    Russian: '​Компактный и легкий для поездок​',
                    Malay: 'Mudah Alih untuk Perjalanan',
                    Turkish: 'Seyahat için Taşınabilir'
                },
                desc: {
                    zh: '适用于旅行便携',
                    en: 'Suitable for travel and portability',
                    ja: '旅行携帯に適応',
                    Russian: '​Компактный и легкий для поездок​',
                    Malay: 'Sesuai untuk mudah alih semasa perjalanan.',
                    Turkish: 'Seyahatlerde taşınabilir kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ZhiBeiLuXingBianXie.png'
            }
        ],
        relatedProducts: ['packaging-006', 'packaging-007', 'packaging-008']
    },
    {
        id: 'packaging-010',
        title: {
            zh: '管芯原纸',
            en: 'Core Tube Base Paper',
            ja: '紙管原紙',
            Russian: 'Бумага-основа для втулок',
            Malay: 'Kertas Asas Teras Gulung',
            Turkish: 'Tüp Çekirdek Temel Kağıdı'
        },
        category: 'packaging',
        desc: {
            zh: '厚度均匀、无异味',
            en: 'Uniform Thickness, Odorless',
            ja: '均一厚、無臭',
            Russian: 'Равномерная толщина, без запаха',
            Malay: 'Ketebalan Seragam, Bebas Bau',
            Turkish: 'Düzgün Kalınlık, Kokusuz'
        },
        img: '/images/mainProduction/GuanXinYuanZhi.png',
        gallery: [
            // '/images/mainProduction/KeDingZhiShiPinBaoZhuangSuoLveTu.png',
            // '/images/mainProduction/KeDingZhiShiPinBaoZhuangSuoLveTu.png',
            // '/images/mainProduction/KeDingZhiShiPinBaoZhuangSuoLveTu.png',
            '/images/mainProduction/GuanXinYuanZhi.png'
        ],
        features: {
            zh: [
                '原生竹浆',
                '厚度均匀',
                '无异味',
                '颜色自然'
            ],
            en: [
                'Virgin Bamboo Pulp',
                'Uniform Thickness,',
                'Odorless',
                'Natural Color'
            ],
            ja: [
                'バージン竹パルプ',
                '均一厚',
                '無臭',
                '自然な色合い'
            ],
            Russian: [
                'Натуральная бамбуковая целлюлоза',
                'Равномерная толщина',
                'без запаха',
                'Естественный цвет'
            ],
            Malay: [
                'Pulpa Buluh Asli (Primer)',
                'Ketebalan Seragam',
                'Bebas Bau',
                'Warna Semula Jadi'
            ],
            Turkish: [
                'Ham Bambu Hamuru',
                'Düzgün Kalınlık',
                'Kokusuz',
                'Doğal Renk'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-shield-alt',
            //     name: {
            //         zh: '食品级认证',
            //         en: 'Food Grade Certification',
            //         ja: '食品レベル認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '190/210/250 g/㎡',
                    en: '190/210/250 g/㎡',
                    ja: '190/210/250 g/㎡',
                    Russian: '190/210/250 g/㎡',
                    Malay: '190/210/250 g/㎡',
                    Turkish: '190/210/250 g/㎡'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customizable Upon Request',
                    ja: 'ご要望に応じカスタマイズ',
                    Russian: 'Индивидуальный заказ по требованиям',
                    Malay: 'Disesuaikan Mengikut Keperluan',
                    Turkish: 'İhtiyaca Göre Özel Üretim'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '非食品包装',
                    en: 'Non-Food Packaging',
                    ja: '非食品包装',
                    Russian: 'Непищевая упаковка',
                    Malay: 'Pembungkusan Bukan Makanan',
                    Turkish: 'Gıda Dışı Ambalaj'
                },
                desc: {
                    zh: '用于卫生纸纸芯生产',
                    en: 'For producing tissue paper cores',
                    ja: 'トイレットペーパー紙管製造用',
                    Russian: 'Для производства сердечников для туалетной бумаги',
                    Malay: 'Untuk pengeluaran teras gulung tisu tandas.',
                    Turkish: 'Tuvalet kağıdı tüp çekirdekleri üretimi için kullanılır.'
                },
                img: '/images/ApplicationScenarios/GuanXinYuanZhi.png'
            }
        ],
        relatedProducts: ['packaging-011', 'cultural-002', 'cultural-004']
    },
    {
        id: 'packaging-011',
        title: {
            zh: '通用包装箱',
            en: 'General Packaging Cartons',
            ja: '汎用包装箱',
            Russian: 'Универсальные упаковочные коробки',
            Malay: 'Kotak Pembungkusan Serbaguna',
            Turkish: 'Genel Amaçlı Ambalaj Kutusu'
        },
        category: 'packaging',
        desc: {
            zh: '低碳环保、可回收循环利用',
            en: 'Low-Carbon, Eco-Friendly, Recyclable',
            ja: '低炭素・環境配慮型、リサイクル可能',
            Russian: 'Низкоуглеродистые, экологичные, перерабатываемые',
            Malay: 'Rendah Karbon, Mesra Alam & Boleh Kitar Semula',
            Turkish: 'Düşük Karbonlu, Çevre Dostu, Geri Dönüştürülebilir'
        },
        img: '/images/mainProduction/TongYongBaoZhuangXiangSuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/TongYongBaoZhuangXiangSuoLve.png'
        ],
        features: {
            zh: [
                '低碳环保',
                '质量好',
                '性价比高',
                '可回收循环利用'
            ],
            en: [
                'Low-Carbon & Eco-Friendly',
                'High Quality',
                'High Cost-Effectiveness',
                'Recyclable'
            ],
            ja: [
                '低炭素・環境配慮型',
                '高品質',
                '高コストパフォーマンス',
                'リサイクル可能'
            ],
            Russian: [
                'Низкоуглеродистые и экологичные',
                'Высокое качество',
                'Высокая стоимость',
                'Возможность переработки'
            ],
            Malay: [
                'Rendah Karbon & Mesra Alam',
                'Kualiti Baik',
                'Nisbah Harga-Kualiti Tinggi',
                'Boleh Kitar Semula'
            ],
            Turkish: [
                'Düşük Karbonlu ve Çevre Dostu',
                'İyi Kalite',
                'Yüksek Fiyat-Performans Oranı',
                'Geri Dönüştürülebilir ve Yeniden Kullanılabilir'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-shield-alt',
            //     name: {
            //         zh: '食品级认证',
            //         en: 'Food Grade Certification',
            //         ja: '食品レベル認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '标准规格',
                    en: 'Standard Specification',
                    ja: '標準規格',
                    Russian: 'Стандартные параметры',
                    Malay: 'Spesifikasi Standard',
                    Turkish: 'Standart Özellikler'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customizable Upon Request',
                    ja: 'ご要望に応じカスタマイズ',
                    Russian: 'Индивидуальный заказ по требованиям',
                    Malay: 'Disesuaikan Mengikut Keperluan',
                    Turkish: 'İhtiyaca Göre Özel Üretim'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '包装周转箱',
                    en: 'Packaging & Transport Crates',
                    ja: '輸送用包装箱',
                    Russian: 'Оборотные упаковочные ящики',
                    Malay: 'Kotak Pusingan Pembungkusan',
                    Turkish: 'Ambalaj Dolaşım Kutusu'
                },
                desc: {
                    zh: '白酒类、医药类、电子类、食品饮料类、水果类、农副产品类、工业产品类包装/周转箱',
                    en: 'For packaging/transport of liquor, pharmaceuticals, electronics, F&B, fruits, agricultural products, industrial products',
                    ja: '白酒類、医薬類、電子類、食品飲料類、果物類、農副産物類、工業製品類 包装/輸送箱',
                    Russian: 'Упаковка/ящики для оборота: для китайского белого алкоголя (байцзю), медицинских препаратов, электроники, продуктов питания и напитков, фруктов, сельскохозяйственной продукции, промышленных товаров',
                    Malay: 'Kotak Pembungkusan/Pusingan untuk Alkohol, Farmaseutikal, Elektronik, Makanan & Minuman, Buah-buahan, Hasil Pertanian & Industri',
                    Turkish: 'Alkollü İçecekler, İlaçlar, Elektronik, Gıda ve İçecek, Meyve, Tarımsal Ürünler, Endüstriyel Ürünler için Ambalaj/Dolaşım Kutusu'
                },
                img: '/images/newMaterial/6SuoLue.png'
            }
        ],
        relatedProducts: ['packaging-010', 'cultural-002', 'cultural-004']
    },
    {
        id: 'cultural-001',
        title: { zh: '金竹A4纸', en: 'Gold Bamboo A4 Paper', ja: '「金竹」A4用紙', Russian: 'Бумага A4 "Золотой бамбук"', Malay: 'Kertas A4 "Golden Bamboo"' ,Turkish: 'Altın Bambu A4 Kağıdı'},
        category: 'cultural',
        desc: { zh: '质地光滑洁净，厚度适中', en: 'Smooth, Clean Texture, Moderate Thickness', ja: '滑らかで清潔な紙質、適度な厚み', Russian: 'Гладкая и чистая текстура, средняя толщина', Malay: 'Tekstur Licin & Bersih, Ketebalan Sederhana',Turkish: 'Pürüzsüz ve Temiz Doku, Orta Kalınlık' },
        img: '/images/mainProduction/JinZhuA4SuoLve.png',
        gallery: ['/images/mainProduction/JinZhuA4SuoLve.png'],
        features: { zh: ['质地光滑洁净', '厚度适中', '白度高，强度好'], en: ['Smooth & Clean Texture', 'Moderate Thickness', 'High Whiteness, Good Strength'], ja: ['滑らかで清潔な紙質', '適度な厚み', '高白色度、高強度'], Russian: ['Гладкая и чистая текстура', 'Средняя толщина', 'Высокая белизна и прочность'], Malay: ['Tekstur Licin & Bersih', 'Ketebalan Sederhana', 'Keputihan Tinggi, Kekuatan Baik'] ,
            Turkish: ['Pürüzsüz ve Temiz Doku', 'Orta Kalınlık', 'Yüksek Beyazlık, İyi Dayanıklılık']},
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '500张/包',
                    en: '500 Sheets/Pack',
                    ja: '500 枚/包',
                    Russian: '500 листов/упаковка',
                    Malay: '500 keping/pakej',
                    Turkish: '500 Yaprak/Paket'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur',
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '70 g/m',
                    en: '70 g/m',
                    ja: '70 g/m',
                    Russian: '70 g/m',
                    Malay: '70 g/m',
                    Turkish: '70 g/m'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议用',
                    en: 'For Business Meetings',
                    ja: 'ビジネス会議用',
                    Russian: 'Для деловых встреч',
                    Malay: 'Untuk Mesyuarat Perniagaan',
                    Turkish: 'İş Toplantıları İçin'
                },
                desc: {
                    zh: '适用于商务会议等场景',
                    en: 'Suitable for business meetings and similar scenarios',
                    ja: 'ビジネス会議等に適応',
                    Russian: 'Подходит для деловых встреч и подобных мероприятий',
                    Malay: 'Sesuai untuk mesyuarat perniagaan dan situasi lain.',
                    Turkish: 'İş toplantıları gibi ortamlar için uygundur.'
                },
                img: '/images/ShangWuDingZhiLingYuSuoLve.png'
            },
            {
                title: {
                    zh: '教育办公用',
                    en: 'For Education & Office Use',
                    ja: '教育・オフィス用',
                    Russian: 'Для образования и офиса',
                    Malay: 'Untuk Pendidikan & Pejabat',
                    Turkish: 'Eğitim ve Ofis Kullanımı İçin'
                },
                desc: {
                    zh: '适用于教育办公等场景',
                    en: 'Suitable for education, office use, and similar scenarios',
                    ja: '教育・オフィス等に適応',
                    Russian: 'Подходит для образовательных и офисных целей',
                    Malay: 'Sesuai untuk pendidikan, pejabat dan situasi lain.',
                    Turkish: 'Eğitim ve ofis gibi ortamlar için uygundur.'
                },
                img: '/images/BanGongJiaoYuSuoLve.png'
            }
        ],
        relatedProducts: ['cultural-002', 'cultural-003', 'cultural-004']
    },
    {
        id: 'cultural-002',
        title: { zh: '原生竹浆牛皮纸', en: 'Virgin Bamboo Kraft Paper', ja: 'バージン竹パルプクラフト紙', Russian: 'Крафт-бумага из натуральной бамбуковой целлюлозы', Malay: 'Kertas Kraft Pulpa Buluh Asli' , Turkish: 'Ham Bambu Hamuru Kraft Kağıdı'},
        category: 'cultural',
        desc: { zh: '原生竹纤维，色泽光亮，拉力好', en: 'Virgin Bamboo Fiber, bright color, good tensile strength', ja: 'バージン竹繊維、光沢ある色合い、良好な引張強度', Russian: 'Натуральные бамбуковые волокна、Яркий цвет、Высокая прочность на разрыв', Malay: 'Gentian Buluh Asli、Warna Cerah、Kekuatan Tarikan Baik' , 
            Turkish: 'Ham Bambu Lifi, Parlak Renk, İyi Çekme Direnci' },
        img: '/images/mainProduction/NiuPiZhiSuoLve.png',
        gallery: ['/images/mainProduction/NiuPiZhiSuoLve.png'],
        features: { zh: ['原生竹纤维', '色泽光亮', '拉力好,强度高'], en: ['Virgin Bamboo Fiber', 'Bright Color', 'Good Tensile Strength, High Strength'], ja: ['バージン竹繊維', '光沢ある色合い', '良好な引張強度、高強度'], Russian: ['Натуральные бамбуковые волокна', 'Яркий цвет', 'Высокая прочность на разрыв и общая прочность'], Malay: ['Gentian Buluh Asli', 'Warna Cerah', 'Kekuatan Tarikan Baik, Kekuatan Tinggi'] , 
            Turkish: ['Ham Bambu Lifi', 'Parlak Renk', 'İyi Çekme Direnci, Yüksek Dayanıklılık']},
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customizable Upon Request',
                    ja: 'ご要望に応じカスタマイズ',
                    Russian: 'Индивидуальный заказ по требованиям',
                    Malay: 'Disesuaikan Mengikut Keperluan', 
                    Turkish: 'İhtiyaca Göre Özel Üretim'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '包装封装',
                    en: 'Packaging & Sealing',
                    ja: '包装・封緘用',
                    Russian: 'Упаковка и герметизация',
                    Malay: 'Pembungkusan & Pengekapan', 
                    Turkish: 'Ambalaj ve Paketleme'
                },
                desc: {
                    zh: '应用于档案袋、手提袋、信封等领域',
                    en: 'Used for file cover, handbags, envelopes, etc.',
                    ja: 'ファイル袋、手提げ袋、封筒等分野に応用',
                    Russian: 'Применяется для архивных папок, сумок, конвертов и т.д.',
                    Malay: 'Digunakan untuk fail beg, beg tangan, sampul surat, dll.', 
                    Turkish: 'Dosya zarfları, el çantaları, zarflar gibi alanlarda uygulanır.'
                },
                img: '/images/ApplicationScenarios/NiuPiZhiShouTiDai.png'
            },
            {
                title: {
                    zh: '工业印刷',
                    en: 'Industrial Printing',
                    ja: '工業印刷用',
                    Russian: 'Промышленная печать',
                    Malay: 'Percetakan Industri', 
                    Turkish: 'Endüstriyel Baskı'
                },
                desc: {
                    zh: '应用于工业包装、印刷等领域',
                    en: 'Used for industrial packaging, printing, etc.',
                    ja: '工業包装、印刷等分野に応用',
                    Russian: 'Применяется в промышленной упаковке, печати и т.д.',
                    Malay: 'Digunakan untuk pembungkusan industri, percetakan, dll.', 
                    Turkish: 'Endüstriyel ambalaj ve baskı gibi alanlarda uygulanır.'
                },
                img: '/images/ApplicationScenarios/NiuPiZhiBaoZhuangYinShua.png'
            },
            {
                title: {
                    zh: '淋膜再加工',
                    en: 'Lamination & Reprocessing',
                    ja: 'ラミネート再加工用',
                    Russian: 'Ламинирование и дальнейшая обработка',
                    Malay: 'Pemprosesan Semula Laminasi', 
                    Turkish: 'Laminasyon ve Yeniden İşleme'
                },
                desc: {
                    zh: '应用于印刷、淋膜，纸棒等领域',
                    en: 'Used for printing, lamination, paper sticks, etc.',
                    ja: '印刷、ラミネート、紙スティック等分野に応用',
                    Russian: 'Применяется в печати, ламинировании, производстве бумажных палочек и т.д.',
                    Malay: 'Digunakan untuk percetakan, laminasi, batang kertas, dll.', 
                    Turkish: 'Baskı, laminasyon, kağıt çubuklar gibi alanlarda uygulanır.'
                },
                img: '/images/GongYeZhiZaoLingYuSuoLve.png'
            }
        ],
        relatedProducts: ['cultural-001', 'cultural-003', 'cultural-004']
    },
    {
        id: 'cultural-003',
        title: { zh: '竹浆本色热压垫板纸', en: 'Natural Bamboo Pulp Hot Press Pad Paper', ja: '未晒竹パルプ熱圧クッション板紙', Russian: 'Термопрессованная подложка из бамбуковой целлюлозы натурального цвета', Malay: 'Kertas Lapik Haba Tekan Warna Buluh Asli' , Turkish: 'Bambu Hamuru Doğal Renkli Sıcak Presleme Ped Kağıdı'},
        category: 'cultural',
        desc: { zh: '抗压、耐热性好，使用次数高', en: 'Compression Resistant, Good Heat Resistance, High Reusability', ja: '高耐圧性、高耐熱性、高使用回数', Russian: 'Устойчивость к давлению, высокая термостойкость, многократное использование', Malay: 'Tahan Tekanan, Ketahanan Haba Baik, Kekerapan Penggunaan Tinggi' , Turkish: 'İyi Basınç Direnci, Isıya Dayanıklı, Yüksek Kullanım Ömrü'},
        img: '/images/mainProduction/DianZiYeYaZhiSuoLve.png',
        gallery: ['/images/mainProduction/DianZiYeYaZhiSuoLve.png'],
        features: { zh: ['抗压', '耐热性好', '使用次数高'], en: ['Compression Resistant', 'Good Heat Resistance', 'High Reusability'], ja: ['耐圧性', '高耐熱性', '高使用回数'], Russian: ['Устойчивость к давлению', 'Высокая термостойкость', 'Многократное использование'], Malay: ['Tahan Tekanan', 'Ketahanan Haba Baik', 'Kekerapan Penggunaan Tinggi'], 
            Turkish: ['Basınç Direnci', 'Isıya Dayanıklılık', 'Yüksek Kullanım Ömrü']},
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '150~320 g/㎡',
                    en: '150~320 g/㎡',
                    ja: '150~320 g/㎡',
                    Russian: '150~320 g/㎡',
                    Malay: '150~320 g/㎡', 
                    Turkish: '150~320 g/㎡'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '100%原生竹浆',
                    en: '100% Vrigin Bamboo Pulp',
                    ja: '100%バージン竹パルプ',
                    Russian: '100% цельная бамбуковая целлюлоза',
                    Malay: '100% Pulpa Buluh Asli', 
                    Turkish: '%100 Ham Bambu Hamuru'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '工业制造',
                    en: 'Industrial Manufacturing',
                    ja: '工業製造用',
                    Russian: 'Промышленное производство',
                    Malay: 'Pembuatan Industri', 
                    Turkish: 'Endüstriyel Üretim'
                },
                desc: {
                    zh: '用于PCB行业电路板热压',
                    en: 'Used for PCB (Printed Circuit Board) hot pressing in the electronics industry',
                    ja: 'PCB業界回路基板熱圧用',
                    Russian: 'Для термопрессования печатных плат в PCB-индустрии',
                    Malay: 'Untuk tekanan haba papan litar industri PCB.', 
                    Turkish: 'PCB endüstrisinde devre kartı sıcak presleme için kullanılır.'
                },
                img: '/images/ApplicationScenarios/ReYaZhiPCB.png'
            }
        ],
        relatedProducts: ["cultural-001", 'cultural-002', 'cultural-004']
    },
    {
        id: 'cultural-004',
        title: { zh: '彩票专用原纸', en: 'Specialty Base Paper for Lottery Tickets', ja: '宝くじ専用原紙', Russian: 'Специальная бумага-основа для лотерейных билетов', Malay: 'Kertas Khas Loteri', Turkish: 'Piyango Özel Kağıdı' },
        category: 'cultural',
        desc: { zh: '无荧光增白剂，厚度均匀，无异味', en: 'Fluorescent Whitening Agent Free, Uniform Thickness, Odorless', ja: '蛍光増白剤不使用、均一厚、無臭', Russian: 'Без флуоресцентных отбеливателей, равномерная толщина, без запаха', Malay: 'Tiada Agen Pendarfluor, Ketebalan Seragam, Bebas Bau', Turkish: 'Floresan ağartıcı içermez, düzgün kalınlık, kokusuz'  },
        img: '/images/mainProduction/DianZiYeYaZhiSuoLve.png',
        gallery: ['/images/mainProduction/DianZiYeYaZhiSuoLve.png'],
        features: { zh: ['无荧光增白剂', '未涂布、未淋膜', '厚度均匀，无异味'], en: ['Fluorescent Whitening Agent Free', 'Uncoated, Unlaminated', 'Uniform Thickness, Odorless'], ja: ['蛍光増白剤不使用', '無塗工、無ラミネート', '均一厚、無臭'], Russian: ['Без флуоресцентных отбеливателей', 'Без покрытия и ламинации', 'Равномерная толщина, без запаха'], Malay: ['Tiada Agen Pendarfluor', 'Tiada Salutan/Tiada Laminasi', 'Ketebalan Seragam, Bebas Bau'] ,
            Turkish: ['Floresan Ağartıcı İçermez', 'Kaplanmamış, laminasyon yapılmamış', 'düzgün kalınlık, kokusuz'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler' 
                },
                value: {
                    zh: '135/150 g/㎡',
                    en: '135/150 g/㎡',
                    ja: '135/150 g/㎡',
                    Russian: '135/150 g/㎡',
                    Malay: '135/150 g/㎡', 
                    Turkish: '135/150 g/㎡' 
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme' 
                },
                value: {
                    zh: '原生竹浆、原生木浆',
                    en: 'Virgin Bamboo Pulp, Virgin Wood Pulp',
                    ja: 'バージン竹パルプ、バージン木材パルプ',
                    Russian: 'Натуральная бамбуковая целлюлоза',
                    Malay: 'Pulpa Buluh Asli, Pulpa Kayu Asli', 
                    Turkish: 'Ham Bambu Hamuru, Ham Odun Hamuru' 
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '彩票、游戏币生产',
                    en: 'Lottery Ticket & Game Token Production',
                    ja: '宝くじ・ゲームコイン製造用',
                    Russian: 'Производство лотерейных билетов и игровых жетонов',
                    Malay: 'Untuk pengeluaran loteri dan syiling permainan.', 
                    Turkish: 'Piyango ve jeton üretimi için kullanılır.' 
                },
                desc: {
                    zh: '用于各类彩票、游戏币生产',
                    en: 'For producing various lottery tickets and game tokens',
                    ja: '各種宝くじ・ゲームコイン製造用',
                    Russian: 'Для производства различных лотерейных билетов и игровых жетонов',
                    Malay: 'Digunakan dalam pengeluaran pelbagai tiket loteri dan token permainan', 
                    Turkish: 'Piyango biletleri ve oyun jetonları üretimine özel' 
                },
                img: '/images/ApplicationScenarios/CaiPiaoZhuanYong.png'
            }
        ],
        relatedProducts: ["cultural-001", 'cultural-002', 'cultural-003']
    },
    {
        id: 'rawpaper-001',
        title: { zh: '本色原纸', en: 'Natural Color Base Paper', ja: '未晒原紙', Russian: 'Бумага-основа натурального цвета', Malay: 'Kertas Asas Warna Semula Jadi' , Turkish: 'Doğal Renkli Temel Kağıt' },
        category: 'rawpaper',
        desc: { zh: '色泽金黄、强度好、洁净度好', en: 'Golden Hue, Good Strength, Good Cleanliness', ja: '黄金色、高強度、高清潔度', Russian: 'Золотистый цвет, высокая прочность, отличная чистота', Malay: 'Warna Keemasan, Kekuatan Baik, Kebersihan Baik' , Turkish: 'Altın Sarısı Renk, İyi Dayanıklılık, İyi Temizlik' },
        img: '/images/mainProduction/ShengHuoYuanZhi2SuoLve.png',
        gallery: ['/images/mainProduction/ShengHuoYuanZhi2SuoLve.png'],
        features: { zh: ['湿水强韧', '绿色环保', '天然抑菌'], en: ['High Wet Strength', 'Eco-Friendly', 'Naturally Antibacterial'], ja: ['湿潤強度強靭', 'グリーン・環境配慮型', '天然抗菌'], Russian: ['Высокая прочность во влажном состоянии', 'Экологически чистая', 'Естественная антибактериальная защита'], Malay: ['Kuat Semasa Basah', 'Hijau & Mesra Alam', 'Penghalang Bakteria Semula Jadi'] , 
            Turkish: ['Islakken Güçlü', 'Yeşil ve Çevre Dostu', 'Doğal Antibakteriyel'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler' 
                },
                value: {
                    zh: '高伸长率、中纹、细纹系列',
                    en: 'High Elongation, Medium Grain, Fine Grain Series',
                    ja: '高伸長率、中目、細目シリーズ',
                    Russian: 'Серии с высокой эластичностью, средней и тонкой текстурой',
                    Malay: 'Siri Pemanjangan Tinggi, Tekstur Sederhana & Halus', 
                    Turkish: 'Yüksek Uzama Oranı, Orta Desen, İnce Desen Serisi' 
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme' 
                },
                value: {
                    zh: '全竹浆',
                    en: '100% Bamboo Pulp',
                    ja: '全量竹パルプ',
                    Russian: '100% бамбуковая целлюлоза',
                    Malay: 'Pulpa Buluh Penuh', 
                    Turkish: 'Tam Bambu Hamuru' 
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna', 
                    Turkish: 'Renk' 
                },
                value: {
                    zh: '本色',
                    en: 'Natural Color',
                    ja: '自然色',
                    Russian: 'Исходный цвет',
                    Malay: 'Warna Semula Jadi (tanpa peluntur)', 
                    Turkish: 'Doğal Renk' 
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur', 
                    Turkish: 'Gramaj' 
                },
                value: {
                    zh: '13.5-35 g',
                    en: '13.5-35 g',
                    ja: '13.5-35 g',
                    Russian: '13.5-35 g',
                    Malay: '13.5-35 g', 
                    Turkish: '13.5-35 g' 
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan', 
                    Turkish: 'Katman Sayısı' 
                },
                value: {
                    zh: '1',
                    en: '1',
                    ja: '1',
                    Russian: '1',
                    Malay: '1', 
                    Turkish: '1' 
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan', 
                    Turkish: 'Ambalaj' 
                },
                value: {
                    zh: '拉伸膜',
                    en: 'Stretch Film',
                    ja: 'ストレッチフィルム',
                    Russian: 'Растягивающаяся плёнка',
                    Malay: 'Filem Regangan', 
                    Turkish: 'Streç Film' 
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan', 
                    Turkish: 'Uygulama Standardı' 
                },
                value: {
                    zh: 'T/SCSZX002-2021',
                    en: 'T/SCSZX002-2021',
                    ja: 'T/SCSZX002-2021',
                    Russian: 'T/SCSZX002-2021',
                    Malay: 'T/SCSZX002-2021', 
                    Turkish: 'T/SCSZX002-2021' 
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '5800元/吨',
            //         en: '¥5800/Ton',
            //         ja: '5800人民元/トン',
            //         Russian: '5800 юаней/т',
            //         Malay: '5800 RMB/tan'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '生活用纸产品加工',
                    en: 'Tissue Product Processing',
                    ja: '家庭紙製品加工',
                    Russian: 'Производство бытовой бумажной продукции',
                    Malay: 'Pemprosesan Produk Kertas Kegunaan Harian', 
                    Turkish: 'Yaşam Kağıt Ürünleri İşleme' 
                },
                desc: {
                    zh: '应用于各类生活用纸产品加工，抽纸、卷纸、盘纸、擦手纸、厨房纸等',
                    en: 'Used for processing various tissue products: pocket tissues, toilet rolls, coreless rolls, hand towels, kitchen towels, etc.',
                    ja: 'ティッシュ、トイレットペーパー、業務用トイレットペーパー、ペーパータオル、キッチンペーパー等、各種家庭紙製品加工に応用',
                    Russian: 'Применяется в производстве различных видов бытовой бумаги: салфеток, рулонной бумаги, кухонных полотенец и т.д.',
                    Malay: 'Digunakan untuk pemprosesan pelbagai produk kertas kegunaan harian seperti tisu tarik, tisu gulung, tisu cakera, tisu tangan, tisu dapur, dll.', 
                    Turkish: 'Çeşitli yaşam kağıt ürünleri işlemesinde uygulanır: çekmeli kağıt, rulo kağıt, tabak kağıdı, el kurulama kağıdı, mutfak kağıdı vb.' 
                },
                img: '/images/finishedPaper/QuanXiLieSuoLve.png'
            }
        ],
        relatedProducts: ['rawpaper-002', 'rawpaper-003', 'packaging-001']
    },
    {
        id: 'rawpaper-002',
        title: { zh: '白色原纸', en: 'White Base Paper', ja: '晒原紙', Russian: 'Белая бумага-основа', Malay: 'Kertas Asas Putih' , Turkish: 'Beyaz Temel Kağıt' },
        category: 'rawpaper',
        desc: { zh: '绿色环保、天然抑菌、成品包型好', en: 'Eco-Friendly, Naturally Antibacterial, Excellent Finished Product Shape', ja: 'グリーン・環境配慮型、天然抗菌、製品包装美麗', Russian: 'Экологичная, с естественной антибактериальной защитой, хорошая форма упаковки', Malay: 'Hijau & Mesra Alam, Penghalang Bakteria Semula Jadi, Bentuk Bungkusan Produk Siap Yang Baik' , 
            Turkish: 'Yeşil ve çevre dostu, doğal antibakteriyel, iyi bitmiş paket şekli' },
        img: '/images/mainProduction/ShengHuoYuanZhi1SuoLve.png',
        gallery: ['/images/mainProduction/ShengHuoYuanZhi1SuoLve.png'],
        features: { zh: ['强度好、拉力高', '洁净度好', '湿水强韧'], en: ['Good Strength, High Tensile Strength', 'Good Cleanliness', 'High Wet Strength'], ja: ['高強度、高引張強度', '高清潔度', '湿潤強度強靭'], Russian: ['Высокая прочность и сопротивление разрыву', 'Отличная чистота', 'Высокая прочность во влажном состоянии'], Malay: ['Kekuatan Baik, Kekuatan Tarikan Tinggi', 'Kebersihan Baik', 'Kuat Semasa Basah'], 
            Turkish: ['İyi Dayanıklılık, Yüksek Çekme Direnci', 'İyi Temizlik', 'Islakken Güçlü'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler' 
                },
                value: {
                    zh: '高伸长率、中纹、细纹系列',
                    en: 'High Elongation, Medium Grain, Fine Grain Series',
                    ja: '高伸長率、中目、細目シリーズ',
                    Russian: 'Серии с высокой эластичностью, средней и тонкой текстурой',
                    Malay: 'Siri Pemanjangan Tinggi, Tekstur Sederhana & Halus', 
                    Turkish: 'Yüksek Uzama Oranı, Orta Desen, İnce Desen Serisi' 
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme' 
                },
                value: {
                    zh: '全竹浆',
                    en: '100% Bamboo Pulp',
                    ja: '全量竹パルプ',
                    Russian: '100% бамбуковая целлюлоза',
                    Malay: 'Pulpa Buluh Penuh', 
                    Turkish: 'Tam Bambu Hamuru' 
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna', 
                    Turkish: 'Renk' 
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih', 
                    Turkish: 'Beyaz' 
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur', 
                    Turkish: 'Gramaj' 
                },
                value: {
                    zh: '13.5-35 g',
                    en: '13.5-35 g',
                    ja: '13.5-35 g',
                    Russian: '13.5-35 g',
                    Malay: '13.5-35 g', 
                    Turkish: '13.5-35 g' 
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan', 
                    Turkish: 'Katman Sayısı' 
                },
                value: {
                    zh: '1',
                    en: '1',
                    ja: '1',
                    Russian: '1',
                    Malay: '1', 
                    Turkish: '1' 
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan', 
                    Turkish: 'Ambalaj' 
                },
                value: {
                    zh: '拉伸膜',
                    en: 'Stretch Film',
                    ja: 'ストレッチフィルム',
                    Russian: 'Растягивающаяся плёнка',
                    Malay: 'Filem Regangan', 
                    Turkish: 'Streç Film' 
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan', 
                    Turkish: 'Uygulama Standardı' 
                },
                value: {
                    zh: 'T/SCSZX002-2021',
                    en: 'T/SCSZX002-2021',
                    ja: 'T/SCSZX002-2021',
                    Russian: 'T/SCSZX002-2021',
                    Malay: 'T/SCSZX002-2021', 
                    Turkish: 'T/SCSZX002-2021' 
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '6350元/吨',
            //         en: '¥6350/Ton',
            //         ja: '6350人民元/トン',
            //         Russian: '6350 юаней/т',
            //         Malay: '6350 RMB/tan'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '生活用纸产品加工',
                    en: 'Tissue Product Processing',
                    ja: '家庭紙製品加工',
                    Russian: 'Производство бытовой бумажной продукции',
                    Malay: 'Pemprosesan Produk Kertas Kegunaan Harian', 
                    Turkish: 'Yaşam Kağıt Ürünleri İşleme' 
                },
                desc: {
                    zh: '应用于各类生活用纸产品加工，抽纸、卷纸、盘纸、擦手纸、厨房纸等',
                    en: 'Used for processing various tissue products: pocket tissues, toilet rolls, coreless rolls, hand towels, kitchen towels, etc.',
                    ja: 'ティッシュ、トイレットペーパー、業務用トイレットペーパー、ペーパータオル、キッチンペーパー等、各種家庭紙製品加工に応用',
                    Russian: 'Применяется в производстве различных видов бытовой бумаги: салфеток, рулонной бумаги, кухонных полотенец и т.д.',
                    Malay: 'Digunakan untuk pemprosesan pelbagai produk kertas kegunaan harian seperti tisu tarik, tisu gulung, tisu cakera, tisu tangan, tisu dapur, dll.', 
                    Turkish: 'Çeşitli yaşam kağıt ürünleri işlemesinde uygulanır: çekmeli kağıt, rulo kağıt, tabak kağıdı, el kurulama kağıdı, mutfak kağıdı vb.' 
                },
                img: '/images/finishedPaper/QuanXiLieSuoLve.png'
            }
        ],
        relatedProducts: ['rawpaper-001', 'rawpaper-003', 'packaging-001']
    },
    {
        id: 'rawpaper-003',
        title: { zh: '吸水衬纸', en: 'Absorbent Core Wrap Paper', ja: '吸水ライナー紙', Russian: 'Впитывающая подложка', Malay: 'Kertas Pelapik Penyerap' , Turkish: 'Emici Astar Kağıdı' },
        category: 'rawpaper',
        desc: { zh: '湿水强韧、洁净度好、吸水均匀速度快', en: 'High Wet Strength, Good Cleanliness, Fast & Uniform Absorption', ja: '湿潤強度強靭、高清潔度、均一高速吸水', Russian: 'Высокая прочность во влажном состоянии, отличная чистота, быстрое и равномерное впитывание', Malay: 'Kuat Semasa Basah, Kebersihan Baik, Penyerapan Seragam & Pantas', 
            Turkish: 'Islakken güçlü, iyi temizlik, hızlı ve eşit emiş'  },
        img: '/images/mainProduction/ShengHuoYuanZhi3SuoLve.png',
        gallery: ['/images/mainProduction/ShengHuoYuanZhi3SuoLve.png'],
        features: { zh: ['湿水强韧', '洁净度好', '吸水均匀速度快'], en: ['High Wet Strength', 'Good Cleanliness', 'Fast & Uniform Absorption'], ja: ['湿潤強度強靭', '高清潔度', '均一高速吸水'], Russian: ['Высокая прочность во влажном состоянии', 'Отличная чистота', 'Быстрое и равномерное впитывание'], Malay: ['Kuat Semasa Basah', 'Kebersihan Baik', 'Penyerapan Air Seragam dan Cepat'] , 
            Turkish: ['Islakken güçlü', 'iyi temizlik', 'hızlı ve eşit emiş'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme' 
                },
                value: {
                    zh: '全竹浆',
                    en: '100% Bamboo Pulp',
                    ja: '全量竹パルプ',
                    Russian: '100% бамбуковая целлюлоза',
                    Malay: 'Pulpa Buluh Penuh', 
                    Turkish: 'Tam Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna', 
                    Turkish: 'Renk'
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih', 
                    Turkish: 'Beyaz'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Grammage',
                    ja: '坪量',
                    Russian: 'Грамматура',
                    Malay: 'Gramatur', 
                    Turkish: 'Gramaj'
                },
                value: {
                    zh: '13.5 g',
                    en: '13.5 g',
                    ja: '13.5 g',
                    Russian: '13.5 g',
                    Malay: '13.5 g', 
                    Turkish: '13.5 g'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan', 
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '1',
                    en: '1',
                    ja: '1',
                    Russian: '1',
                    Malay: '1', 
                    Turkish: '1'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan', 
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '拉伸膜',
                    en: 'Stretch Film',
                    ja: 'ストレッチフィルム',
                    Russian: 'Растягивающаяся плёнка',
                    Malay: 'Filem Regangan', 
                    Turkish: 'Streç Film'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan', 
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX002-2021',
                    en: 'T/SCSZX002-2021',
                    ja: 'T/SCSZX002-2021',
                    Russian: 'T/SCSZX002-2021',
                    Malay: 'T/SCSZX002-2021', 
                    Turkish: 'T/SCSZX002-2021'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '6350元/吨',
            //         en: '¥6350/Ton',
            //         ja: '6350人民元/トン',
            //         Russian: '6350 юаней/т',
            //         Malay: '6350 RMB/tan'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '生活用纸产品加工',
                    en: 'Tissue Product Processing',
                    ja: '家庭紙製品加工',
                    Russian: 'Производство бытовой бумажной продукции',
                    Malay: 'Pemprosesan Produk Kertas Kegunaan Harian', 
                    Turkish: 'Yaşam Kağıt Ürünleri İşleme'
                },
                desc: {
                    zh: '应用于婴幼儿、成人卫生纸尿裤、护理垫加工',
                    en: 'Used in processing baby diapers, adult incontinence products, and care pads.',
                    ja: '乳幼児・成人用紙おむつ、介護パッド加工に応用',
                    Russian: 'Применяется в производстве подгузников и гигиенических прокладок для детей и взрослых',
                    Malay: 'Digunakan untuk pemprosesan lampin tisu dewasa/bayi dan lapik penjagaan.', 
                    Turkish: 'Bebek, yetişkin hijyenik bezi ve bakım pedi işlemesinde uygulanır.'
                },
                img: '/images/ApplicationScenarios/XiShuiCunZhi.png'
            }
        ],
        relatedProducts: ['rawpaper-001', 'rawpaper-002', 'packaging-001']
    },
    {
        id: 'finishedpaper-001',
        title: {
            zh: '山水可湿水软抽',
            en: 'Shanshui Wet Wipes (Soft Pack)',
            ja: '「山水」ウェットティッシュ対応ソフトパックティッシュ',
            Russian: 'Мягкие влажные салфетки "Горный поток"',
            Malay: 'Tisu Lembap Banxi Series - "Banjaran Gunung"', 
            Turkish: 'Dağ ve Nehir Islatılabilir Yumuşak Çekmeli Kağıt'
        },
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat', 
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/ShanShuiKeShiShuiRuanChouSuoLve.png',
        gallery: [
            // '/images/6.png',
            // '/images/10.png',
            // '/images/19.jpg',
            '/images/finishedPaper/ShanShuiKeShiShuiRuanChouSuoLve.png',
        ],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '无荧光剂添加'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'No Fluorescent Agents Added'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '蛍光剤無添加'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Без добавления флуоресцентных агентов'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Tiada Tambahan Agen Pendarfluor'
            ], 
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Floresan ağartıcı eklenmemiştir'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001', 
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC', 
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan', 
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna', 
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh', 
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli', 
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '155mm x 190mm',
                    en: '155mm x 190mm',
                    ja: '155mm x 190mm',
                    Russian: '155mm x 190mm',
                    Malay: '155mm x 190mm', 
                    Turkish: '155mm x 190mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan', 
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3', 
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan', 
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '130抽',
                    en: '130 Sheets',
                    ja: '130組',
                    Russian: '130 салфеток',
                    Malay: '130 helai', 
                    Turkish: '130 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan', 
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '山水系列',
                    en: 'Shanshui Series',
                    ja: '山水シリーズ',
                    Russian: 'Серия "Горный поток"',
                    Malay: 'Siri Banxi', 
                    Turkish: 'Dağ ve Nehir Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi', 
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah', 
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan', 
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: 'GB/T 20808',
                    ja: 'GB/T 20808',
                    Russian: 'GB/T 20808',
                    Malay: 'GB/T 20808', 
                    Turkish: 'GB/T 20808'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '4.75元/包',
            //         en: '¥4.75/Pack',
            //         ja: '4.75人民元/パック',
            //         Russian: '4.75 юаня/упаковка',
            //         Malay: '4.75 RMB/pakej'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Household Daily Use',
                    ja: '家庭日常用',
                    Russian: 'Для повседневного домашнего использования',
                    Malay: 'Kegunaan Harian Keluarga', 
                    Turkish: 'Günlük Ev Kullanımı'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily household cleaning and wiping.',
                    ja: '家庭の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в домашних условиях',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian keluarga.', 
                    Turkish: 'Evde günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Food Service',
                    ja: '飲食サービス用',
                    Russian: 'Для общепита',
                    Malay: 'Perkhidmatan Makanan & Minuman', 
                    Turkish: 'Restoran Hizmetleri'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for restaurants, cafes, and similar venues.',
                    ja: 'レストラン、カフェ等で使用可能',
                    Russian: 'Можно использовать в ресторанах, кафе и т.д.',
                    Malay: 'Boleh digunakan di restoran, kafe, dll.', 
                    Turkish: 'Restoranlar, kafeler gibi yerlerde kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Business Meeting & Reception',
                    ja: 'ビジネス会議接客用',
                    Russian: 'Для деловых встреч и приёмов',
                    Malay: 'Sambutan Mesyuarat Perniagaan', 
                    Turkish: 'İş Toplantıları ve Resepsiyonlar'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Ideal for customized use in offices, meeting rooms, etc.',
                    ja: 'オフィス、会議室等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования в офисах, конференц-залах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di pejabat, bilik mesyuarat, dll.', 
                    Turkish: 'Ofisler, toplantı odaları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-008', 'finishedpaper-009', 'finishedpaper-013']
    },
    {
        id: 'finishedpaper-002',
        title: { zh: '竹韵185软抽', en: 'Zhuyun 185 Soft Pack Tissues', ja: '「竹韻」185組ソフトパックティッシュ', Russian: 'Мягкие салфетки "Бамбуковая мелодия 185"', Malay: 'Tisu Lembut "Bamboo Rhythm 185"' , Turkish: 'Bambu Melodisi 185 Yumuşak Çekmeli'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat', 
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/ZhuYun185RuanChouSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuYun185RuanChouSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '无荧光剂添加'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'No Fluorescent Agents Added'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '蛍光剤無添加'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Без добавления флуоресцентных агентов'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Tiada Tambahan Agen Pendarfluor'
            ], 
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Floresan ağartıcı eklenmemiştir'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001', 
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC', 
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan', 
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna', 
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh', 
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli', 
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '185mm x 190mm',
                    en: '185mm x 190mm',
                    ja: '185mm x 190mm',
                    Russian: '185mm x 190mm',
                    Malay: '185mm x 190mm', 
                    Turkish: '185mm x 190mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan', 
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3', 
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan', 
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '140抽',
                    en: '140 Sheets',
                    ja: '140組',
                    Russian: '140 салфеток',
                    Malay: '140 helai', 
                    Turkish: '140 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan', 
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '竹韵系列',
                    en: 'Zhuyun Series',
                    ja: '竹韻シリーズ',
                    Russian: 'Серия "Бамбуковая мелодия"',
                    Malay: 'Siri Bamboo Rhythm', 
                    Turkish: 'Bambu Melodisi Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi', 
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah', 
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan', 
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: 'T/SCSZX 002',
                    ja: 'T/SCSZX 002',
                    Russian: 'T/SCSZX 002',
                    Malay: 'T/SCSZX 002', 
                    Turkish: 'T/SCSZX 002'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '4.99元/包',
            //         en: '¥4.99/Pack',
            //         ja: '4.99人民元/パック',
            //         Russian: '4.99 юаня/упаковка',
            //         Malay: '4.99 RMB/pakej'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Household Daily Use',
                    ja: '家庭日常用',
                    Russian: 'Для повседневного домашнего использования',
                    Malay: 'Kegunaan Harian Keluarga', 
                    Turkish: 'Günlük Ev Kullanımı'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily household cleaning and wiping.',
                    ja: '家庭の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в домашних условиях',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian keluarga.', 
                    Turkish: 'Evde günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Food Service',
                    ja: '飲食サービス用',
                    Russian: 'Для общепита',
                    Malay: 'Perkhidmatan Makanan & Minuman', 
                    Turkish: 'Restoran Hizmetleri'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for restaurants, cafes, and similar venues.',
                    ja: 'レストラン、カフェ等で使用可能',
                    Russian: 'Можно использовать в ресторанах, кафе и т.д.',
                    Malay: 'Boleh digunakan di restoran, kafe, dll.', 
                    Turkish: 'Restoranlar, kafeler gibi yerlerde kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Business Meeting & Reception',
                    ja: 'ビジネス会議接客用',
                    Russian: 'Для деловых встреч и приёмов',
                    Malay: 'Sambutan Mesyuarat Perniagaan', 
                    Turkish: 'İş Toplantıları ve Resepsiyonlar'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Ideal for customized use in offices, meeting rooms, etc.',
                    ja: 'オフィス、会議室等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования в офисах, конференц-залах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di pejabat, bilik mesyuarat, dll.', 
                    Turkish: 'Ofisler, toplantı odaları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-003', 'finishedpaper-011', 'finishedpaper-014']
    },
    {
        id: 'finishedpaper-003',
        title: { zh: '竹韵165软抽', en: 'Zhuyun 165 Soft Pack Tissues', ja: '「竹韻」165組ソフトパックティッシュ', Russian: 'Мягкие салфетки "Бамбуковая мелодия 165"', Malay: 'Tisu Lembut "Bamboo Rhythm 165"', Turkish: 'Bambu Melodisi 165 Yumuşak Çekmeli' },
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat', 
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/ZhuYun165RuanChouSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuYun165RuanChouSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '无荧光剂添加'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'No Fluorescent Agents Added'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '蛍光剤無添加'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Без добавления флуоресцентных агентов'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Tiada Tambahan Agen Pendarfluor'
            ], 
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Floresan ağartıcı eklenmemiştir'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001', 
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC', 
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan', 
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna', 
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh', 
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli', 
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '165mm x 190mm',
                    en: '165mm x 190mm',
                    ja: '165mm x 190mm',
                    Russian: '165mm x 190mm',
                    Malay: '165mm x 190mm', 
                    Turkish: '165mm x 190mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan', 
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3', 
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan', 
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '134抽',
                    en: '134 Sheets',
                    ja: '134組',
                    Russian: '134 салфеток',
                    Malay: '134 helai', 
                    Turkish: '134 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan', 
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '竹韵系列',
                    en: 'Zhuyun Series',
                    ja: '竹韻シリーズ',
                    Russian: 'Серия "Бамбуковая мелодия"',
                    Malay: 'Siri Bamboo Rhythm', 
                    Turkish: 'Bambu Melodisi Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi', 
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah', 
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan', 
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: 'T/SCSZX 002',
                    ja: 'T/SCSZX 002',
                    Russian: 'T/SCSZX 002',
                    Malay: 'T/SCSZX 002', 
                    Turkish: 'T/SCSZX 002'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '4.06元/包',
            //         en: '¥4.06/Pack',
            //         ja: '4.06人民元/パック',
            //         Russian: '4.06 юаня/упаковка',
            //         Malay: '4.06 RMB/pakej'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Household Daily Use',
                    ja: '家庭日常用',
                    Russian: 'Для повседневного домашнего использования',
                    Malay: 'Kegunaan Harian Keluarga', 
                    Turkish: 'Günlük Ev Kullanımı'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily household cleaning and wiping.',
                    ja: '家庭の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в домашних условиях',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian keluarga.', 
                    Turkish: 'Evde günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Food Service',
                    ja: '飲食サービス用',
                    Russian: 'Для общепита',
                    Malay: 'Perkhidmatan Makanan & Minuman', 
                    Turkish: 'Restoran Hizmetleri'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for restaurants, cafes, and similar venues.',
                    ja: 'レストラン、カフェ等で使用可能',
                    Russian: 'Можно использовать в ресторанах, кафе и т.д.',
                    Malay: 'Boleh digunakan di restoran, kafe, dll.', 
                    Turkish: 'Restoranlar, kafeler gibi yerlerde kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Business Meeting & Reception',
                    ja: 'ビジネス会議接客用',
                    Russian: 'Для деловых встреч и приёмов',
                    Malay: 'Sambutan Mesyuarat Perniagaan', 
                    Turkish: 'İş Toplantıları ve Resepsiyonlar'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Ideal for customized use in offices, meeting rooms, etc.',
                    ja: 'オフィス、会議室等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования в офисах, конференц-залах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di pejabat, bilik mesyuarat, dll.', 
                    Turkish: 'Ofisler, toplantı odaları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-002', 'finishedpaper-011', 'finishedpaper-014']
    },
    {
        id: 'finishedpaper-004',
        title: { zh: '哪吒155软抽', en: 'Nezha 155 Soft Pack Tissues', ja: '「哪吒」155組ソフトパックティッシュ', Russian: 'Мягкие салфетки "Нечжа 155"' , Malay: 'Tisu Lembut "Nezha 155"' , Turkish: 'Nezha 155 Yumuşak Çekmeli' },
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat', 
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/NeZha155RuanChouSuoLve.png',
        gallery: ['/images/finishedPaper/NeZha155RuanChouSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '无荧光剂添加'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'No Fluorescent Agents Added'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '蛍光剤無添加'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Без добавления флуоресцентных агентов'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Tiada Tambahan Agen Pendarfluor'
            ], 
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Floresan ağartıcı eklenmemiştir'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001', 
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC', 
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan', 
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna', 
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh', 
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli', 
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '155mm x 190mm',
                    en: '155mm x 190mm',
                    ja: '155mm x 190mm',
                    Russian: '155mm x 190mm',
                    Malay: '155mm x 190mm', 
                    Turkish: '155mm x 190mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan', 
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3', 
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan', 
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '130抽',
                    en: '130 Sheets',
                    ja: '130組',
                    Russian: '130 салфеток',
                    Malay: '130 helai', 
                    Turkish: '130 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan', 
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '哪吒系列',
                    en: 'Nezha Series',
                    ja: '哪吒シリーズ',
                    Russian: 'Серия "Нечжа"',
                    Malay: 'Siri Nezha', 
                    Turkish: 'Nezha Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi', 
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah', 
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan', 
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: 'GB/T 20808',
                    ja: 'GB/T 20808',
                    Russian: 'GB/T 20808',
                    Malay: 'GB/T 20808', 
                    Turkish: 'GB/T 20808'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '4.2元/包',
            //         en: '¥4.2/Pack',
            //         ja: '4.2人民元/パック',
            //         Russian: '4.26 юаня/упаковка',
            //         Malay: '4.2 RMB/pakej'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Household Daily Use',
                    ja: '家庭日常用',
                    Russian: 'Для повседневного домашнего использования',
                    Malay: 'Kegunaan Harian Keluarga', 
                    Turkish: 'Günlük Ev Kullanımı'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily household cleaning and wiping.',
                    ja: '家庭の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в домашних условиях',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian keluarga.', 
                    Turkish: 'Evde günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Food Service',
                    ja: '飲食サービス用',
                    Russian: 'Для общепита',
                    Malay: 'Perkhidmatan Makanan & Minuman', 
                    Turkish: 'Restoran Hizmetleri'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for restaurants, cafes, and similar venues.',
                    ja: 'レストラン、カフェ等で使用可能',
                    Russian: 'Можно использовать в ресторанах, кафе и т.д.',
                    Malay: 'Boleh digunakan di restoran, kafe, dll.', 
                    Turkish: 'Restoranlar, kafeler gibi yerlerde kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Business Meeting & Reception',
                    ja: 'ビジネス会議接客用',
                    Russian: 'Для деловых встреч и приёмов',
                    Malay: 'Sambutan Mesyuarat Perniagaan', 
                    Turkish: 'İş Toplantıları ve Resepsiyonlar'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Ideal for customized use in offices, meeting rooms, etc.',
                    ja: 'オフィス、会議室等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования в офисах, конференц-залах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di pejabat, bilik mesyuarat, dll.', 
                    Turkish: 'Ofisler, toplantı odaları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-005', 'finishedpaper-010', 'finishedpaper-006']
    },
    {
        id: 'finishedpaper-005',
        title: { zh: '哪吒135抽纸', en: 'Nezha 135 Tissues', ja: '「哪吒」135組ティッシュ', Russian: 'Салфетки "Нечжа 135"', Malay: 'Tisu Tarik "Nezha 135"' , Turkish: 'Nezha 135 Çekmeli Kağıt'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat', 
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/NeZha135ChouZhiSuoLve.png',
        gallery: ['/images/finishedPaper/NeZha135ChouZhiSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '无荧光剂添加'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'No Fluorescent Agents Added'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '蛍光剤無添加'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Без добавления флуоресцентных агентов'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Tiada Tambahan Agen Pendarfluor'
            ], 
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Floresan ağartıcı eklenmemiştir'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001', 
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC', 
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan', 
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna', 
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh', 
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan', 
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli', 
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi', 
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '135mm x 190mm',
                    en: '135mm x 190mm',
                    ja: '135mm x 190mm',
                    Russian: '135mm x 190mm',
                    Malay: '135mm x 190mm', 
                    Turkish: '135mm x 190mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan', 
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3', 
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan', 
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '120抽',
                    en: '120 Sheets',
                    ja: '120組',
                    Russian: '120 салфеток',
                    Malay: '120 helai', 
                    Turkish: '120 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan', 
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '哪吒系列',
                    en: 'Nezha Series',
                    ja: '哪吒シリーズ',
                    Russian: 'Серия "Нечжа"',
                    Malay: 'Siri Nezha', 
                    Turkish: 'Nezha Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi', 
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah', 
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan', 
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: 'GB/T 20808',
                    ja: 'GB/T 20808',
                    Russian: 'GB/T 20808',
                    Malay: 'GB/T 20808', 
                    Turkish: 'GB/T 20808'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '3元/包',
            //         en: '¥3/Pack',
            //         ja: '3人民元/パック',
            //         Russian: '3 юаня/упаковка',
            //         Malay: '3 RMB/pakej'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Household Daily Use',
                    ja: '家庭日常用',
                    Russian: 'Для повседневного домашнего использования',
                    Malay: 'Kegunaan Harian Keluarga', 
                    Turkish: 'Günlük Ev Kullanımı'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily household cleaning and wiping.',
                    ja: '家庭の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в домашних условиях',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian keluarga.', 
                    Turkish: 'Evde günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Food Service',
                    ja: '飲食サービス用',
                    Russian: 'Для общепита',
                    Malay: 'Perkhidmatan Makanan & Minuman', 
                    Turkish: 'Restoran Hizmetleri'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for restaurants, cafes, and similar venues.',
                    ja: 'レストラン、カフェ等で使用可能',
                    Russian: 'Можно использовать в ресторанах, кафе и т.д.',
                    Malay: 'Boleh digunakan di restoran, kafe, dll.', 
                    Turkish: 'Restoranlar, kafeler gibi yerlerde kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Business Meeting & Reception',
                    ja: 'ビジネス会議接客用',
                    Russian: 'Для деловых встреч и приёмов',
                    Malay: 'Sambutan Mesyuarat Perniagaan', 
                    Turkish: 'İş Toplantıları ve Resepsiyonlar'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Ideal for customized use in offices, meeting rooms, etc.',
                    ja: 'オフィス、会議室等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования в офисах, конференц-залах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di pejabat, bilik mesyuarat, dll.', 
                    Turkish: 'Ofisler, toplantı odaları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-004', 'finishedpaper-010', 'finishedpaper-006']
    },
    {
        id: 'finishedpaper-006',
        title: { zh: '“一鹿有您”软抽', en: '"One Deer With You" Soft Pack Tissues', ja: '「一鹿有你」ソフトパックティッシュ', Russian: 'Мягкие салфетки "Олень с вами"', Malay: 'Tisu Lembut "One Deer With You"' , 
            Turkish: 'Bir Geyikle Sizinle Yumuşak Çekmeli'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat', 
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/YiLuYouNinRuanChouSuoLve.png',
        gallery: ['/images/finishedPaper/YiLuYouNinRuanChouSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '无荧光剂添加'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'No Fluorescent Agents Added'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '蛍光剤無添加'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Без добавления флуоресцентных агентов'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Tiada Tambahan Agen Pendarfluor'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Floresan ağartıcı eklenmemiştir'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '134mm x 190mm',
                    en: '134mm x 190mm',
                    ja: '134mm x 190mm',
                    Russian: '134mm x 190mm',
                    Malay: '134mm x 190mm',
                    Turkish: '134mm x 190mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3',
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '100抽',
                    en: '100 Sheets',
                    ja: '100組',
                    Russian: '100 салфеток',
                    Malay: '100 helai',
                    Turkish: '100 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '小鹿系列',
                    en: 'Little Deer Series',
                    ja: '子鹿シリーズ',
                    Russian: 'Серия "Маленький олень"',
                    Malay: 'Siri Little Deer',
                    Turkish: 'Küçük Geyik Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah',
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: 'T/SCSZX 002',
                    ja: 'T/SCSZX 002',
                    Russian: 'T/SCSZX 002',
                    Malay: 'T/SCSZX 002',
                    Turkish: 'T/SCSZX 002'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '2.88元/包',
            //         en: '¥2.88/Pack',
            //         ja: '2.88人民元/パック',
            //         Russian: '2.88 юаня/упаковка',
            //         Malay: '2.88 RMB/pakej'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Household Daily Use',
                    ja: '家庭日常用',
                    Russian: 'Для повседневного домашнего использования',
                    Malay: 'Kegunaan Harian Keluarga',
                    Turkish: 'Günlük Ev Kullanımı'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily household cleaning and wiping.',
                    ja: '家庭の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в домашних условиях',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian keluarga.',
                    Turkish: 'Evde günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Food Service',
                    ja: '飲食サービス用',
                    Russian: 'Для общепита',
                    Malay: 'Perkhidmatan Makanan & Minuman',
                    Turkish: 'Restoran Hizmetleri'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for restaurants, cafes, and similar venues.',
                    ja: 'レストラン、カフェ等で使用可能',
                    Russian: 'Можно использовать в ресторанах, кафе и т.д.',
                    Malay: 'Boleh digunakan di restoran, kafe, dll.',
                    Turkish: 'Restoranlar, kafeler gibi yerlerde kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Business Meeting & Reception',
                    ja: 'ビジネス会議接客用',
                    Russian: 'Для деловых встреч и приёмов',
                    Malay: 'Sambutan Mesyuarat Perniagaan',
                    Turkish: 'İş Toplantıları ve Resepsiyonlar'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Ideal for customized use in offices, meeting rooms, etc.',
                    ja: 'オフィス、会議室等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования в офисах, конференц-залах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di pejabat, bilik mesyuarat, dll.',
                    Turkish: 'Ofisler, toplantı odaları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-007', 'finishedpaper-015', 'finishedpaper-012']
    },
    {
        id: 'finishedpaper-007',
        title: { zh: '“莫迪卡”软抽135', en: '"Modica" Soft Pack Tissues 135', ja: '「莫迪卡」135組ソフトパックティッシュ', Russian: 'Мягкие салфетки "Модика 135"', Malay: 'Tisu Lembut "Merdeka 135"' ,
            Turkish: 'Modica Yumuşak Çekmeli 135'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/MoDiKaRuanChou135.png',
        gallery: ['/images/finishedPaper/MoDiKaRuanChou135.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '无荧光剂添加'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'No Fluorescent Agents Added'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '蛍光剤無添加'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Без добавления флуоресцентных агентов'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Tiada Tambahan Agen Pendarfluor'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Floresan ağartıcı eklenmemiştir'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '135mm x 190mm',
                    en: '135mm x 190mm',
                    ja: '135mm x 190mm',
                    Russian: '135mm x 190mm',
                    Malay: '135mm x 190mm',
                    Turkish: '135mm x 190mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3',
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '120抽',
                    en: '120 Sheets',
                    ja: '120組',
                    Russian: '120 салфеток',
                    Malay: '120 helai',
                    Turkish: '120 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '莫迪卡系列',
                    en: 'Modica Series',
                    ja: '莫迪卡シリーズ',
                    Russian: 'Серия "Модика"',
                    Malay: 'Siri Merdeka',
                    Turkish: 'Modica Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah',
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: 'GB/T 20808',
                    ja: 'GB/T 20808',
                    Russian: 'GB/T 20808',
                    Malay: 'GB/T 20808',
                    Turkish: 'GB/T 20808'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '2.48元/包',
            //         en: '¥2.48/Pack',
            //         ja: '2.48人民元/パック',
            //         Russian: '2.48 юаня/упаковка',
            //         Malay: '2.48 RMB/pakej'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Household Daily Use',
                    ja: '家庭日常用',
                    Russian: 'Для повседневного домашнего использования',
                    Malay: 'Kegunaan Harian Keluarga',
                    Turkish: 'Günlük Ev Kullanımı'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily household cleaning and wiping.',
                    ja: '家庭の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в домашних условиях',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian keluarga.',
                    Turkish: 'Evde günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Food Service',
                    ja: '飲食サービス用',
                    Russian: 'Для общепита',
                    Malay: 'Perkhidmatan Makanan & Minuman',
                    Turkish: 'Restoran Hizmetleri'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for restaurants, cafes, and similar venues.',
                    ja: 'レストラン、カフェ等で使用可能',
                    Russian: 'Можно использовать в ресторанах, кафе и т.д.',
                    Malay: 'Boleh digunakan di restoran, kafe, dll.',
                    Turkish: 'Restoranlar, kafeler gibi yerlerde kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Business Meeting & Reception',
                    ja: 'ビジネス会議接客用',
                    Russian: 'Для деловых встреч и приёмов',
                    Malay: 'Sambutan Mesyuarat Perniagaan',
                    Turkish: 'İş Toplantıları ve Resepsiyonlar'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Ideal for customized use in offices, meeting rooms, etc.',
                    ja: 'オフィス、会議室等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования в офисах, конференц-залах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di pejabat, bilik mesyuarat, dll.',
                    Turkish: 'Ofisler, toplantı odaları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-015', 'finishedpaper-006', 'finishedpaper-012']
    },
    {
        id: 'finishedpaper-008',
        title: { zh: '山水可湿水盒抽', en: 'Shanshui Wet Wipes (Box Pack)', ja: '「山水」ウェットティッシュ対応ボックスティッシュ', Russian: 'Влажные салфетки в коробке "Горный поток"', Malay: 'Tisu Kotak Lembap Banxi' ,
            Turkish: 'Dağ ve Nehir Islatılabilir Kutu Çekmeli'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/ShanShuiKeShiShuiHeChouSuoLve.png',
        gallery: ['/images/finishedPaper/ShanShuiKeShiShuiHeChouSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '无荧光剂添加'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'No Fluorescent Agents Added'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '蛍光剤無添加'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Без добавления флуоресцентных агентов'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Tiada Tambahan Agen Pendarfluor'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Floresan ağartıcı eklenmemiştir'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '185mm x 190mm',
                    en: '185mm x 190mm',
                    ja: '185mm x 190mm',
                    Russian: '185mm x 190mm',
                    Malay: '185mm x 190mm',
                    Turkish: '185mm x 190mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3',
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '120抽',
                    en: '120 Sheets',
                    ja: '120組',
                    Russian: '120 салфеток',
                    Malay: '120 helai',
                    Turkish: '120 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '山水系列',
                    en: 'Shanshui Series',
                    ja: '山水シリーズ',
                    Russian: 'Серия "Горный поток"',
                    Malay: 'Siri Banxi',
                    Turkish: 'Dağ ve Nehir Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah',
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: 'GB/T 20808',
                    ja: 'GB/T 20808',
                    Russian: 'GB/T 20808',
                    Malay: 'GB/T 20808',
                    Turkish: 'GB/T 20808'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '7.5元/包',
            //         en: '¥7.5/Pack',
            //         ja: '7.5人民元/パック',
            //         Russian: '7.5 юаня/упаковка',
            //         Malay: '7.5 RMB/pakej'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务接待',
                    en: 'Business Reception',
                    ja: 'ビジネス接客用',
                    Russian: 'Для деловых приёмов',
                    Malay: 'Sambutan Perniagaan',
                    Turkish: 'İş Toplantıları ve Misafir Ağırlama'
                },
                desc: {
                    zh: '适合商务接待等场所定制化使用',
                    en: 'Ideal for customized use in business reception settings, etc.',
                    ja: 'ビジネス接客等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования на деловых приёмах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di tempat sambutan perniagaan, dll.',
                    Turkish: 'İş resepsiyonları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '办公会议',
                    en: 'Office & Meetings',
                    ja: 'オフィス会議用',
                    Russian: 'Для офисных встреч',
                    Malay: 'Mesyuarat Pejabat',
                    Turkish: 'Ofis Toplantıları'
                },
                desc: {
                    zh: '可用于办公室、会议室等场所',
                    en: 'Suitable for offices, meeting rooms, etc.',
                    ja: 'オフィス、会議室等で使用可能',
                    Russian: 'Можно использовать в офисах, конференц-залах и т.д.',
                    Malay: 'Boleh digunakan di pejabat, bilik mesyuarat, dll.',
                    Turkish: 'Ofisler, toplantı odaları gibi yerlerde kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ChouZhiHuiYiBanGong.png'
            },
            {
                title: {
                    zh: '酒店定制',
                    en: 'Hotel Customization',
                    ja: 'ホテルカスタマイズ用',
                    Russian: 'Индивидуальный заказ для отелей',
                    Malay: 'Tersuai untuk Hotel',
                    Turkish: 'Otel Özelleştirme'
                },
                desc: {
                    zh: '适合酒店等场所定制化使用',
                    en: 'Ideal for customized use in hotels, etc.',
                    ja: 'ホテル等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования в отелях и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di hotel, dll.',
                    Turkish: 'Oteller gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiJiuDian.png'
            }
        ],
        relatedProducts: ['finishedpaper-001', 'finishedpaper-009', 'finishedpaper-013']
    },
    {
        id: 'finishedpaper-009',
        title: { zh: '山水可湿水条巾纸', en: 'Shanshui Wet Towelletes', ja: '「山水」ウェットティッシュ対応スティックパックティッシュ', Russian: 'Влажные полотенца "Горный поток"', Malay: 'Tisu Kertas Bar Lembap Banxi' ,
            Turkish: 'Dağ ve Nehir Islatılabilir Şerit Mendil'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/ShanShuiKeShiShuiTiaoJinZhiSuoLve.png',
        gallery: ['/images/finishedPaper/ShanShuiKeShiShuiTiaoJinZhiSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '包装小巧，方便携带'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'Compact Package, Portable'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '小型包装、携帯便利'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Компактная упаковка, удобно носить с собой'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Pembungkusan Kecil & Mudah Dibawa'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Kompakt ambalaj, taşıması kolay'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '200mm x 200mm',
                    ja: '200mm x 200mm',
                    Russian: '200mm x 200mm',
                    Malay: '200mm x 200mm',
                    Turkish: '200mm x 200mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3',
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '12片',
                    en: '12 Sheets',
                    ja: '12枚入り',
                    Russian: '12 штук',
                    Malay: '12 keping',
                    Turkish: '12 Adet'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '山水系列',
                    en: 'Shanshui Series',
                    ja: '山水シリーズ',
                    Russian: 'Серия "Горный поток"',
                    Malay: 'Siri Banxi',
                    Turkish: 'Dağ ve Nehir Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah',
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20810',
                    en: 'GB/T 20810',
                    ja: 'GB/T 20810',
                    Russian: 'GB/T 20810',
                    Malay: 'GB/T 20810',
                    Turkish: 'GB/T 20810'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '1.5元/包',
            //         en: '¥1.5/Pack',
            //         ja: '1.5人民元/パック',
            //         Russian: '1.5 юаня/упаковка',
            //         Malay: '1.5 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议',
                    en: 'Business Meetings',
                    ja: 'ビジネス会議用',
                    Russian: 'Для деловых встреч',
                    Malay: 'Mesyuarat Perniagaan',
                    Turkish: 'İş Toplantıları'
                },
                desc: {
                    zh: '适合商务会议等场所定制化使用',
                    en: 'Ideal for customized use in business meetings, etc.',
                    ja: 'ビジネス会議等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования на деловых встречах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di mesyuarat perniagaan, dll.',
                    Turkish: 'İş toplantıları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Business Travel Portable',
                    ja: '出張携帯用',
                    Russian: 'Для командировок',
                    Malay: 'Mudah Alih untuk Perjalanan Dinas',
                    Turkish: 'İş Seyahati için Taşınabilir'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Portable for business travel, airports, high-speed rail stations, etc.',
                    ja: '出張、空港・高速鉄道駅等での携帯使用に便利',
                    Russian: 'Можно брать с собой в командировки, аэропорты, на вокзалы и т.д.',
                    Malay: 'Boleh digunakan untuk kegunaan mudah alih semasa perjalanan dinas, lapangan terbang, stesen HSR, dll.',
                    Turkish: 'İş seyahatleri, havaalanları, yüksek hızlı tren istasyonları gibi yerlerde taşınabilir kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Compact for Travel',
                    ja: '旅行携帯用',
                    Russian: 'Для путешествий',
                    Malay: 'Mudah Alih untuk Pelancongan',
                    Turkish: 'Turistik Seyahat için Taşınabilir'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Suitable for portable use during travel, camping, etc.',
                    ja: '旅行、キャンプ等の携帯使用に最適',
                    Russian: 'Подходит для путешествий, кемпинга и т.д.',
                    Malay: 'Sesuai untuk kegunaan mudah alih semasa pelancongan, perkhemahan, dll.',
                    Turkish: 'Turizm, kampçılık gibi taşınabilir kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-001', 'finishedpaper-008', 'finishedpaper-013']
    },
    {
        id: 'finishedpaper-010',
        title: { zh: '哪吒条巾纸', en: 'Nezha Towelletes', ja: '「哪吒」スティックパックティッシュ', Russian: 'Полотенца "Нечжа"', Malay: 'Tisu Kertas Bar Nezha' ,Turkish: 'Nezha Şerit Mendil'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/NeZhaTiaoJinZhiSuoLve.png',
        gallery: ['/images/finishedPaper/NeZhaTiaoJinZhiSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '包装小巧，方便携带'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'Compact Package, Portable'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '小型包装、携帯便利'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Компактная упаковка, удобно носить с собой'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Pembungkusan Kecil & Mudah Dibawa'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Kompakt ambalaj, taşıması kolay'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '200mm x 200mm',
                    ja: '200mm x 200mm',
                    Russian: '200mm x 200mm',
                    Malay: '200mm x 200mm',
                    Turkish: '200mm x 200mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3',
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '12片',
                    en: '12 Sheets',
                    ja: '12枚入り',
                    Russian: '12 штук',
                    Malay: '12 keping',
                    Turkish: '12 Adet'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '哪吒系列',
                    en: 'Nezha Series',
                    ja: '哪吒シリーズ',
                    Russian: 'Серия "Нечжа"',
                    Malay: 'Siri Nezha',
                    Turkish: 'Nezha Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah',
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20810',
                    en: 'GB/T 20810',
                    ja: 'GB/T 20810',
                    Russian: 'GB/T 20810',
                    Malay: 'GB/T 20810',
                    Turkish: 'GB/T 20810'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '1.5元/包',
            //         en: '¥1.5/Pack',
            //         ja: '1.5人民元/パック',
            //         Russian: '1.5 юаня/упаковка',
            //         Malay: '1.5 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议',
                    en: 'Business Meetings',
                    ja: 'ビジネス会議用',
                    Russian: 'Для деловых встреч',
                    Malay: 'Mesyuarat Perniagaan',
                    Turkish: 'İş Toplantıları'
                },
                desc: {
                    zh: '适合商务会议等场所定制化使用',
                    en: 'Ideal for customized use in business meetings, etc.',
                    ja: 'ビジネス会議等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования на деловых встречах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di mesyuarat perniagaan, dll.',
                    Turkish: 'İş toplantıları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Business Travel Portable',
                    ja: '出張携帯用',
                    Russian: 'Для командировок',
                    Malay: 'Mudah Alih untuk Perjalanan Dinas',
                    Turkish: 'İş Seyahati için Taşınabilir'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Portable for business travel, airports, high-speed rail stations, etc.',
                    ja: '出張、空港・高速鉄道駅等での携帯使用に便利',
                    Russian: 'Можно брать с собой в командировки, аэропорты, на вокзалы и т.д.',
                    Malay: 'Boleh digunakan untuk kegunaan mudah alih semasa perjalanan dinas, lapangan terbang, stesen HSR, dll.',
                    Turkish: 'İş seyahatleri, havaalanları, yüksek hızlı tren istasyonları gibi yerlerde taşınabilir kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Compact for Travel',
                    ja: '旅行携帯用',
                    Russian: 'Для путешествий',
                    Malay: 'Mudah Alih untuk Pelancongan',
                    Turkish: 'Turistik Seyahat için Taşınabilir'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Suitable for portable use during travel, camping, etc.',
                    ja: '旅行、キャンプ等の携帯使用に最適',
                    Russian: 'Подходит для путешествий, кемпинга и т.д.',
                    Malay: 'Sesuai untuk kegunaan mudah alih semasa pelancongan, perkhemahan, dll.',
                    Turkish: 'Turizm, kampçılık gibi taşınabilir kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-004', 'finishedpaper-005', 'finishedpaper-012']
    },
    {
        id: 'finishedpaper-011',
        title: { zh: '竹韵手帕纸', en: 'Zhuyun Pocket Tissues', ja: '「竹韻」ハンカチティッシュ', Russian: 'Носовые платки "Бамбуковая мелодия"', Malay: 'Tisu Sapu Tangan Bamboo Rhythm' ,Turkish: 'Bambu Melodisi Mendil Kağıdı'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/ZhuYunShouPaZhi.png',
        gallery: ['/images/finishedPaper/ZhuYunShouPaZhi.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '包装小巧，方便携带'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'Compact Package, Portable'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '小型包装、携帯便利'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Компактная упаковка, удобно носить с собой'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Pembungkusan Kecil & Mudah Dibawa'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Kompakt ambalaj, taşıması kolay'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '210mm x 210mm',
                    en: '210mm x 210mm',
                    ja: '210mm x 210mm',
                    Russian: '210mm x 210mm',
                    Malay: '210mm x 210mm',
                    Turkish: '210mm x 210mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '4',
                    en: '4',
                    ja: '4',
                    Russian: '4',
                    Malay: '4',
                    Turkish: '4'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '12片',
                    en: '12 Sheets',
                    ja: '12枚入り',
                    Russian: '12 штук',
                    Malay: '12 keping',
                    Turkish: '12 Adet'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '竹韵系列',
                    en: 'Zhuyun Series',
                    ja: '竹韻シリーズ',
                    Russian: 'Серия "Бамбуковая мелодия"',
                    Malay: 'Siri Bamboo Rhythm',
                    Turkish: 'Bambu Melodisi Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah',
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: 'T/SCSZX 002',
                    ja: 'T/SCSZX 002',
                    Russian: 'T/SCSZX 002',
                    Malay: 'T/SCSZX 002',
                    Turkish: 'T/SCSZX 002'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '0.75元/包',
            //         en: '¥0.75/Pack',
            //         ja: '0.75人民元/パック',
            //         Russian: '0.75 юаня/упаковка',
            //         Malay: '0.75 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议',
                    en: 'Business Meetings',
                    ja: 'ビジネス会議用',
                    Russian: 'Для деловых встреч',
                    Malay: 'Mesyuarat Perniagaan',
                    Turkish: 'İş Toplantıları'
                },
                desc: {
                    zh: '适合商务会议等场所定制化使用',
                    en: 'Ideal for customized use in business meetings, etc.',
                    ja: 'ビジネス会議等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования на деловых встречах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di mesyuarat perniagaan, dll.',
                    Turkish: 'İş toplantıları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Business Travel Portable',
                    ja: '出張携帯用',
                    Russian: 'Для командировок',
                    Malay: 'Mudah Alih untuk Perjalanan Dinas',
                    Turkish: 'İş Seyahati için Taşınabilir'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Portable for business travel, airports, high-speed rail stations, etc.',
                    ja: '出張、空港・高速鉄道駅等での携帯使用に便利',
                    Russian: 'Можно брать с собой в командировки, аэропорты, на вокзалы и т.д.',
                    Malay: 'Boleh digunakan untuk kegunaan mudah alih semasa perjalanan dinas, lapangan terbang, stesen HSR, dll.',
                    Turkish: 'İş seyahatleri, havaalanları, yüksek hızlı tren istasyonları gibi yerlerde taşınabilir kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Compact for Travel',
                    ja: '旅行携帯用',
                    Russian: 'Для путешествий',
                    Malay: 'Mudah Alih untuk Pelancongan',
                    Turkish: 'Turistik Seyahat için Taşınabilir'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Suitable for portable use during travel, camping, etc.',
                    ja: '旅行、キャンプ等の携帯使用に最適',
                    Russian: 'Подходит для путешествий, кемпинга и т.д.',
                    Malay: 'Sesuai untuk kegunaan mudah alih semasa pelancongan, perkhemahan, dll.',
                    Turkish: 'Turizm, kampçılık gibi taşınabilir kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-002', 'finishedpaper-003', 'finishedpaper-014']
    },
    {
        id: 'finishedpaper-012',
        title: { zh: '“花样年华"条巾纸', en: '"Blooming Years" Towelletes', ja: '「花様年華」スティックパックティッシュ', Russian: 'Полотенца "Цветущая молодость"', Malay: 'Tisu Kertas Bar "In the Mood for Love"' ,
            Turkish: 'Çiçekli Yıllar Şerit Mendil'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/HuaYangNianHuaTiaoJinZhiSuoLve.png',
        gallery: ['/images/finishedPaper/HuaYangNianHuaTiaoJinZhiSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '包装小巧，方便携带'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Super Absorbent',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'Compact Package, Portable'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '超強力吸水性能',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '小型包装、携帯便利'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Сверхвысокая впитывающая способность',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Компактная упаковка, удобно носить с собой'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Prestasi Penyerapan Air Luar Biasa',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Pembungkusan Kecil & Mudah Dibawa'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Süper güçlü su emme özelliği',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Kompakt ambalaj, taşıması kolay'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '200mm x 200mm',
                    ja: '200mm x 200mm',
                    Russian: '200mm x 200mm',
                    Malay: '200mm x 200mm',
                    Turkish: '200mm x 200mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3',
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '12片',
                    en: '12 Sheets',
                    ja: '12枚入り',
                    Russian: '12 штук',
                    Malay: '12 keping',
                    Turkish: '12 Adet'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '经典系列',
                    en: 'Classic Series',
                    ja: 'クラシックシリーズ',
                    Russian: 'Классическая серия',
                    Malay: 'Siri Klasik',
                    Turkish: 'Klasik Seri'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '干湿两用',
                    en: 'Dual Use (Dry & Wet)',
                    ja: 'ドライ・ウェット両用',
                    Russian: 'Для сухого и влажного использования',
                    Malay: 'Kegunaan Kering & Basah',
                    Turkish: 'Kuru ve Islak Kullanım'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: 'T/SCSZX 002',
                    ja: 'T/SCSZX 002',
                    Russian: 'T/SCSZX 002',
                    Malay: 'T/SCSZX 002',
                    Turkish: 'T/SCSZX 002'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '1元/包',
            //         en: '¥1/Pack',
            //         ja: '1人民元/パック',
            //         Russian: '1 юаня/упаковка',
            //         Malay: '1 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议',
                    en: 'Business Meetings',
                    ja: 'ビジネス会議用',
                    Russian: 'Для деловых встреч',
                    Malay: 'Mesyuarat Perniagaan',
                    Turkish: 'İş Toplantıları'
                },
                desc: {
                    zh: '适合商务会议等场所定制化使用',
                    en: 'Ideal for customized use in business meetings, etc.',
                    ja: 'ビジネス会議等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования на деловых встречах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di mesyuarat perniagaan, dll.',
                    Turkish: 'İş toplantıları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Business Travel Portable',
                    ja: '出張携帯用',
                    Russian: 'Для командировок',
                    Malay: 'Mudah Alih untuk Perjalanan Dinas',
                    Turkish: 'İş Seyahati için Taşınabilir'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Portable for business travel, airports, high-speed rail stations, etc.',
                    ja: '出張、空港・高速鉄道駅等での携帯使用に便利',
                    Russian: 'Можно брать с собой в командировки, аэропорты, на вокзалы и т.д.',
                    Malay: 'Boleh digunakan untuk kegunaan mudah alih semasa perjalanan dinas, lapangan terbang, stesen HSR, dll.',
                    Turkish: 'İş seyahatleri, havaalanları, yüksek hızlı tren istasyonları gibi yerlerde taşınabilir kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Compact for Travel',
                    ja: '旅行携帯用',
                    Russian: 'Для путешествий',
                    Malay: 'Mudah Alih untuk Pelancongan',
                    Turkish: 'Turistik Seyahat için Taşınabilir'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Suitable for portable use during travel, camping, etc.',
                    ja: '旅行、キャンプ等の携帯使用に最適',
                    Russian: 'Подходит для путешествий, кемпинга и т.д.',
                    Malay: 'Sesuai untuk kegunaan mudah alih semasa pelancongan, perkhemahan, dll.',
                    Turkish: 'Turizm, kampçılık gibi taşınabilir kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-009', 'finishedpaper-010', 'finishedpaper-011']
    },
    {
        id: 'finishedpaper-013',
        title: { zh: '山水速溶卷纸', en: 'Shanshui Dissolving Toilet Paper', ja: '「山水」速溶トイレットペーパー', Russian: 'Быстрорастворимая рулонная бумага "Горный поток"', Malay: 'Tisu Gulung Larut Air Banxi' ,
            Turkish: 'Dağ ve Nehir Hızlı Çözünen Rulo Kağıt'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/ShanShuiSuRongJuanZhiSuoLve.png',
        gallery: ['/images/finishedPaper/ShanShuiSuRongJuanZhiSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '柔软亲肤',
                '环保可降解',
                '冲水速溶'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'Quick-Dissolving in Water'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '水解性・速溶性'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Быстро растворяется при смыве'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Larut Segera semasa Siraman'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Dağ ve Nehir Hızlı Çözünen Rulo Kağıt'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '108mm x 138mm/节',
                    en: '108mm x 138mm/Sheet',
                    ja: '108mm x 138mm/カット',
                    Russian: '108 мм x 138 мм/лист',
                    Malay: '108mm x 138mm/segmen',
                    Turkish: '108mm x 138mm/segmen'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '4',
                    en: '4',
                    ja: '4',
                    Russian: '4',
                    Malay: '4',
                    Turkish: '4'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '山水系列',
                    en: 'Shanshui Series',
                    ja: '山水シリーズ',
                    Russian: 'Серия "Горный поток"',
                    Malay: 'Siri Banxi',
                    Turkish: 'Dağ ve Nehir Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '冲水速溶',
                    en: 'Quick-Dissolving in Water',
                    ja: '水解性・速溶性',
                    Russian: 'Быстро растворяется при смыве',
                    Malay: 'Larut Segera semasa Siraman',
                    Turkish: 'Suda Hızlı Çözünme'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20810',
                    en: 'GB/T 20810',
                    ja: 'GB/T 20810',
                    Russian: 'GB/T 20810',
                    Malay: 'GB/T 20810',
                    Turkish: 'GB/T 20810'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '3.5元/卷 ',
            //         en: '¥3.5/Roll',
            //         ja: '3.5人民元/ロール',
            //         Russian: '3.5 юаня/рулон',
            //         Malay: '3.5 RMB/gulung',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '洗手间清洁',
                    en: 'Bathroom Cleaning',
                    ja: 'トイレ清掃用',
                    Russian: 'Для уборки в туалетах',
                    Malay: 'Pembersihan Tandas',
                    Turkish: 'Tuvalet Temizliği'
                },
                desc: {
                    zh: '适用于厕所、洗手间日常清洁擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in toilets and bathrooms.',
                    ja: 'トイレ、お手洗いの日常清掃・拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в туалетах',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian tandas.',
                    Turkish: 'Tuvaletler, banyolar için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/JuanZhiCeSuo.png'
            },
            {
                title: {
                    zh: '个人卫生清洁',
                    en: 'Personal Hygiene',
                    ja: '個人衛生清掃用',
                    Russian: 'Для личной гигиены',
                    Malay: 'Pembersihan Kebersihan Peribadi',
                    Turkish: 'Kişisel Hijyen Temizliği'
                },
                desc: {
                    zh: '可用于个人卫生清洁',
                    en: 'Suitable for personal hygiene',
                    ja: '個人衛生清掃に使用可能',
                    Russian: 'Можно использовать для личной гигиены',
                    Malay: 'Boleh digunakan untuk pembersihan kebersihan peribadi.',
                    Turkish: 'Kişisel hijyen temizliği için kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/JuanZhiGeRenQingJie.png'
            }
        ],
        relatedProducts: ['finishedpaper-001', 'finishedpaper-008', 'finishedpaper-009']
    },
    {
        id: 'finishedpaper-014',
        title: { zh: '竹韵无芯卷纸', en: 'Zhuyun Coreless Toilet Roll', ja: '「竹韻」芯なしトイレットペーパー', Russian: 'Рулонная бумага без втулки "Бамбуковая мелодия"', Malay: 'Tisu Gulung Tiada Teras Bamboo Rhythm' ,
            Turkish: 'Bambu Melodisi Çekirdeksiz Rulo Kağıt'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/ZhuYunWuXinJuanZhiSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuYunWuXinJuanZhiSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '柔软亲肤',
                '环保可降解',
                '冲水速溶'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'Quick-Dissolving in Water'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '水解性・速溶性'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Быстро растворяется при смыве'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Larut Segera semasa Siraman'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Dağ ve Nehir Hızlı Çözünen Rulo Kağıt'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '108mm x 138mm/节',
                    en: '108mm x 138mm/Sheet',
                    ja: '108mm x 138mm/カット',
                    Russian: '108 мм x 138 мм/лист',
                    Malay: '108mm x 138mm/segmen',
                    Turkish: '108mm x 138mm/Bölüm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '4',
                    en: '4',
                    ja: '4',
                    Russian: '4',
                    Malay: '4',
                    Turkish: '4'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '竹韵系列',
                    en: 'Zhuyun Series',
                    ja: '竹韻シリーズ',
                    Russian: 'Серия "Бамбуковая мелодия"',
                    Malay: 'Siri Bamboo Rhythm',
                    Turkish: 'Bambu Melodisi Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '冲水速溶',
                    en: 'Quick-Dissolving in Water',
                    ja: '水解性・速溶性',
                    Russian: 'Быстро растворяется при смыве',
                    Malay: 'Larut Segera semasa Siraman',
                    Turkish: 'Suda Hızlı Çözünme'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: 'T/SCSZX 002',
                    ja: 'T/SCSZX 002',
                    Russian: 'T/SCSZX 002',
                    Malay: 'T/SCSZX 002',
                    Turkish: 'T/SCSZX 002'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '3.1元/卷 ',
            //         en: '¥3.1/Roll',
            //         ja: '3.1人民元/ロール',
            //         Russian: '3.1 юаня/рулон',
            //         Malay: '3.1 RMB/gulung',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '洗手间清洁',
                    en: 'Bathroom Cleaning',
                    ja: 'トイレ清掃用',
                    Russian: 'Для уборки в туалетах',
                    Malay: 'Pembersihan Tandas',
                    Turkish: 'Tuvalet Temizliği'
                },
                desc: {
                    zh: '适用于厕所、洗手间日常清洁擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in toilets and bathrooms.',
                    ja: 'トイレ、お手洗いの日常清掃・拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в туалетах',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian tandas.',
                    Turkish: 'Tuvaletler, banyolar için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/JuanZhiCeSuo.png'
            },
            {
                title: {
                    zh: '个人卫生清洁',
                    en: 'Personal Hygiene',
                    ja: '個人衛生清掃用',
                    Russian: 'Для личной гигиены',
                    Malay: 'Pembersihan Kebersihan Peribadi',
                    Turkish: 'Kişisel Hijyen Temizliği'
                },
                desc: {
                    zh: '可用于个人卫生清洁',
                    en: 'Suitable for personal hygiene',
                    ja: '個人衛生清掃に使用可能',
                    Russian: 'Можно использовать для личной гигиены',
                    Malay: 'Boleh digunakan untuk pembersihan kebersihan peribadi.',
                    Turkish: 'Kişisel hijyen temizliği için kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/JuanZhiGeRenQingJie.png'
            }
        ],
        relatedProducts: ['finishedpaper-002', 'finishedpaper-003', 'finishedpaper-011']
    },
    {
        id: 'finishedpaper-015',
        title: { zh: '“莫迪卡”卷纸', en: '"Modica" Toilet Roll', ja: '「莫迪卡」トイレットペーパー', Russian: 'Рулонная бумага "Модика"', Malay: 'Tisu Gulung "Merdeka"' ,Turkish: 'Modica Rulo Kağıt'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/MoDiKaJuanZhi.png',
        gallery: ['/images/finishedPaper/MoDiKaJuanZhi.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '柔软亲肤',
                '环保可降解',
                '冲水速溶'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Soft & Skin-Friendly',
                'Eco-Friendly & Biodegradable',
                'Quick-Dissolving in Water'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                'ソフトで肌に優しい',
                '環境配慮型・生分解性',
                '水解性・速溶性'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Мягкие и нежные для кожи',
                'Экологичные и биоразлагаемые',
                'Быстро растворяется при смыве'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Lembut & Mesra Kulit',
                'Mesra Alam & Boleh Terurai',
                'Larut Segera semasa Siraman'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Yumuşak ve cilt dostu',
                'Çevre dostu ve biyobozunur',
                'Dağ ve Nehir Hızlı Çözünen Rulo Kağıt'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '108mm x 138mm/节',
                    en: '108mm x 138mm/Sheet',
                    ja: '108mm x 138mm/カット',
                    Russian: '108 мм x 138 мм/лист',
                    Malay: '108mm x 138mm/segmen',
                    Turkish: '108mm x 138mm/Bölüm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '4',
                    en: '4',
                    ja: '4',
                    Russian: '4',
                    Malay: '4',
                    Turkish: '4'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '莫迪卡系列',
                    en: 'Modica Series',
                    ja: '莫迪卡シリーズ',
                    Russian: 'Серия "Модика"',
                    Malay: 'Siri Merdeka',
                    Turkish: 'Modica Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '冲水速溶',
                    en: 'Quick-Dissolving in Water',
                    ja: '水解性・速溶性',
                    Russian: 'Быстро растворяется при смыве',
                    Malay: 'Larut Segera semasa Siraman',
                    Turkish: 'Suda Hızlı Çözünme'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20810',
                    en: 'GB/T 20810',
                    ja: 'GB/T 20810',
                    Russian: 'GB/T 20810',
                    Malay: 'GB/T 20810',
                    Turkish: 'GB/T 20810'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '3.1元/卷 ',
            //         en: '¥3.1/Roll',
            //         ja: '3.1人民元/ロール',
            //         Russian: '3.1 юаня/рулон',
            //         Malay: '3.1 RMB/gulung',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '洗手间清洁',
                    en: 'Bathroom Cleaning',
                    ja: 'トイレ清掃用',
                    Russian: 'Для уборки в туалетах',
                    Malay: 'Pembersihan Tandas',
                    Turkish: 'Tuvalet Temizliği'
                },
                desc: {
                    zh: '适用于厕所、洗手间日常清洁擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in toilets and bathrooms.',
                    ja: 'トイレ、お手洗いの日常清掃・拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки в туалетах',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian tandas.',
                    Turkish: 'Tuvaletler, banyolar için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/JuanZhiCeSuo.png'
            },
            {
                title: {
                    zh: '个人卫生清洁',
                    en: 'Personal Hygiene',
                    ja: '個人衛生清掃用',
                    Russian: 'Для личной гигиены',
                    Malay: 'Pembersihan Kebersihan Peribadi',
                    Turkish: 'Kişisel Hijyen Temizliği'
                },
                desc: {
                    zh: '可用于个人卫生清洁',
                    en: 'Suitable for personal hygiene',
                    ja: '個人衛生清掃に使用可能',
                    Russian: 'Можно использовать для личной гигиены',
                    Malay: 'Boleh digunakan untuk pembersihan kebersihan peribadi.',
                    Turkish: 'Kişisel hijyen temizliği için kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/JuanZhiGeRenQingJie.png'
            }
        ],
        relatedProducts: ['finishedpaper-007', 'finishedpaper-013', 'finishedpaper-014']
    },
    {
        id: 'finishedpaper-016',
        title: { zh: '厨房抽纸', en: 'Kitchen Towels', ja: 'キッチンペーパータオル', Russian: 'Кухонные салфетки', Malay: 'Tisu Tarik Dapur' ,Turkish: 'Mutfak Çekmeli Kağıt'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/ChuFangChouZhiSuoLve.png',
        gallery: ['/images/finishedPaper/ChuFangChouZhiSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '不漂白、无荧光',
                '七大油污双倍洁净',
                '擦碗擦桌不掉渣'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'Unbleached, No Fluorescent Agents',
                'Double Strength Cleaning for 7 Types of Grease & Stains',
                'Lint-Free for Wiping Dishes & Tables'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                '無漂白、蛍光剤不使用',
                '7大油汚れにダブルクリーニング',
                '食器・テーブル拭きで糸くずが出ない'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Без отбеливания и флуоресцентных агентов',
                'Двойная очистка от семи видов жира',
                'Не оставляет ворсинок при протирании посуды и столов'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Tanpa Pelunturan & Tiada Pendarfluor',
                'Tujuh Jenis Minyak, Kebersihan Berganda',
                'Mengelap Mangkuk & Meja Tanpa Runtuhan Serpihan'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'Ağartılmamış, floresans içermez',
                'Yedi Büyük Yağ Lekesine Karşı Çift Temizlik',
                'Tabak ve masa silerken kırıntı bırakmaz'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food-Grade Certified',
                    ja: '食品グレード認証',
                    Russian: 'Маркировка "Пищевая продукция" — безопасно для контакта с пищей',
                    Malay: 'Pensijilan Gred Makanan',
                    Turkish: 'Gıda Sınıfı Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '198mm x 210mm',
                    en: '198mm x 210mm',
                    ja: '198mm x 210mm',
                    Russian: '198mm x 210mm',
                    Malay: '198mm x 210mm',
                    Turkish: '198mm x 210mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '2',
                    en: '2',
                    ja: '2',
                    Russian: '2',
                    Malay: '2',
                    Turkish: '2'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '80抽',
                    en: '80 Sheets',
                    ja: '80組',
                    Russian: '80 салфеток',
                    Malay: '80 helai',
                    Turkish: '80 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '厨卫系列',
                    en: 'Kitchen & Bath Series',
                    ja: 'キッチン・バスシリーズ',
                    Russian: 'Серия для кухни и ванной',
                    Malay: 'Siri Dapur & Tandas',
                    Turkish: 'Mutfak ve Banyo Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '吸油吸水',
                    en: 'Oil & Water Absorbent',
                    ja: '吸油・吸水',
                    Russian: 'Впитывает жир и воду',
                    Malay: 'Penyerap Minyak & Air',
                    Turkish: 'Yağ ve Su Emici'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: 'T/SCSZX 002',
                    ja: 'T/SCSZX 002',
                    Russian: 'T/SCSZX 002',
                    Malay: 'T/SCSZX 002',
                    Turkish: 'T/SCSZX 002'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '6元/包',
            //         en: '¥6/Pack',
            //         ja: '6人民元/パック',
            //         Russian: '6 юаня/упаковка',
            //         Malay: '6 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '厨房使用',
                    en: 'Kitchen Use',
                    ja: 'キッチン用',
                    Russian: 'Для использования на кухне',
                    Malay: 'Kegunaan Dapur',
                    Turkish: 'Mutfak Kullanımı'
                },
                desc: {
                    zh: '适用于厨房日常清洁、擦拭等用途',
                    en: 'Suitable for daily kitchen cleaning and wiping.',
                    ja: 'キッチンの日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной уборки и очистки на кухне',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian dapur.',
                    Turkish: 'Mutfakta günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChuFangChouZhiChuFang.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Food Service',
                    ja: '飲食サービス用',
                    Russian: 'Для общепита',
                    Malay: 'Perkhidmatan Makanan & Minuman',
                    Turkish: 'Restoran Hizmetleri'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for restaurants, cafes, and similar venues.',
                    ja: 'レストラン、カフェ等で使用可能',
                    Russian: 'Можно использовать в ресторанах, кафе и т.д.',
                    Malay: 'Boleh digunakan di restoran, kafe, dll.',
                    Turkish: 'Restoranlar, kafeler gibi yerlerde kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '酒店定制',
                    en: 'Hotel Customization',
                    ja: 'ホテルカスタマイズ用',
                    Russian: 'Индивидуальный заказ для отелей',
                    Malay: 'Tersuai untuk Hotel',
                    Turkish: 'Otel Özelleştirme'
                },
                desc: {
                    zh: '适合酒店等场所定制化使用',
                    en: 'Ideal for customized use in hotels, etc.',
                    ja: 'ホテル等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования в отелях и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di hotel, dll.',
                    Turkish: 'Oteller gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/ChouZhiJiuDian.png'
            }
        ],
        relatedProducts: ['finishedpaper-017', 'finishedpaper-018', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-017',
        title: { zh: '小盘纸', en: 'Small Roll Towels', ja: '業務用トイレットペーパー', Russian: 'Маленькие рулончики', Malay: 'Tisu Cakera Kecil' ,Turkish: 'Küçük Tabak Kağıdı'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/XiaoPanZhiSuoLve.png',
        gallery: ['/images/finishedPaper/XiaoPanZhiSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '符合FSC认证',
                '不堵厕所',
                '冲水速溶'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'FSC Certified',
                'Toilet-Safe (Non-Clogging)',
                'Quick-Dissolving in Water'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                'FSC認証適合',
                'トイレ詰まり防止',
                '水解性・速溶性'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Соответствует сертификации FSC',
                'Не засоряет канализацию',
                'Быстро растворяется при смыве'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Mematuhi Pensijilan FSC',
                'Tidak Menyumbat Tandas',
                'Larut Segera semasa Siraman'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'FSC Sertifikalı',
                'Tuvaleti Tıkamaz',
                'Güçlü Su Emme'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '94mm x 120mm',
                    en: '94mm x 120mm',
                    ja: '94mm x 120mm',
                    Russian: '94mm x 120mm',
                    Malay: '94mm x 120mm',
                    Turkish: '94mm x 120mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '3',
                    en: '3',
                    ja: '3',
                    Russian: '3',
                    Malay: '3',
                    Turkish: '3'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '1380节',
                    en: '1380 Sheet',
                    ja: '1380 カット',
                    Russian: '1380 лист',
                    Malay: '1380 segmen',
                    Turkish: '1380 Bölüm'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '厨卫系列',
                    en: 'Kitchen & Bath Series',
                    ja: 'キッチン・バスシリーズ',
                    Russian: 'Серия для кухни и ванной',
                    Malay: 'Siri Dapur & Tandas',
                    Turkish: 'Mutfak ve Banyo Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '吸水性强',
                    en: 'High Absorbency ',
                    ja: '高吸水性',
                    Russian: 'Высокая впитывающая способность',
                    Malay: 'Keupayaan Penyerapan Air Yang Kuat',
                    Turkish: 'Güçlü Su Emme'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: 'T/SCSZX 002',
                    ja: 'T/SCSZX 002',
                    Russian: 'T/SCSZX 002',
                    Malay: 'T/SCSZX 002',
                    Turkish: 'T/SCSZX 002'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '13.6元/卷 ',
            //         en: '¥13.6/Roll',
            //         ja: '13.6人民元/ロール',
            //         Russian: '13.6 юаня/рулон',
            //         Malay: '13.6 RMB/gulung',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '公共卫生间',
                    en: 'Public Restrooms',
                    ja: '公共トイレ用',
                    Russian: 'Для общественных туалетов',
                    Malay: 'Tandas Awam',
                    Turkish: 'Umumi Tuvaletler'
                },
                desc: {
                    zh: '适用于公共卫生间区域、厕所等',
                    en: 'Suitable for public restroom areas, toilets, etc.',
                    ja: '公共トイレエリア、お手洗い等に適応',
                    Russian: 'Подходит для общественных туалетов и подобных мест',
                    Malay: 'Sesuai untuk kawasan tandas awam, tandas, dll.',
                    Turkish: 'Umumi tuvalet alanları, tuvaletler gibi yerler için uygundur.'
                },
                img: '/images/ApplicationScenarios/XiaoPanZhiCeSuo.png'
            }
        ],
        relatedProducts: ['finishedpaper-016', 'finishedpaper-018', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-018',
        title: { zh: '擦手纸', en: 'Hand Towels', ja: 'ペーパータオル', Russian: 'Бумажные полотенца для рук', Malay: 'Tisu Tangan' ,Turkish: 'El Kurulama Kağıdı'},
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'Virgin Bamboo Pulp, Green & Healthy',
            ja: 'バージン竹パルプ、グリーンで健康的',
            Russian: 'Натуральная бамбуковая целлюлоза, экологично и полезно для здоровья',
            Malay: 'Pulpa Buluh Asli, Hijau & Sihat',
            Turkish: 'Ham bambu hamuru, yeşil ve sağlıklı'
        },
        img: '/images/finishedPaper/CaShouZhiSuoLve.png',
        gallery: ['/images/finishedPaper/CaShouZhiSuoLve.png'],
        features: {
            zh: [
                '100%原生竹浆制造',
                '符合FSC认证',
                '吸水性强',
                '不掉渣不掉屑'
            ],
            en: [
                'Made from 100% Vrigin Bamboo Pulp',
                'FSC Certified',
                'High Absorbency',
                'Lint-Free & Dust-Free'
            ],
            ja: [
                '100%バージン竹パルプ製造',
                'FSC認証適合',
                '高吸水性',
                '糸くず・紙粉が出ない'
            ],
            Russian: [
                'Изготовлено из 100% натуральной бамбуковой целлюлозы',
                'Соответствует сертификации FSC',
                'Высокая впитывающая способность',
                'Не оставляет ворсинок и частиц'
            ],
            Malay: [
                'Diperbuat daripada 100% Pulpa Buluh Asli',
                'Mematuhi Pensijilan FSC',
                'Keupayaan Penyerapan Air Yang Kuat',
                'Tiada Runtuhan Serpihan'
            ],
            Turkish: [
                '%100 ham bambu hamurundan üretilmiştir',
                'FSC Sertifikalı',
                'Güçlü Su Emme',
                'Kırıntı ve Toz Bırakmaz'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '竹浆本色',
                    en: 'Natural Bamboo Color',
                    ja: '竹パルプ自然色',
                    Russian: 'Натуральный цвет бамбуковой целлюлозы',
                    Malay: 'Warna Semula Jadi Buluh',
                    Turkish: 'Bambu Hamuru Doğal Rengi'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '225mm x 225mm',
                    en: '225mm x 225mm',
                    ja: '225mm x 225mm',
                    Russian: '225mm x 225mm',
                    Malay: '225mm x 225mm',
                    Turkish: '225mm x 225mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '1',
                    en: '1',
                    ja: '1',
                    Russian: '1',
                    Malay: '1',
                    Turkish: '1'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '200张',
                    en: '200 Sheets',
                    ja: '200枚',
                    Russian: '200 листов',
                    Malay: '200 keping',
                    Turkish: '200 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '厨卫系列',
                    en: 'Kitchen & Bath Series',
                    ja: 'キッチン・バスシリーズ',
                    Russian: 'Серия для кухни и ванной',
                    Malay: 'Siri Dapur & Tandas',
                    Turkish: 'Mutfak ve Banyo Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '吸水性强',
                    en: 'High Absorbency ',
                    ja: '高吸水性',
                    Russian: 'Высокая впитывающая способность',
                    Malay: 'Keupayaan Penyerapan Air Yang Kuat',
                    Turkish: 'Güçlü Su Emme'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: 'T/SCSZX 002',
                    ja: 'T/SCSZX 002',
                    Russian: 'T/SCSZX 002',
                    Malay: 'T/SCSZX 002',
                    Turkish: 'T/SCSZX 002'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '7.6元/包',
            //         en: '¥7.6/Pack',
            //         ja: '7.6人民元/パック',
            //         Russian: '7.6 юаня/упаковка',
            //         Malay: '7.6 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '卫生间',
                    en: 'Restrooms',
                    ja: 'お手洗い用',
                    Russian: 'Для туалетов',
                    Malay: 'Tandas',
                    Turkish: 'Banyo'
                },
                desc: {
                    zh: '适用于卫生间区域、厕所等',
                    en: 'Suitable for restroom areas, toilets, etc.',
                    ja: 'お手洗いエリア、トイレ等に適応',
                    Russian: 'Подходит для туалетов и подобных мест',
                    Malay: 'Sesuai untuk kawasan tandas, tandas, dll.',
                    Turkish: 'Banyo alanları, tuvaletler gibi yerler için uygundur.'
                },
                img: '/images/ApplicationScenarios/CaShouZhiCeSuo.png'
            }
        ],
        relatedProducts: ['finishedpaper-016', 'finishedpaper-017', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-019',
        title: { zh: '亲肤棉柔巾', en: 'Skin-Friendly Cotton-Feel Wipes', ja: '肌に優しいコットンフィールソフトタオル', Russian: 'Мягкие хлопковые салфетки для кожи', Malay: 'Lap Kapas Lembut Mesra Kulit',
            Turkish: 'Cilt Dostu Pamuklu Yumuşak Mendil' },
        category: 'finishedpaper',
        desc: { zh: '富含竹纤维，超强吸水', en: 'Rich in Bamboo Fiber, Super Absorbent', ja: '竹繊維豊富、超強力吸水', Russian: 'Богаты бамбуковыми волокнами, сверхвысокая впитывающая способность', Malay: 'Kaya dengan Gentian Buluh, Penyerapan Air Luar Biasa',
            Turkish: 'Zengin bambu lifi içerir, süper emici' },
        img: '/images/finishedPaper/QinFuMianRouJinSuoLve.png',
        gallery: ['/images/finishedPaper/QinFuMianRouJinSuoLve.png'],
        features: { zh: ['富含竹纤维','超强吸水','干湿两用','亲肤柔软'], en: ['Rich in Bamboo Fiber', 'Super Absorbent', 'Dual Use (Dry & Wet)', 'Skin-Friendly & Soft'], ja: ['竹繊維豊富', '超強力吸水', 'ドライ・ウェット両用', '肌に優しくソフト'] , Russian: ['Богаты бамбуковыми волокнами', 'Сверхвысокая впитывающая способность', 'Для сухого и влажного использования', 'Мягкие и нежные для кожи'] , Malay: ['Berkhampiran Serat Buluh yang Tumpat', 'Penyerapan Air Super Kuat', 'Kegunaan Kering & Basah', 'Lembut & Mesra Kulit'] ,
            Turkish: ['Zengin Bambu Lifi İçerir', 'Süper Emici', 'Kuru ve Islak Kullanım', 'Cilt Dostu ve Yumuşak'] 
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih',
                    Turkish: 'Beyaz'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '竹纤维',
                    en: 'Bamboo Fiber',
                    ja: '竹繊維',
                    Russian: 'Бамбуковые волокна',
                    Malay: 'Gentian Buluh',
                    Turkish: 'Bambu Lifi'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '200mm x 200mm',
                    ja: '200mm x 200mm',
                    Russian: '200mm x 200mm',
                    Malay: '200mm x 200mm',
                    Turkish: '200mm x 200mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '1',
                    en: '1',
                    ja: '1',
                    Russian: '1',
                    Malay: '1',
                    Turkish: '1'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '60张',
                    en: '60 Sheets',
                    ja: '60枚',
                    Russian: '60 листов',
                    Malay: '60 keping',
                    Turkish: '60 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '竹纤维系列',
                    en: 'Bamboo Fiber Series',
                    ja: '竹繊維シリーズ',
                    Russian: 'Серия "Бамбуковые волокна"',
                    Malay: 'Siri Gentian Buluh',
                    Turkish: 'Bambu Lifi Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '卸妆、可代替洗脸巾',
                    en: 'For Makeup Removal, Can Replace Face Towels',
                    ja: 'メイク落とし、洗顔タオル代替可能',
                    Russian: 'Для снятия макияжа, может заменять полотенце для умывания',
                    Malay: 'Pembersih Solekan & Gantian Tisu Muka',
                    Turkish: 'Makyaj Temizleme, Yüz Mendili Yerine Kullanılabilir'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T40276',
                    en: 'GB/T40276',
                    ja: 'GB/T40276',
                    Russian: 'GB/T40276',
                    Malay: 'GB/T40276',
                    Turkish: 'GB/T40276'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '16.9元/包',
            //         en: '¥16.9/Pack',
            //         ja: '16.9人民元/パック',
            //         Russian: '16.9 юаня/упаковка',
            //         Malay: '16.9 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '个人清洁',
                    en: 'Personal Cleansing',
                    ja: 'パーソナルケア用',
                    Russian: 'Для личной гигиены',
                    Malay: 'Pembersihan Peribadi',
                    Turkish: 'Kişisel Temizlik'
                },
                desc: {
                    zh: '适用于个人日常清洁、擦拭等用途',
                    en: 'Suitable for daily personal cleansing and wiping.',
                    ja: '個人の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходит для повседневной личной гигиены и очистки',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian peribadi.',
                    Turkish: 'Kişisel günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/GeRenQingJie.png'
            },
            {
                title: {
                    zh: '卸妆',
                    en: 'Makeup Removal',
                    ja: 'メイク落とし用',
                    Russian: 'Для снятия макияжа',
                    Malay: 'Pembersihan Solekan',
                    Turkish: 'Makyaj Temizleme'
                },
                desc: {
                    zh: '可用于卸妆',
                    en: 'Suitable for makeup removal',
                    ja: 'メイク落としに使用可能',
                    Russian: 'Можно использовать для снятия макияжа',
                    Malay: 'Boleh digunakan untuk membersihkan solekan.',
                    Turkish: 'Makyaj temizleme için kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/XieZhuang.png'
            },
            {
                title: {
                    zh: '洗脸巾替代',
                    en: 'Face Towel Alternative',
                    ja: '洗顔タオル代替',
                    Russian: 'Может заменять полотенце для умывания',
                    Malay: 'Gantian Tisu Muka',
                    Turkish: 'Yüz Mendili Yerine'
                },
                desc: {
                    zh: '可用于代替洗脸巾',
                    en: 'Can be used as an alternative to face towels',
                    ja: '洗顔タオルの代替として使用可能',
                    Russian: 'Можно использовать вместо полотенца для умывания',
                    Malay: 'Boleh digunakan sebagai gantian tisu muka.',
                    Turkish: 'Yüz mendili yerine kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/XiLianJinTiDai.png'
            }
        ],
        relatedProducts: ['finishedpaper-020', 'finishedpaper-021', 'finishedpaper-022']
    },
    {
        id: 'finishedpaper-020',
        title: { zh: '竹纤维婴儿柔肤湿纸巾', en: 'Bamboo Fiber Baby Gentle Wet Wipes', ja: '竹繊維ベビーソフトウェットティッシュ', Russian: 'Влажные салфетки для детей с бамбуковыми волокнами', Malay: 'Tisu Basah Lembut Bayi Gentian Buluh' ,
            Turkish: 'Bambu Lifli Bebek Yumuşak Islak Mendil'},
        category: 'finishedpaper',
        desc: { zh: '富含竹纤维，温和不刺激', en: 'Rich in Bamboo Fiber, Gentle & Non-Irritating', ja: '竹繊維豊富、マイルドで低刺激', Russian: 'Богаты бамбуковыми волокнами, мягкие и не раздражают', Malay: 'Kaya dengan Gentian Buluh, Lembut & Tidak Merengsa' ,
            Turkish: 'Zengin bambu lifi içerir, nazik ve tahriş etmez'},
        img: '/images/finishedPaper/ZhuXianWeiYingErRouFuShiZhiJinSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuXianWeiYingErRouFuShiZhiJinSuoLve.png'],
        features: { zh: ['富含竹纤维','温和不刺激','宝宝放心用','亲肤柔软'], en: ['Rich in Bamboo Fiber', 'Gentle & Non-Irritating', 'Safe for Babies', 'Skin-Friendly & Soft'], ja: ['竹繊維豊富', 'マイルドで低刺激', '赤ちゃん安心使用', '肌に優しくソフト'], Russian: ['Богаты бамбуковыми волокнами', 'Мягкие и не раздражают', 'Безопасны для малышей', 'Мягкие и нежные для кожи'], Malay: ['Berkhampiran Serat Buluh yang Tumpat', 'Lembut & Tidak Merengsa', 'Selamat untuk Bayi', 'Lembut & Mesra Kulit'] 
            , Turkish: ['Zengin bambu lifi içerir', 'Nazik ve Tahriş Etmez', 'Bebekler için Güvenle Kullanılabilir', 'Cilt Dostu ve Yumuşak']},
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih',
                    Turkish: 'Beyaz'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '竹纤维',
                    en: 'Bamboo Fiber',
                    ja: '竹繊維',
                    Russian: 'Бамбуковые волокна',
                    Malay: 'Gentian Buluh',
                    Turkish: 'Bambu Lifi'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '180mm x 180mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '180mm x 180mm',
                    Malay: '180mm x 180mm',
                    Turkish: '180mm x 180mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '1',
                    en: '1',
                    ja: '1',
                    Russian: '1',
                    Malay: '1',
                    Turkish: '1'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '80张',
                    en: '80 Sheets',
                    ja: '80枚',
                    Russian: '80 листов',
                    Malay: '80 keping',
                    Turkish: '80 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '竹纤维系列',
                    en: 'Bamboo Fiber Series',
                    ja: '竹繊維シリーズ',
                    Russian: 'Серия "Бамбуковые волокна"',
                    Malay: 'Siri Gentian Buluh',
                    Turkish: 'Bambu Lifi Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '深层清洁、可降解',
                    en: 'Deep Cleansing, Biodegradable',
                    ja: 'ディープクレンジング、生分解性',
                    Russian: 'Глубокая очистка, биоразлагаемые',
                    Malay: 'Pembersihan Mendalam & Boleh Terurai',
                    Turkish: 'Derinlemesine Temizlik, Biyobozunur'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T27728',
                    en: 'GB/T27728',
                    ja: 'GB/T27728',
                    Russian: 'GB/T27728',
                    Malay: 'GB/T27728',
                    Turkish: 'GB/T27728'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '12.9元/包',
            //         en: '¥12.9/Pack',
            //         ja: '12.9人民元/パック',
            //         Russian: '12.9 юаня/упаковка',
            //         Malay: '12.9 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '母婴适用',
                    en: 'Suitable for Mothers & Babies',
                    ja: ' マタニティ＆ベビー向け',
                    Russian: 'Подходят для мам и детей',
                    Malay: 'Sesuai untuk Ibu & Bayi',
                    Turkish: 'Anne ve Bebek Kullanımı İçin'
                },
                desc: {
                    zh: '适用于母婴日常清洁、擦拭等用途',
                    en: 'Suitable for mothers and babies daily cleansing and wiping',
                    ja: ' マタニティ＆ベビーの日常清潔、拭き取りなどに適しています',
                    Russian: 'Подходят для повседневной гигиены мам и детей',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian ibu & bayi.',
                    Turkish: 'Anne ve bebekler için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/MuYing.png'
            },
            {
                title: {
                    zh: '敏感肌',
                    en: 'Sensitive Skin',
                    ja: ' 敏感肌',
                    Russian: 'Для чувствительной кожи',
                    Malay: 'Kulit Sensitif',
                    Turkish: 'Hassas Cilt'
                },
                desc: {
                    zh: '适用于敏感肌人群日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleansing and wiping for people with sensitive skin.',
                    ja: '敏感肌の方の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходят для повседневной гигиены людей с чувствительной кожей',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian pemilik kulit sensitif.',
                    Turkish: 'Hassas ciltli kişiler için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/MinGanJi.png'
            }
        ],
        relatedProducts: ['finishedpaper-019', 'finishedpaper-021', 'finishedpaper-022']
    },
    {
        id: 'finishedpaper-021',
        title: { zh: '竹纤维湿厕纸', en: 'Bamboo Fiber Flushable Wet Wipes', ja: '竹繊維流せるウェットティッシュ', Russian: 'Влажная туалетная бумага с бамбуковыми волокнами', Malay: 'Tisu Tandas Basah Gentian Buluh' ,
            Turkish: 'Bambu Lifli Islak Tuvalet Kağıdı'},
        category: 'finishedpaper',
        desc: { zh: '富含竹纤维，母婴级呵护', en: 'Rich in Bamboo Fiber, Mother & Baby Grade Care', ja: '竹繊維豊富、マザー＆ベビーグレードケア', Russian: 'Богаты бамбуковыми волокнами, уход уровня "мама и малыш"', Malay: 'Kaya dengan Gentian Buluh, Perlindungan Tahap Ibu & Bayi' ,
            Turkish: 'Zengin bambu lifi içerir, anne-bebek düzeyinde bakım'},
        img: '/images/finishedPaper/ZhuXianWeiShiCeZhi.png',
        gallery: ['/images/finishedPaper/ZhuXianWeiShiCeZhi.png'],
        features: { zh: ['富含竹纤维','可降解','亲肤、抗菌、柔韧','母婴级呵护'], en: ['Rich in Bamboo Fiber', 'Biodegradable', 'Skin-Friendly, Antibacterial, Flexible', 'Mother & Baby Grade Care'], ja: ['竹繊維豊富', '生分解性', '肌に優しい、抗菌、ソフトで強靭', 'マザー＆ベビーグレードケア'], Russian: ['Богаты бамбуковыми волокнами', 'Биоразлагаемые', 'Нежные для кожи, антибактериальные, гибкие', 'Уход уровня "мама и малыш"'], Malay: ['Berkhampiran Serat Buluh yang Tumpat', 'Boleh Terurai', 'Mesra Kulit, Antibakteria & Lentur', 'Perlindungan Tahap Ibu & Bayi'] 
            , Turkish: ['Zengin bambu lifi içerir', 'Biyobozunur', 'Cilt dostu, antibakteriyel, esnek', 'Anne-Bebek Düzeyinde Bakım']
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih',
                    Turkish: 'Beyaz'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '竹纤维',
                    en: 'Bamboo Fiber',
                    ja: '竹繊維',
                    Russian: 'Бамбуковые волокна',
                    Malay: 'Gentian Buluh',
                    Turkish: 'Bambu Lifi'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '150mm x 200mm',
                    en: '150mm x 200mm',
                    ja: '150mm x 200mm',
                    Russian: '150mm x 200mm',
                    Malay: '150mm x 200mm',
                    Turkish: '150mm x 200mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '1',
                    en: '1',
                    ja: '1',
                    Russian: '1',
                    Malay: '1',
                    Turkish: '1'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '80张',
                    en: '80 Sheets',
                    ja: '80枚',
                    Russian: '80 листов',
                    Malay: '80 keping',
                    Turkish: '80 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '竹纤维系列',
                    en: 'Bamboo Fiber Series',
                    ja: '竹繊維シリーズ',
                    Russian: 'Серия "Бамбуковые волокна"',
                    Malay: 'Siri Gentian Buluh',
                    Turkish: 'Bambu Lifi Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '深层清洁、可降解',
                    en: 'Deep Cleansing, Biodegradable',
                    ja: 'ディープクレンジング、生分解性',
                    Russian: 'Глубокая очистка, биоразлагаемые',
                    Malay: 'Pembersihan Mendalam & Boleh Terurai',
                    Turkish: 'Derinlemesine Temizlik, Biyobozunur'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T27728',
                    en: 'GB/T27728',
                    ja: 'GB/T27728',
                    Russian: 'GB/T27728',
                    Malay: 'GB/T27728',
                    Turkish: 'GB/T27728'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '14.9元/包',
            //         en: '¥14.9/Pack',
            //         ja: '14.9人民元/パック',
            //         Russian: '14.9 юаня/упаковка',
            //         Malay: '14.9 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '厕所使用',
                    en: 'Toilet Use',
                    ja: 'トイレ用',
                    Russian: 'Для использования в туалете',
                    Malay: 'Kegunaan Tandas',
                    Turkish: 'Tuvalet Kullanımı'
                },
                desc: {
                    zh: '适用于个人清洁、擦拭等用途',
                    en: 'Suitable for  personal cleansing and wiping',
                    ja: '個人の清潔、拭き取りなどに適しています',
                    Russian: 'Подходят для личной гигиены и очистки',
                    Malay: 'Boleh digunakan untuk pembersihan peribadi, mengelap dan sebagainya.',
                    Turkish: 'Kişisel temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/ShiCeZhiCeSuo.png'
            },
            {
                title: {
                    zh: '卫生清洁',
                    en: 'Hygiene Cleaning',
                    ja: '衛生清掃用',
                    Russian: 'Для гигиенической очистки',
                    Malay: 'Pembersihan Kebersihan',
                    Turkish: 'Hijyenik Temizlik'
                },
                desc: {
                    zh: '可用于个人卫生清洁',
                    en: 'Suitable for personal hygiene cleaning',
                    ja: '個人衛生清掃に使用可能',
                    Russian: 'Можно использовать для личной гигиены',
                    Malay: 'Boleh digunakan untuk pembersihan kebersihan peribadi.',
                    Turkish: 'Kişisel hijyen temizliği için kullanılabilir.'
                },
                img: '/images/ApplicationScenarios/ShiCeZhiQingJie.png'
            }
        ],
        relatedProducts: ['finishedpaper-019', 'finishedpaper-020', 'finishedpaper-022']
    },
    {
        id: 'finishedpaper-022',
        title: { zh: '竹纤维便携湿巾', en: 'Bamboo Fiber Portable Wipes', ja: '竹繊維携帯ウェットティッシュ', Russian: 'Портативные влажные салфетки с бамбуковыми волокнами', Malay: 'Tisu Basah Mudah Alih Gentian Buluh' ,
            Turkish: 'Bambu Lifli Taşınabilir Islak Mendil'},
        category: 'finishedpaper',
        desc: { zh: '富含竹纤维，深层清洁', en: 'Rich in Bamboo Fiber, Deep Cleansing', ja: '竹繊維豊富、ディープクレンジング' , Russian: 'Богаты бамбуковыми волокнами, глубокая очистка', Malay: 'Kaya dengan Gentian Buluh, Pembersihan Mendalam',
            Turkish: 'Zengin bambu lifi içerir, derinlemesine temizlik'},
        img: '/images/finishedPaper/ZhuXianWeiBianXieShiJinSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuXianWeiBianXieShiJinSuoLve.png'],
        features: { zh: ['富含竹纤维','亲肤柔韧可降解','深层清洁','不含荧光、不含酒精'], en: ['Rich in Bamboo Fiber', 'Skin-Friendly, Flexible, Biodegradable', 'Deep Cleansing', 'No Fluorescent Agents, No Alcohol'], ja: ['竹繊維豊富', '肌に優しくソフトで強靭、生分解性', 'ディープクレンジング', '蛍光剤不使用、アルコールフリー'], Russian: ['Богаты бамбуковыми волокнами', 'Нежные для кожи, гибкие, биоразлагаемые', 'Глубокая очистка', 'Без флуоресцентных агентов и алкоголя'], Malay: ['Berkhampiran Serat Buluh yang Tumpat', 'Mesra Kulit, Lentur & Boleh Terurai', 'Pembersihan Mendalam', 'Tiada Pendarfluor, Tiada Alkohol'] 
            , Turkish: ['Zengin bambu lifi içerir', 'Cilt dostu, esnek, biyobozunur', 'Derinlemesine Temizlik', 'Floresans ve alkol içermez']
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih',
                    Turkish: 'Beyaz'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '竹纤维',
                    en: 'Bamboo Fiber',
                    ja: '竹繊維',
                    Russian: 'Бамбуковые волокна',
                    Malay: 'Gentian Buluh',
                    Turkish: 'Bambu Lifi'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '180mm x 180mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '180mm x 180mm',
                    Malay: '180mm x 180mm',
                    Turkish: '180mm x 180mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '1',
                    en: '1',
                    ja: '1',
                    Russian: '1',
                    Malay: '1',
                    Turkish: '1'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '10片',
                    en: '10 Sheets',
                    ja: '10枚入り',
                    Russian: '10 штук',
                    Malay: '10 keping',
                    Turkish: '10 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '竹纤维系列',
                    en: 'Bamboo Fiber Series',
                    ja: '竹繊維シリーズ',
                    Russian: 'Серия "Бамбуковые волокна"',
                    Malay: 'Siri Gentian Buluh',
                    Turkish: 'Bambu Lifi Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '深层清洁、可降解',
                    en: 'Deep Cleansing, Biodegradable',
                    ja: 'ディープクレンジング、生分解性',
                    Russian: 'Глубокая очистка, биоразлагаемые',
                    Malay: 'Pembersihan Mendalam & Boleh Terurai',
                    Turkish: 'Derinlemesine Temizlik, Biyobozunur'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T27728',
                    en: 'GB/T27728',
                    ja: 'GB/T27728',
                    Russian: 'GB/T27728',
                    Malay: 'GB/T27728',
                    Turkish: 'GB/T27728'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '4元/包',
            //         en: '¥4/Pack',
            //         ja: '4人民元/パック',
            //         Russian: '4 юаня/упаковка',
            //         Malay: '4 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务接待',
                    en: 'Business Reception',
                    ja: 'ビジネス接客用',
                    Russian: 'Для деловых приёмов',
                    Malay: 'Sambutan Perniagaan',
                    Turkish: 'İş Toplantıları ve Misafir Ağırlama'
                },
                desc: {
                    zh: '适合商务接待等场所定制化使用',
                    en: 'Ideal for customized use in business reception settings, etc.',
                    ja: 'ビジネス接客等でのカスタマイズ使用に最適',
                    Russian: 'Подходит для индивидуального использования на деловых приёмах и т.д.',
                    Malay: 'Sesuai untuk kegunaan tersuai di tempat sambutan perniagaan, dll.',
                    Turkish: 'İş resepsiyonları gibi yerlerde özelleştirilmiş kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Business Travel Portable',
                    ja: '出張携帯用',
                    Russian: 'Для командировок',
                    Malay: 'Mudah Alih untuk Perjalanan Dinas',
                    Turkish: 'İş Seyahati için Taşınabilir'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Portable for business travel, airports, high-speed rail stations, etc.',
                    ja: '出張、空港・高速鉄道駅等での携帯使用に便利',
                    Russian: 'Можно брать с собой в командировки, аэропорты, на вокзалы и т.д.',
                    Malay: 'Boleh digunakan untuk kegunaan mudah alih semasa perjalanan dinas, lapangan terbang, stesen HSR, dll.',
                    Turkish: 'İş seyahatleri, havaalanları, yüksek hızlı tren istasyonları gibi yerlerde taşınabilir kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Compact for Travel',
                    ja: '旅行携帯用',
                    Russian: 'Для путешествий',
                    Malay: 'Mudah Alih untuk Pelancongan',
                    Turkish: 'Turistik Seyahat için Taşınabilir'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Suitable for portable use during travel, camping, etc.',
                    ja: '旅行、キャンプ等の携帯使用に最適',
                    Russian: 'Подходит для путешествий, кемпинга и т.д.',
                    Malay: 'Sesuai untuk kegunaan mudah alih semasa pelancongan, perkhemahan, dll.',
                    Turkish: 'Turizm, kampçılık gibi taşınabilir kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-019', 'finishedpaper-020', 'finishedpaper-021']
    },
    {
        id: 'finishedpaper-023',
        title: { zh: '80抽竹浆乳霜柔润面纸', en: '80ct Bamboo Pulp Lotion Facial Tissues', ja: '80組 竹パルプ保湿ローションティッシュ', Russian: '80 салфеток с кремом из бамбуковой целлюлозы', Malay: 'Tisu Muka Lembut Krim Buluh 80 helai' ,
            Turkish: '80 Yaprak Bambu Hamuru Kremli Yumuşak Yüz Kağıdı'},
        category: 'finishedpaper',
        desc: { zh: '竹浆抑菌，至柔至润', en: 'Bamboo Pulp Antibacterial, Ultra-Soft & Ultra-Moisturizing', ja: '竹パルプ抗菌、究極のソフトさと潤い' , Russian: 'Антибактериальная бамбуковая целлюлоза, невероятно мягкая и увлажняющая', Malay: 'Pulpa Buluh Antibakteria, Kelembutan & Kelembapan Maksimum',
            Turkish: 'Bambu hamuru antibakteriyel, son derece yumuşak ve nemlendirici'},
        img: '/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi80Chou.png',
        gallery: ['/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi80Chou.png'],
        features: {
            zh: [
                '乳霜润肤、羽柔触感',
                '竹浆抑菌',
                '韧性结构，厚乘安心',
                '擦拭无屑更安心'
            ],
            en: [
                'Lotion Moisturizing, Feather-Soft Feel',
                'Bamboo Pulp Antibacterial',
                'Durable Structure, Thick & Reassuring',
                'Lint-Free Wiping for Greater Assurance'
            ],
            ja: [
                '保湿クリーム配合、羽のようなソフトタッチ',
                '竹パルプ抗菌',
                '強靭構造、厚手で安心',
                '拭き取り時ノーリントでさらに安心'
            ],
            Russian: [
                'Кремовое увлажнение, ощущение мягкости как у перьев',
                'Антибактериальная бамбуковая целлюлоза',
                'Прочная структура, толщина обеспечивает уверенность',
                'Не оставляет ворсинок, что даёт дополнительное спокойствие'
            ],
            Malay: [
                'Pelembap Krim, Sentuhan Selembut Bulu',
                'Pulpa Buluh Mengawal Bakteria',
                'Struktur Kenyal, Ketebalan Memberi Ketenangan',
                'Pengelapan Tanpa Serpihan, Lebih Tenang'
            ],
            Turkish: [
                'Kremli nemlendirme, tüy gibi yumuşak dokunuş',
                'Bambu Hamuru Antibakteriyel',
                'Sağlam yapı, kalınlık güven verir',
                'Silerken kırıntı bırakmaz, daha güvenli'
            ]
        },        
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih',
                    Turkish: 'Beyaz'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '170mm x 180mm',
                    en: '170mm x 180mm',
                    ja: '170mm x 180mm',
                    Russian: '170mm x 180mm',
                    Malay: '170mm x 180mm',
                    Turkish: '170mm x 180mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '5',
                    en: '5',
                    ja: '5',
                    Russian: '5',
                    Malay: '5',
                    Turkish: '5'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '80抽',
                    en: '80 Sheets',
                    ja: '80組',
                    Russian: '80 салфеток',
                    Malay: '80 helai',
                    Turkish: '80 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '乳霜纸系列',
                    en: 'Lotion Tissue Series',
                    ja: '保湿ローションティッシュシリーズ',
                    Russian: 'Серия "Кремовая бумага"',
                    Malay: 'Siri Tisu Krim',
                    Turkish: 'Kremli Kağıt Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '至柔至润、羽柔触感',
                    en: 'Ultra-Soft & Ultra-Moisturizing, Feather-Soft Feel',
                    ja: '究極のソフトさと潤い、羽のようなソフトタッチ',
                    Russian: 'Невероятно мягкая и увлажняющая, ощущение мягкости как у перьев',
                    Malay: 'Kelembutan & Kelembapan Maksimum, Sentuhan Selembut Bulu',
                    Turkish: 'Son Derece Yumuşak ve Nemlendirici, Tüy Gibi Yumuşak Dokunuş'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: 'GB/T 20808',
                    ja: 'GB/T 20808',
                    Russian: 'GB/T 20808',
                    Malay: 'GB/T 20808',
                    Turkish: 'GB/T 20808'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '10.99元/包',
            //         en: '¥10.99/Pack',
            //         ja: '10.99人民元/パック',
            //         Russian: '10.99 юаня/упаковка',
            //         Malay: '10.99 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '母婴适用',
                    en: 'Suitable for Mothers & Babies',
                    ja: ' マタニティ＆ベビー向け',
                    Russian: 'Подходят для мам и детей',
                    Malay: 'Sesuai untuk Ibu & Bayi',
                    Turkish: 'Anne ve Bebek Kullanımı İçin'
                },
                desc: {
                    zh: '适用于母婴日常清洁、擦拭等用途',
                    en: 'Suitable for mothers and babies daily cleansing and wiping',
                    ja: ' マタニティ＆ベビーの日常清潔、拭き取りなどに適しています',
                    Russian: 'Подходят для повседневной гигиены мам и детей',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian ibu & bayi.',
                    Turkish: 'Anne ve bebekler için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/MuYing.png'
            },
            {
                title: {
                    zh: '敏感肌',
                    en: 'Sensitive Skin',
                    ja: ' 敏感肌',
                    Russian: 'Для чувствительной кожи',
                    Malay: 'Kulit Sensitif',
                    Turkish: 'Hassas Cilt'
                },
                desc: {
                    zh: '适用于敏感肌人群日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleansing and wiping for people with sensitive skin.',
                    ja: '敏感肌の方の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходят для повседневной гигиены людей с чувствительной кожей',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian pemilik kulit sensitif.',
                    Turkish: 'Hassas ciltli kişiler için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/MinGanJi.png'
            }
        ],
        relatedProducts: ['finishedpaper-024', 'finishedpaper-025', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-024',
        title: { zh: '30抽竹浆乳霜柔润面纸', en: '30ct Bamboo Pulp Lotion Facial Tissues', ja: '30組 竹パルプ保湿ローションティッシュ', Russian: '30 салфеток с кремом из бамбуковой целлюлозы', Malay: 'Tisu Muka Lembut Krim Buluh 30 helai' ,
            Turkish: '30 Yaprak Bambu Hamuru Kremli Yumuşak Yüz Kağıdı'},
        category: 'finishedpaper',
        desc: { zh: '竹浆抑菌，至柔至润', en: 'Bamboo Pulp Antibacterial, Ultra-Soft & Ultra-Moisturizing', ja: '竹パルプ抗菌、究極のソフトさと潤い' , Russian: 'Антибактериальная бамбуковая целлюлоза, невероятно мягкая и увлажняющая', Malay: 'Pulpa Buluh Antibakteria, Kelembutan & Kelembapan Maksimum',
            Turkish: 'Bambu hamuru antibakteriyel, son derece yumuşak ve nemlendirici'},
        img: '/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi30ChouSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi30ChouSuoLve.png'],
        features: {
            zh: [
                '乳霜润肤、羽柔触感',
                '竹浆抑菌',
                '韧性结构，厚乘安心',
                '轻巧一包，旅途的温柔陪伴'
            ],
            en: [
                'Lotion Moisturizing, Feather-Soft Feel',
                'Bamboo Pulp Antibacterial',
                'Durable Structure, Thick & Reassuring',
                'Lightweight Pack, Gentle Companion for Travel'
            ],
            ja: [
                '保湿クリーム配合、羽のようなソフトタッチ',
                '竹パルプ抗菌',
                '強靭構造、厚手で安心',
                '軽量一パック、旅先の優しいお供'
            ],
            Russian: [
                'Кремовое увлажнение, ощущение мягкости как у перьев',
                'Антибактериальная бамбуковая целлюлоза',
                'Прочная структура, толщина обеспечивает уверенность',
                'Лёгкая упаковка - нежный спутник в путешествиях'
            ],
            Malay: [
                'Pelembap Krim, Sentuhan Selembut Bulu',
                'Pulpa Buluh Mengawal Bakteria',
                'Struktur Kenyal, Ketebalan Memberi Ketenangan',
                'Satu Pek Ringan, Teman Lembut dalam Perjalanan'
            ],
            Turkish: [
                'Kremli nemlendirme, tüy gibi yumuşak dokunuş',
                'Bambu Hamuru Antibakteriyel',
                'Sağlam yapı, kalınlık güven verir',
                'Hafif bir paket, yolculukta nazik bir eşlik'
            ]
        },
        certifications:  [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih',
                    Turkish: 'Beyaz'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '138mm x 180mm',
                    en: '138mm x 180mm',
                    ja: '138mm x 180mm',
                    Russian: '138mm x 180mm',
                    Malay: '138mm x 180mm',
                    Turkish: '138mm x 180mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '5',
                    en: '5',
                    ja: '5',
                    Russian: '5',
                    Malay: '5',
                    Turkish: '5'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '30抽',
                    en: '30 Sheets',
                    ja: '30組',
                    Russian: '30 салфеток',
                    Malay: '30 helai',
                    Turkish: '30 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '乳霜纸系列',
                    en: 'Lotion Tissue Series',
                    ja: '保湿ローションティッシュシリーズ',
                    Russian: 'Серия "Кремовая бумага"',
                    Malay: 'Siri Tisu Krim',
                    Turkish: 'Kremli Kağıt Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '至柔至润、羽柔触感',
                    en: 'Ultra-Soft & Ultra-Moisturizing, Feather-Soft Feel',
                    ja: '究極のソフトさと潤い、羽のようなソフトタッチ',
                    Russian: 'Невероятно мягкая и увлажняющая, ощущение мягкости как у перьев',
                    Malay: 'Kelembutan & Kelembapan Maksimum, Sentuhan Selembut Bulu',
                    Turkish: 'Son Derece Yumuşak ve Nemlendirici, Tüy Gibi Yumuşak Dokunuş'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: 'GB/T 20808',
                    ja: 'GB/T 20808',
                    Russian: 'GB/T 20808',
                    Malay: 'GB/T 20808',
                    Turkish: 'GB/T 20808'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '4.99元/包',
            //         en: '¥4.99/Pack',
            //         ja: '4.99人民元/パック',
            //         Russian: '4.99 юаня/упаковка',
            //         Malay: '4.99 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '母婴适用',
                    en: 'Suitable for Mothers & Babies',
                    ja: ' マタニティ＆ベビー向け',
                    Russian: 'Подходят для мам и детей',
                    Malay: 'Sesuai untuk Ibu & Bayi',
                    Turkish: 'Anne ve Bebek Kullanımı İçin'
                },
                desc: {
                    zh: '适用于母婴日常清洁、擦拭等用途',
                    en: 'Suitable for mothers and babies daily cleansing and wiping',
                    ja: ' マタニティ＆ベビーの日常清潔、拭き取りなどに適しています',
                    Russian: 'Подходят для повседневной гигиены мам и детей',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian ibu & bayi.',
                    Turkish: 'Anne ve bebekler için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/MuYing.png'
            },
            {
                title: {
                    zh: '敏感肌',
                    en: 'Sensitive Skin',
                    ja: ' 敏感肌',
                    Russian: 'Для чувствительной кожи',
                    Malay: 'Kulit Sensitif',
                    Turkish: 'Hassas Cilt'
                },
                desc: {
                    zh: '适用于敏感肌人群日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleansing and wiping for people with sensitive skin.',
                    ja: '敏感肌の方の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходят для повседневной гигиены людей с чувствительной кожей',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian pemilik kulit sensitif.',
                    Turkish: 'Hassas ciltli kişiler için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/MinGanJi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Business Travel Portable',
                    ja: '出張携帯用',
                    Russian: 'Для командировок',
                    Malay: 'Mudah Alih untuk Perjalanan Dinas',
                    Turkish: 'İş Seyahati için Taşınabilir'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Portable for business travel, airports, high-speed rail stations, etc.',
                    ja: '出張、空港・高速鉄道駅等での携帯使用に便利',
                    Russian: 'Можно брать с собой в командировки, аэропорты, на вокзалы и т.д.',
                    Malay: 'Boleh digunakan untuk kegunaan mudah alih semasa perjalanan dinas, lapangan terbang, stesen HSR, dll.',
                    Turkish: 'İş seyahatleri, havaalanları, yüksek hızlı tren istasyonları gibi yerlerde taşınabilir kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            }
        ],
        relatedProducts: ['finishedpaper-023', 'finishedpaper-025', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-025',
        title: { zh: '8片竹浆乳霜柔润面纸', en: '8 PCS Bamboo Pulp Lotion Facial Tissues', ja: '8枚 竹パルプ保湿ローションティッシュ', Russian: '8 салфеток с кремом из бамбуковой целлюлозы', Malay: 'Tisu Muka Lembut Krim Buluh 8 keping',
            Turkish: 'Bağımsız Steril Ambalaj' },
        category: 'finishedpaper',
        desc: { zh: '竹浆抑菌，至柔至润', en: 'Bamboo Pulp Antibacterial, Ultra-Soft & Ultra-Moisturizing', ja: '竹パルプ抗菌、究極のソフトさと潤い' , Russian: 'Антибактериальная бамбуковая целлюлоза, невероятно мягкая и увлажняющая', Malay: 'Pulpa Buluh Antibakteria, Kelembutan & Kelembapan Maksimum',
            Turkish: 'Bambu hamuru antibakteriyel, son derece yumuşak ve nemlendirici'},
        img: '/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi8PianSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi8PianSuoLve.png'],
        features: {
            zh: [
                '乳霜润肤、羽柔触感',
                '独立灭菌包装',
                '韧性结构，厚乘安心',
                '一抽即走，清爽随行'
            ],
            en: [
                'Lotion Moisturizing, Feather-Soft Feel',
                'Individually Sterilized Packaging',
                'Durable Structure, Thick & Reassuring',
                'Grab & Go, Refreshing On-The-Go'
            ],
            ja: [
                '保湿クリーム配合、羽のようなソフトタッチ',
                '個別滅菌包装',
                '強靭構造、厚手で安心',
                'サッと一枚、いつでも爽やか'
            ],
            Russian: [
                'Кремовое увлажнение, ощущение мягкости как у перьев',
                'Индивидуальная стерильная упаковка',
                'Прочная структура, толщина обеспечивает уверенность',
                'Достал и пошёл, свежесть всегда с тобой'
            ],
            Malay: [
                'Pelembap Krim, Sentuhan Selembut Bulu',
                'Pembungkusan Steril Bebas',
                'Struktur Kenyal, Ketebalan Memberi Ketenangan',
                'Ambil & Pergi, Kesegaran Menyertai Anda'
            ],
            Turkish: [
                'Kremli nemlendirme, tüy gibi yumuşak dokunuş',
                'Bağımsız Steril Ambalaj',
                'Sağlam yapı, kalınlık güven verir',
                'Bir çekişte alın, serinlik yanınızda'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO 9001 Certified',
                    ja: 'ISO9001認証',
                    Russian: 'Сертификат ISO9001',
                    Malay: 'Pensijilan ISO9001',
                    Turkish: 'ISO9001 Sertifikası'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: 'Сертификация FSC (Forest Stewardship Council) — международная сертификация устойчивого лесопользования',
                    Malay: 'Pensijilan FSC',
                    Turkish: 'FSC Sertifikası'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Color',
                    ja: '色',
                    Russian: 'Цвет',
                    Malay: 'Warna',
                    Turkish: 'Renk'
                },
                value: {
                    zh: '白色',
                    en: 'White',
                    ja: '白色',
                    Russian: 'Белый',
                    Malay: 'Putih',
                    Turkish: 'Beyaz'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '材質',
                    Russian: '​Материал изготовления​',
                    Malay: 'Bahan',
                    Turkish: 'Malzeme'
                },
                value: {
                    zh: '原生竹浆',
                    en: 'Virgin Bamboo Pulp',
                    ja: 'バージン竹パルプ',
                    Russian: 'натуральной бамбуковой целлюлозы',
                    Malay: 'Pulpa Buluh Asli',
                    Turkish: 'Ham Bambu Hamuru'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specifications',
                    ja: '規格',
                    Russian: 'Спецификация',
                    Malay: 'Spesifikasi',
                    Turkish: 'Özellikler'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '200mm x 200mm',
                    ja: '200mm x 200mm',
                    Russian: '200mm x 200mm',
                    Malay: '200mm x 200mm',
                    Turkish: '200mm x 200mm'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Ply',
                    ja: '層数',
                    Russian: 'Количество слоёв',
                    Malay: 'Bilangan Lapisan',
                    Turkish: 'Katman Sayısı'
                },
                value: {
                    zh: '5',
                    en: '5',
                    ja: '5',
                    Russian: '5',
                    Malay: '5',
                    Turkish: '5'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: '包装規格',
                    Russian: 'Упаковочные спецификации',
                    Malay: 'Spesifikasi Pembungkusan',
                    Turkish: 'Ambalaj Özellikleri'
                },
                value: {
                    zh: '8片',
                    en: '8 Sheets',
                    ja: '8枚入り',
                    Russian: '8 штук',
                    Malay: '8 keping',
                    Turkish: '8 Yaprak'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package',
                    ja: '包装',
                    Russian: 'Упаковка',
                    Malay: 'Pembungkusan',
                    Turkish: 'Ambalaj'
                },
                value: {
                    zh: '乳霜纸系列',
                    en: 'Lotion Tissue Series',
                    ja: '保湿ローションティッシュシリーズ',
                    Russian: 'Серия "Кремовая бумага"',
                    Malay: 'Siri Tisu Krim',
                    Turkish: 'Kremli Kağıt Serisi'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Function',
                    ja: '機能',
                    Russian: 'Функции',
                    Malay: 'Fungsi',
                    Turkish: 'Fonksiyon'
                },
                value: {
                    zh: '至柔至润、羽柔触感',
                    en: 'Ultra-Soft & Ultra-Moisturizing, Feather-Soft Feel',
                    ja: '究極のソフトさと潤い、羽のようなソフトタッチ',
                    Russian: 'Невероятно мягкая и увлажняющая, ощущение мягкости как у перьев',
                    Malay: 'Kelembutan & Kelembapan Maksimum, Sentuhan Selembut Bulu',
                    Turkish: 'Son Derece Yumuşak ve Nemlendirici, Tüy Gibi Yumuşak Dokunuş'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Compliance Standards',
                    ja: '適用基準',
                    Russian: 'Стандарты исполнения',
                    Malay: 'Standard Pelaksanaan',
                    Turkish: 'Uygulama Standardı'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: 'GB/T 20808',
                    ja: 'GB/T 20808',
                    Russian: 'GB/T 20808',
                    Malay: 'GB/T 20808',
                    Turkish: 'GB/T 20808'
                }
            },
            // {
            //     name: {
            //         zh: '指导价',
            //         en: 'Reference Price',
            //         ja: '参考価格',
            //         Russian: 'Руководящая цена',
            //         Malay: 'Harga Panduan',
            //         Turkish: 'Yönlendirme Fiyatı'
            //     },
            //     value: {
            //         zh: '2.09元/包',
            //         en: '¥2.09/Pack',
            //         ja: '2.09人民元/パック',
            //         Russian: '2.09 юаня/упаковка',
            //         Malay: '2.09 RMB/pakej',
            //         Turkish: 'ISO9001認証'
            //     }
            // }
        ],
        usageExamples: [
            {
                title: {
                    zh: '母婴适用',
                    en: 'Suitable for Mothers & Babies',
                    ja: ' マタニティ＆ベビー向け',
                    Russian: 'Подходят для мам и детей',
                    Malay: 'Sesuai untuk Ibu & Bayi',
                    Turkish: 'Anne ve Bebek Kullanımı İçin'
                },
                desc: {
                    zh: '适用于母婴日常清洁、擦拭等用途',
                    en: 'Suitable for mothers and babies daily cleansing and wiping',
                    ja: ' マタニティ＆ベビーの日常清潔、拭き取りなどに適しています',
                    Russian: 'Подходят для повседневной гигиены мам и детей',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian ibu & bayi.',
                    Turkish: 'Anne ve bebekler için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/MuYing.png'
            },
            {
                title: {
                    zh: '敏感肌',
                    en: 'Sensitive Skin',
                    ja: ' 敏感肌',
                    Russian: 'Для чувствительной кожи',
                    Malay: 'Kulit Sensitif',
                    Turkish: 'Hassas Cilt'
                },
                desc: {
                    zh: '适用于敏感肌人群日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleansing and wiping for people with sensitive skin.',
                    ja: '敏感肌の方の日常清掃、拭き取り等用途に適応',
                    Russian: 'Подходят для повседневной гигиены людей с чувствительной кожей',
                    Malay: 'Sesuai untuk pembersihan dan pengelapan harian pemilik kulit sensitif.',
                    Turkish: 'Hassas ciltli kişiler için günlük temizlik ve silme gibi kullanımlar için uygundur.'
                },
                img: '/images/ApplicationScenarios/MinGanJi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Business Travel Portable',
                    ja: '出張携帯用',
                    Russian: 'Для командировок',
                    Malay: 'Mudah Alih untuk Perjalanan Dinas',
                    Turkish: 'İş Seyahati için Taşınabilir'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Portable for business travel, airports, high-speed rail stations, etc.',
                    ja: '出張、空港・高速鉄道駅等での携帯使用に便利',
                    Russian: 'Можно брать с собой в командировки, аэропорты, на вокзалы и т.д.',
                    Malay: 'Boleh digunakan untuk kegunaan mudah alih semasa perjalanan dinas, lapangan terbang, stesen HSR, dll.',
                    Turkish: 'İş seyahatleri, havaalanları, yüksek hızlı tren istasyonları gibi yerlerde taşınabilir kullanım için uygundur.'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            }
        ],
        relatedProducts: ['finishedpaper-023', 'finishedpaper-024', 'finishedpaper-019']
    },
    {
        id: 'fiber-001',
        title: { zh: '塑料级二醋酸纤维素', en: 'Plastic-Grade Cellulose Diacetate (CDA)', ja: 'プラスチックグレード 二酢酸セルロース', Russian: 'Диацетат целлюлозы пластикового класса', Malay: 'Selulosa Diasetat Gred Plastik' ,
            Turkish: 'Plastik Sınıfı Selüloz Diasetat'},
        category: 'fiber',
        desc: { zh: '优良的着色性能、加工性能，色泽亮丽', en: 'Excellent Coloring Properties, Good Processability, Bright Color', ja: '優れた着色性・加工性、鮮やかな光沢', Russian: 'Отличные окрашивающие и обрабатывающие свойства, яркие цвета', Malay: 'Prestasi Pewarnaan & Pemprosesan Unggul, Warna Cerah' ,
            Turkish: 'Mükemmel renklendirme özellikleri, iyi işlenebilirlik, parlak renkler'},
        img: '/images/Fibre/SuLiaoJiErCuSuanXianWeiSuSuoLve.png',
        gallery: ['/images/Fibre/SuLiaoJiErCuSuanXianWeiSuSuoLve.png'],
        features: { zh: ['优良的着色性能', '加工性能好，制品手感良好', '色泽亮丽'], en: ['Excellent Coloring Properties', 'Good Processability, Pleasant Product Feel', 'Bright Color'], ja: ['優れた着色性', '良好な加工性、製品の手触り良好', '鮮やかな光沢'], Russian: ['Отличные окрашивающие свойства', 'Хорошая обрабатываемость, приятная на ощупь продукция', 'Яркие цвета'], Malay: ['Prestasi Pewarnaan Unggul', 'Prestasi Pemprosesan Baik, Produk Berasa Selesa', 'Warna Cerah'], 
            Turkish: ['Mükemmel Renklendirme Özellikleri', 'İyi İşlenebilirlik, Ürünlerde İyi Hissedilen Doku', 'Parlak Renkler']},
        certifications: [],
        specifications: [],
        usageExamples: [
            {
                title: {
                    zh: '高档眼镜、儿童玩具',
                    en: 'Premium Eyewear, Children‘s Toys',
                    ja: '高級メガネ、子供用玩具',
                    Russian: 'Премиальные очки, детские игрушки',
                    Malay: 'Cermin Mata Premium, Mainan Kanak-kanak',
                    Turkish: 'Yüksek Kalite Gözlükler, Çocuk Oyuncakları'
                },
                desc: {
                    zh: '适合高档眼镜、儿童玩具等产品加工',
                    en: 'Suitable for processing premium eyewear, children‘s toys, etc.',
                    ja: '高級メガネ、子供用玩具等製品加工に最適',
                    Russian: 'Подходит для производства премиальных очков, детских игрушек и т.д.',
                    Malay: 'Sesuai untuk pemprosesan produk seperti cermin mata premium, mainan kanak-kanak, dll.',
                    Turkish: 'Yüksek kaliteli gözlükler, çocuk oyuncakları gibi ürünlerin işlenmesi için uygundur.'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiYanJing.png'
            },
            {
                title: {
                    zh: '工具手柄',
                    en: 'Tool Handles',
                    ja: '工具取っ手',
                    Russian: 'Ручки инструментов',
                    Malay: 'Pemegang Alat',
                    Turkish: 'Alet Sapı'
                },
                desc: {
                    zh: '适合工具手柄、工业按钮，汽车方向盘等产品加工',
                    en: 'Suitable for tool handles, industrial buttons, car steering wheels, etc.',
                    ja: '工具取っ手、工業用ボタン、自動車ハンドル等製品加工に最適',
                    Russian: 'Подходит для производства ручек инструментов, промышленных кнопок, автомобильных рулей и т.д.',
                    Malay: 'Sesuai untuk pemprosesan pemegang alat, butang industri, stereng kereta, dll.',
                    Turkish: 'Alet sapları, endüstriyel düğmeler, araba direksiyonları gibi ürünlerin işlenmesi için uygundur.'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiAnNiu.png'
            },
            {
                title: {
                    zh: '隐形胶带',
                    en: 'Invisible Tape',
                    ja: 'メンディングテープ',
                    Russian: 'Невидимая лента',
                    Malay: 'Pita Telus',
                    Turkish: 'Görünmez Bant'
                },
                desc: {
                    zh: '适合隐形胶带等产品加工',
                    en: 'Suitable for invisible tape, etc.',
                    ja: 'メンディングテープ等製品加工に最適',
                    Russian: 'Подходит для производства невидимой ленты и т.д.',
                    Malay: 'Sesuai untuk pemprosesan produk seperti pita telus, dll.',
                    Turkish: 'Görünmez bant gibi ürünlerin işlenmesi için uygundur.'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiJiaoDai.png'
            }
        ],
        relatedProducts: ['fiber-002', 'fiber-003', 'cultural-003']
    },
    {
        id: 'fiber-002',
        title: { zh: '纺丝级二醋酸纤维素', en: 'Fiber-Grade Cellulose Diacetate (CDA)', ja: '紡糸グレード 二酢酸セルロース', Russian: 'Диацетат целлюлозы для прядения', Malay: 'Selulosa Diasetat Gred Spinning' ,
            Turkish: 'Eğirme Sınıfı Selüloz Diasetat'},
        category: 'fiber',
        desc: { zh: '吸附性好，染色后色泽鲜艳、日晒不掉色', en: 'Good Adsorption, Vibrant Color After Dyeing, Sunlight Fade-Resistant', ja: '良好な吸着性、染色後鮮やかな発色、日光耐性' , Russian: 'Хорошая адсорбция, яркие цвета после окрашивания, не выцветают на солнце', Malay: 'Penjerapan Baik, Warna Cerah Selepas Pencelupan & Tidak Pudar di Bawah Matahari',
            Turkish: 'İyi adsorpsiyon, boyama sonrası canlı renkler, güneşte solmaz'},
        img: '/images/Fibre/FangSiJiErCuSuanXianWeiSuSuoLve.png',
        gallery: ['/images/Fibre/FangSiJiErCuSuanXianWeiSuSuoLve.png'],
        features: { zh: ['吸附性好','长丝织品手感好' ,'染色后色泽鲜艳', '日晒不掉色'], en: ['Good Adsorption', 'Pleasant Feel for Filament Textiles', 'Vibrant Color After Dyeing', 'Sunlight Fade-Resistant'], ja: ['良好な吸着性','長繊維織物の手触り良好','染色後鮮やかな発色','日光耐性'], Russian: ['Хорошая адсорбция','Приятное на ощупь filament полотно','Яркие цвета после окрашивания','Не выцветают на солнце'], Malay: ['Penjerapan Baik','Barang Tenunan Filamen Berasa Selesa','Warna Cerah Selepas Pencelupan','Tidak Pudar di Bawah Matahari']
            , Turkish: ['İyi Adsorpsiyon','İplik Ürünlerde İyi Hissedilen Doku','Boyama Sonrası Canlı Renkler','Güneşte Solmaz']
        },
        certifications: [],
        specifications: [],
        usageExamples: [
            {
                title: {
                    zh: '香烟过滤嘴',
                    en: 'Cigarette Filters',
                    ja: 'たばこフィルター',
                    Russian: 'Фильтры для сигарет',
                    Malay: 'Penapis Rokok',
                    Turkish: 'Sigara Filtresi'
                },
                desc: {
                    zh: '适合香烟过滤嘴等产品加工',
                    en: 'Suitable for cigarette filters, etc.',
                    ja: 'たばこフィルター等製品加工に最適',
                    Russian: 'Подходит для производства сигаретных фильтров и т.д.',
                    Malay: 'Sesuai untuk pemprosesan produk seperti penapis rokok, dll.',
                    Turkish: 'Sigara filtreleri gibi ürünlerin işlenmesi için uygundur.'
                },
                img: '/images/ApplicationScenarios/GuoLuZui.png'
            },
            {
                title: {
                    zh: '高档服装',
                    en: 'Premium Apparel',
                    ja: '高級衣料',
                    Russian: 'Премиальная одежда',
                    Malay: 'Pakaian Premium',
                    Turkish: 'Yüksek Kalite Giyim'
                },
                desc: {
                    zh: '与天然纤维、合成纤维混纺用于高档服装加工',
                    en: 'Blended with natural/synthetic fibers for premium apparel processing',
                    ja: '天然繊維・合成繊維と混紡し高級衣料加工に使用',
                    Russian: 'Смешивается с натуральными и синтетическими волокнами для производства премиальной одежды',
                    Malay: 'Ditenun dengan gentian semula jadi & sintetik untuk pemprosesan pakaian premium.',
                    Turkish: 'Doğal ve sentetik liflerle karıştırılarak yüksek kaliteli giysi üretiminde kullanılır.'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiGaoDangFuZhuang.png'
            }
        ],
        relatedProducts: ['fiber-001', 'fiber-003', 'cultural-003']
    },
    {
        id: 'fiber-003',
        title: { zh: '三醋酸纤维素', en: 'Cellulose Triacetate (CTA)', ja: '三酢酸セルロース', Russian: 'Триацетат целлюлозы', Malay: 'Selulosa Triasetat' ,
            Turkish: 'Selüloz Triasetat'},
        category: 'fiber',
        desc: { zh: '高耐磨性、高阻燃性、低雾度值和高透光率', en: 'High Wear Resistance, High Flame Retardancy, Low Haze, High Light Transmittance', ja: '高耐摩耗性、高難燃性、低ヘイズ値、高光透過率', Russian: 'Высокая износостойкость, огнестойкость, низкая мутность и высокая светопропускаемость', Malay: 'Ketahanan Haus Tinggi, Keresapan Api Tinggi, Nilai Haze Rendah & Keterdapatan Cahaya Tinggi' ,
            Turkish: 'Yüksek aşınma direnci, yüksek alev geciktirici, düşük pus değeri ve yüksek ışık geçirgenliği'},
        img: '/images/Fibre/SanCuSuanXianWeiSuSuoLve.png',
        gallery: ['/images/Fibre/SanCuSuanXianWeiSuSuoLve.png'],
        features: { zh: ['高耐磨性', '高阻燃性', '低雾度值', '高透光率'], en: ['High Wear Resistance', 'High Flame Retardancy', 'Low Haze', 'High Light Transmittance'], ja: ['高耐摩耗性','高難燃性','低ヘイズ値','高光透過率'], Russian: ['Высокая износостойкость','Высокая огнестойкость','Низкая мутность','Высокая светопропускаемость'], Malay: ['Ketahanan Haus Tinggi','Keresapan Api Tinggi','Nilai Haze Rendah','Keterdapatan Cahaya Tinggi']
            , Turkish: ['Yüksek Aşınma Direnci','Yüksek Alev Geciktirici','Düşük Pus Değeri','Yüksek Işık Geçirgenliği']
        },
        certifications: [],
        specifications: [],
        usageExamples: [
            {
                title: {
                    zh: '感光元件',
                    en: 'Photosensitive Components',
                    ja: '感光部品',
                    Russian: 'Светочувствительные элементы',
                    Malay: 'Komponen Fotosensitif',
                    Turkish: 'Fotoğrafik Elemanlar'
                },
                desc: {
                    zh: '适用于感光胶片、显示器光学元件（如：液晶显示器偏振片（PVA膜）的保护膜）',
                    en: 'Suitable for photographic film, display optical components (e.g., protective film for LCD polarizers (PVA film)).',
                    ja: '感光フィルム、ディスプレイ光学部品（例：液晶ディスプレイ偏光板（PVA膜）保護フィルム）に適用',
                    Russian: 'Подходит для светочувствительной плёнки, оптических элементов дисплеев (например, защитная плёнка для поляризаторов ЖК-дисплеев (PVA-плёнка))',
                    Malay: 'Sesuai untuk filem fotosensitif, komponen optik paparan (cth: filem pelindung lapisan polarisasi LCD (filem PVA))',
                    Turkish: 'Fotoğraf filmleri, ekran optik elemanları (örneğin: LCD ekran polarize film (PVA film) koruyucu filmi) için uygundur.'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiGanGuangJiaoPian.png'
            },
            {
                title: {
                    zh: '眼镜片',
                    en: 'Eyeglass Lenses',
                    ja: 'メガネレンズ',
                    Russian: 'Линзы для очков',
                    Malay: 'Kanta Cermin Mata',
                    Turkish: 'Gözlük Camı'
                },
                desc: {
                    zh: '适用于眼镜片等产品加工',
                    en: 'Suitable for eyeglass lenses, etc.',
                    ja: 'メガネレンズ等製品加工に適用',
                    Russian: 'Подходит для производства линз для очков и т.д.',
                    Malay: 'Sesuai untuk pemprosesan produk seperti kanta cermin mata, dll.',
                    Turkish: 'Gözlük camları gibi ürünlerin işlenmesi için uygundur.'
                },
                img: '/images/ApplicationScenarios/YanJingPian.png'
            }
        ],
        relatedProducts: ['fiber-001', 'fiber-002', 'cultural-003']
    },
];

export const advantages: Advantage[] = [
    { 
        icon: 'fas fa-shield-alt', 
        title: {
            zh: '健康安全',
            en: 'Health & Safety',
            ja: '健康的で安全',
            Russian: 'Здоровье и безопасность',
            Malay: 'Kesihatan & Keselamatan',
            Turkish: 'Sağlık ve Güvenlik'
        },
        desc: {
            zh: '竹浆纸天然抗菌，不添加荧光剂，对人体更加友好，特别适合婴幼儿和敏感肌肤使用。',
            en: 'Bamboo paper is naturally antibacterial and free of fluorescent agents, making it skin-friendly and ideal for infants and sensitive skin.',
            ja: '竹パルプ紙は天然抗菌、蛍光剤無添加、人体に優しく、特に乳幼児や敏感肌に適しています。',
            Russian: 'Бумага из бамбуковой целлюлозы обладает естественными антибактериальными свойствами, не содержит флуоресцентных агентов, более безопасна для человека, особенно подходит для младенцев и людей с чувствительной кожей.',
            Malay: 'Kertas buluh semula jadi antibakteria, tiada agen pendarfluor, lebih mesra pada manusia, sangat sesuai untuk bayi dan kulit sensitif.',
            Turkish: 'Bambu hamuru kağıdı doğal antibakteriyeldir, floresan ağartıcı eklenmez, insan vücuduna daha dosttur, özellikle bebekler ve hassas ciltler için uygundur.'
        }
    },
    { 
        icon: 'fas fa-leaf', 
        title: {
            zh: '环保可持续',
            en: 'Eco-Friendly & Sustainable',
            ja: '環境配慮型・持続可能',
            Russian: 'Экологичность и устойчивость',
            Malay: 'Mesra Alam & Mampan',
            Turkish: 'Çevre Dostu ve Sürdürülebilir'
        },
        desc: {
            zh: '竹子生长周期短，3-5年可成熟，是可再生资源理想选择，生产过程减少对森林砍伐。',
            en: 'Bamboo has a short growth cycle (3-5 years), making it an ideal renewable resource; its production reduces reliance on deforestation.',
            ja: '竹は成長サイクルが短く、3～5年で成熟し、再生可能資源として理想的。生産過程で森林伐採を削減します。',
            Russian: 'Бамбук имеет короткий цикл роста, созревает за 3-5 лет, является идеальным возобновляемым ресурсом, процесс производства сокращает вырубку лесов.',
            Malay: 'Buluh matang dalam 3-5 tahun, pilihan sumber boleh diperbaharui yang ideal, mengurangkan penebangan hutan dalam pengeluaran.',
            Turkish: 'Bambu kısa büyüme döngüsüne sahiptir, 3-5 yılda olgunlaşır, yenilenebilir kaynak için ideal seçimdir, üretim süreci orman kesimini azaltır.'
        }
    },
    { 
        icon: 'fas fa-tint', 
        title: {
            zh: '吸水性强',
            en: 'High Absorbency',
            ja: '強力吸水',
            Russian: 'Высокая впитывающая способность',
            Malay: 'Keupayaan Penyerapan Air Yang Kuat',
            Turkish: 'Güçlü Su Emme'
        },
        desc: {
            zh: '竹纤维多孔结构使得竹浆纸具有优异的吸水性能，吸水速度快，吸水量大。',
            en: 'The porous structure of bamboo fiber gives bamboo paper excellent absorbency, with fast absorption speed and high capacity.',
            ja: '竹繊維の多孔質構造により、竹パルプ紙は優れた吸水性能を持ち、吸水速度が速く、吸水量も多いです。',
            Russian: 'Пористая структура бамбуковых волокон придаёт бумаге из бамбуковой целлюлозы превосходные впитывающие свойства, быстро впитывает и удерживает большое количество жидкости.',
            Malay: 'Struktur berliang gentian buluh memberikan prestasi penyerapan air yang unggul pada kertas buluh, pantas & banyak menyerap.',
            Turkish: 'Bambu liflerinin gözenekli yapısı, bambu hamuru kağıdına mükemmel su emme özelliği kazandırır, hızlı emer ve yüksek su tutma kapasitesine sahiptir.'
        }
    },
    { 
        icon: 'fas fa-hand-paper', 
        title: {
            zh: '柔韧不易破',
            en: 'Soft & Tear-Resistant',
            ja: '柔軟で破れにくい',
            Russian: 'Гибкая и прочная',
            Malay: 'Lentur & Sukar Koyak',
            Turkish: 'Esnek ve Kolay Yırtılmaz'
        },
        desc: {
            zh: '竹纤维长度适中，纤维间结合紧密，制成的纸张韧性好，湿水不易破裂。',
            en: 'Moderate bamboo fiber length and tight bonding create strong, tear-resistant paper, even when wet.',
            ja: '竹繊維は適度な長さで、繊維間の結合が緊密なため、作られた紙は強靭で、濡れても破れにくいです。',
            Russian: 'Бамбуковые волокна средней длины, тесно связаны между собой, что придаёт бумаге хорошую гибкость и устойчивость к разрыву во влажном состоянии.',
            Malay: 'Gentian buluh panjang sederhana, ikatan gentian rapat, menghasilkan kertas kenyal yang sukar koyak ketika basah.',
            Turkish: 'Bambu lifleri orta uzunluktadır, lifler arasında sıkı bağ vardır, üretilen kağıt esnektir, ıslakken kolay yırtılmaz.'
        }
    },
    { 
        icon: 'fas fa-sun', 
        title: {
            zh: '本色自然',
            en: 'Natural Color',
            ja: '自然色',
            Russian: 'Естественный натуральный цвет',
            Malay: 'Warna Semula Jadi',
            Turkish: 'Doğal Renk'
        },
        desc: {
            zh: '采用本色工艺，保留竹子原有的颜色，减少漂白过程，更加环保健康。',
            en: "The natural color process retains bamboo's original hue, reducing bleaching for greater eco-friendliness and health benefits.",
            ja: '未晒製法を採用し、竹本来の色を保持。漂白工程を削減し、より環境に優しく健康的です。',
            Russian: 'Использование технологии натурального цвета сохраняет исходный цвет бамбука, сокращает процесс отбеливания, что более экологично и полезно для здоровья.',
            Malay: 'Proses warna semula jadi mengekalkan warna asal buluh, mengurangkan pelunturan, lebih mesra alam & sihat.',
            Turkish: 'Doğal renk işlemi kullanılır, bambunun orijinal rengi korunur, ağartma süreci azaltılır, daha çevre dostu ve sağlıklıdır.'
        }
    },
    { 
        icon: 'fas fa-recycle', 
        title: {
            zh: '可降解',
            en: 'Biodegradable',
            ja: '生分解性',
            Russian: 'Биоразлагаемая',
            Malay: 'Boleh Terurai',
            Turkish: 'Biyobozunur'
        },
        desc: {
            zh: '纯天然植物纤维，使用后可自然降解，不会产生环境污染，符合现代环保理念。',
            en: 'Made from pure natural plant fiber, it biodegrades naturally after use, avoiding pollution and aligning with modern eco-principles.',
            ja: '純天然植物繊維で、使用後は自然分解され、環境汚染を引き起こさず、現代の環境保護理念に適合します。',
            Russian: 'Чистые натуральные растительные волокна, после использования естественно разлагаются, не загрязняя окружающую среду, соответствуя современным экологическим принципам.',
            Malay: 'Gentian tumbuhan tulen, terurai secara semula jadi selepas digunakan, tiada pencemaran, mematuhi konsep mesra alam moden.',
            Turkish: 'Tamamen doğal bitki lifi, kullanımdan sonra doğal olarak bozunur, çevre kirliliği yaratmaz, modern çevrecilik anlayışına uygundur.'
        }
    },
];

export const applications: Application[] = [
    { 
        img: '/images/JiaTingShengHuoSuoLve.png', 
        title: {
            zh: '家庭生活',
            en: 'Household Living',
            ja: '家庭生活用',
            Russian: 'Домашний быт',
            Malay: 'Kehidupan Keluarga',
            Turkish: 'Aile Yaşamı'
        },
        desc: {
            zh: '纸巾、卫生纸、厨房用纸等日常生活必需品，满足家庭清洁和个人卫生需求。',
            en: 'Essential daily necessities like tissues, toilet paper, and kitchen towels meet household cleaning and personal hygiene needs.',
            ja: 'ティッシュ、トイレットペーパー、キッチンペーパー等の日常生活必需品で、家庭の清掃や個人衛生のニーズに応えます。',
            Russian: 'Салфетки, туалетная бумага, кухонные полотенца и другие предметы первой необходимости для домашнего обихода, удовлетворяющие потребности в уборке и личной гигиене.',
            Malay: 'Keperluan harian seperti tisu, tisu tandas, tisu dapur, memenuhi keperluan kebersihan keluarga & peribadi.',
            Turkish: 'Mendil, tuvalet kağıdı, mutfak kağıdı gibi günlük yaşam ihtiyaçları, aile temizliği ve kişisel hijyen ihtiyaçlarını karşılar.'
        }
    },
    { 
        img: '/images/BanGongJiaoYuSuoLve.png', 
        title: {
            zh: '办公文教',
            en: 'Office & Education',
            ja: 'オフィス・教育用',
            Russian: 'Офис и образование',
            Malay: 'Pejabat & Pendidikan',
            Turkish: 'Ofis ve Eğitim'
        },
        desc: {
            zh: '复印纸、笔记本、书写纸等办公和学习用品，提供优质的书写和打印体验。',
            en: 'Office and study supplies like copy paper, notebooks, and writing paper offer high-quality writing and printing experiences.',
            ja: 'コピー用紙、ノート、筆記用紙等のオフィス・学習用品で、質の高い筆記・印刷体験を提供します。',
            Russian: 'Копировальная бумага, тетради, писчая бумага и другие канцелярские товары, обеспечивающие качественное письмо и печать.',
            Malay: 'Barangan pejabat & pembelajaran seperti kertas fotokopi, buku nota, kertas tulis, memberikan pengalaman menulis & mencetak berkualiti.',
            Turkish: 'Fotokopi kağıdı, defter, yazı kağıdı gibi ofis ve eğitim malzemeleri, yüksek kaliteli yazma ve baskı deneyimi sunar.'
        }
    },
    { 
        img: '/images/ShiPinBaoZhuangLingYuSuoLve.png', 
        title: {
            zh: '食品包装',
            en: 'Food Packaging',
            ja: '食品包装用',
            Russian: 'Упаковка для пищевых продуктов',
            Malay: 'Pembungkusan Makanan',
            Turkish: 'Gıda Ambalajı'
        },
        desc: {
            zh: '食品级包装纸、防油纸、餐巾纸等，确保食品安全和包装环保。',
            en: 'Food-grade packaging paper, greaseproof paper, napkins, etc., ensure food safety and eco-friendly packaging.',
            ja: '食品グレード包装紙、耐油紙、ナプキン等で、食品安全と環境配慮型包装を確保します。',
            Russian: 'Пищевая упаковочная бумага, жиронепроницаемая бумага, салфетки и т.д., обеспечивающие безопасность продуктов и экологичность упаковки.',
            Malay: 'Kertas pembungkusan gred makanan, kertas tahan minyak, serbet, memastikan keselamatan makanan & pembungkusan mesra alam.',
            Turkish: 'Gıda sınıfı ambalaj kağıdı, yağ geçirmez kağıt, peçete gibi ürünler, gıda güvenliğini ve çevre dostu ambalajı sağlar.'
        }
    },
    { 
        img: '/images/YiLiaoWeiShengLingYuSuoLve.png', 
        title: {
            zh: '医疗卫生',
            en: 'Medical & Health',
            ja: '医療衛生用',
            Russian: 'Медицина и здравоохранение',
            Malay: 'Perubatan & Kesihatan',
            Turkish: 'Tıbbi ve Hijyenik'
        },
        desc: {
            zh: '医用擦拭纸、医疗包装纸等，满足医疗环境对清洁和卫生的严格要求。',
            en: 'Medical wipes, medical packaging paper, etc., meet strict hygiene and cleanliness standards in healthcare settings.',
            ja: '医療用ワイプ、医療用包装紙等で、医療環境の清潔・衛生に対する厳格な要求に応えます。',
            Russian: 'Медицинские салфетки, упаковочная бумага для медикаментов и т.д., удовлетворяющие строгим требованиям к чистоте и гигиене в медицинской среде.',
            Malay: 'Tisu perubatan, kertas pembungkusan perubatan, memenuhi keperluan kebersihan & sanitasi ketat dalam persekitaran perubatan.',
            Turkish: 'Tıbbi silme kağıdı, tıbbi ambalaj kağıdı gibi ürünler, tıbbi ortamların temizlik ve hijyen için katı gereksinimlerini karşılar.'
        }
    },
    { 
        img: '/images/ShangWuDingZhiLingYuSuoLve.png', 
        title: {
            zh: '商务定制',
            en: 'Business Customization',
            ja: 'ビジネス・カスタマイズ用',
            Russian: 'Бизнес-индивидуализация',
            Malay: 'Tersuai Perniagaan',
            Turkish: 'İş Özelleştirme'
        },
        desc: {
            zh: '航空、高铁、商超等品牌产品定制加工和商务接待定制。',
            en: 'Custom processing for brands (airlines, high-speed rail, supermarkets) and custom solutions for business reception.',
            ja: '航空、高速鉄道、スーパー等のブランド製品カスタマイズ加工及びビジネス接客用カスタマイズ。',
            Russian: 'Индивидуальное производство брендовой продукции для авиакомпаний, высокоскоростных поездов, супермаркетов и индивидуальные решения для деловых приёмов.',
            Malay: 'Pemprosesan tersuai produk jenama penerbangan, HSR, pasar raya, dan sambutan perniagaan tersuai.',
            Turkish: 'Havayolu, yüksek hızlı tren, süpermarket gibi marka ürünler için özel işleme ve iş resepsiyonları için özelleştirme.'
        }
    },
    { 
        img: '/images/GongYeZhiZaoLingYuSuoLve.png', 
        title: {
            zh: '工业制造',
            en: 'Industrial Manufacturing',
            ja: '工業製造用',
            Russian: 'Промышленное производство',
            Malay: 'Pembuatan Industri',
            Turkish: 'Endüstriyel Üretim'
        },
        desc: {
            zh: '高档眼镜、天然纤维、感光材料、绝缘热压板等工业产品制造加工。',
            en: 'Manufacturing and processing of industrial products like premium eyewear, natural fibers, photosensitive materials, and insulating hot press plates.',
            ja: '高級メガネ、天然繊維、感光材料、絶縁熱圧板等の工業製品製造加工',
            Russian: 'Производство премиальных очков, натуральных волокон, светочувствительных материалов, термопрессованных изоляционных плит и других промышленных изделий.',
            Malay: 'Pemprosesan produk industri seperti cermin mata premium, gentian semula jadi, bahan fotosensitif, papan tekanan haba penebat, dll.',
            Turkish: 'Yüksek kaliteli gözlükler, doğal lifler, fotoğrafik malzemeler, yalıtım sıcak presleme levhaları gibi endüstriyel ürünlerin üretimi ve işlenmesi.'
        }
    },
]; 